//----------------------
// <auto-generated>
//     Split from WebApiController.ts
//     Regenerate with: node scripts/splitWebApiController.js
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming


export interface ActivityLog {
    activityLogId: number;
    entityId: number;
    entityType: ActionOutboxEntityType;
    actionDate: string;
    initiatedBy: ActivityLogInitiatedByUser;
    initiatedByImpersonated: ActivityLogInitiatedByUser | null;
    actionType: ActionType;
    auditActionType: AuditActionType | null;
    actionTypeDisplay: string;
    additionalInfo: ActivityLogAdditionalInformationDictionaryOfActivityLogValueChange;
    event: Event | null;
    performer: Performer | null;
    venue: Venue | null;
    tagName: string | null;
}

export enum ActionOutboxEntityType {
    Sale = "Sale",
    Listing = "Listing",
    Purchase = "Purchase",
    SellerSupportCase = "SellerSupportCase",
    Document = "Document",
    SellerEvent = "SellerEvent",
    InboundEmail = "InboundEmail",
    TicketGroup = "TicketGroup",
}

export interface ActivityLogInitiatedByUser {
    userId: string;
    username: string | null;
}

export enum ActionType {
    SaleConfirm = "SaleConfirm",
    SaleReject = "SaleReject",
    SaleUploadBarcodes = "SaleUploadBarcodes",
    SaleUploadTicketUrls = "SaleUploadTicketUrls",
    SaleUploadProofOfTransfer = "SaleUploadProofOfTransfer",
    SaleUploadEtickets = "SaleUploadEtickets",
    SaleMarketplaceInsert = "SaleMarketplaceInsert",
    SaleMarketplaceUpdate = "SaleMarketplaceUpdate",
    SaleBroadcastConfirmSale = "SaleBroadcastConfirmSale",
    SaleBroadcastRejectSale = "SaleBroadcastRejectSale",
    SaleBroadcastUploadBarcodes = "SaleBroadcastUploadBarcodes",
    SaleBroadcastUploadETickets = "SaleBroadcastUploadETickets",
    SaleBroadcastUploadTransferProof = "SaleBroadcastUploadTransferProof",
    SaleBroadcastUploadTransferUrls = "SaleBroadcastUploadTransferUrls",
    SaleViewed = "SaleViewed",
    SaleDeallocate = "SaleDeallocate",
    SaleMarketplaceUpdateTicketType = "SaleMarketplaceUpdateTicketType",
    SaleHoldTickets = "SaleHoldTickets",
    SaleHoldExpire = "SaleHoldExpire",
    SaleHoldCreate = "SaleHoldCreate",
    SaleUploadTransferProofId = "SaleUploadTransferProofId",
    SaleBroadcastUploadTransferProofId = "SaleBroadcastUploadTransferProofId",
    SaleUpdateTicketType = "SaleUpdateTicketType",
    SaleTicketMasterBarcodeTransfer = "SaleTicketMasterBarcodeTransfer",
    SaleCostUpdate = "SaleCostUpdate",
    SaleCostInsert = "SaleCostInsert",
    SaleCostDelete = "SaleCostDelete",
    SaleBroadcastUpdateTicketType = "SaleBroadcastUpdateTicketType",
    SaleConfirmTransferWithoutProof = "SaleConfirmTransferWithoutProof",
    SaleResetFulfillment = "SaleResetFulfillment",
    SaleTotalProceedsUpdate = "SaleTotalProceedsUpdate",
    SaleDocumentUploadActivity = "SaleDocumentUploadActivity",
    SaleFulfillWithoutArtifacts = "SaleFulfillWithoutArtifacts",
    SaleNoFulfillUpdate = "SaleNoFulfillUpdate",
    SaleTicketsAllocatedAction = "SaleTicketsAllocatedAction",
    SaleCommissionsUpdate = "SaleCommissionsUpdate",
    SaleRemoveTicketUserDocuments = "SaleRemoveTicketUserDocuments",
    SaleUpdatePaymentState = "SaleUpdatePaymentState",
    ListingInsert = "ListingInsert",
    ListingUpdateUnitNetProceeds = "ListingUpdateUnitNetProceeds",
    ListingUpdateAllInPrice = "ListingUpdateAllInPrice",
    ListingUpdateDeliveryType = "ListingUpdateDeliveryType",
    ListingUpdateSplitType = "ListingUpdateSplitType",
    ListingUpdateInHandDate = "ListingUpdateInHandDate",
    ListingUpdateHideSeats = "ListingUpdateHideSeats",
    ListingSplit = "ListingSplit",
    ListingMerge = "ListingMerge",
    ListingBroadcast = "ListingBroadcast",
    ListingUnbroadcast = "ListingUnbroadcast",
    ListingMarketplaceInsert = "ListingMarketplaceInsert",
    ListingMarketplaceUpdate = "ListingMarketplaceUpdate",
    ListingMarketplaceDelete = "ListingMarketplaceDelete",
    ListingUpdatePricerUserId = "ListingUpdatePricerUserId",
    BroadcastMarketplaceListing = "BroadcastMarketplaceListing",
    UnbroadcastMarketplaceListing = "UnbroadcastMarketplaceListing",
    ListingBroadcastMergeListing = "ListingBroadcastMergeListing",
    ListingBroadcastSplitListing = "ListingBroadcastSplitListing",
    ListingBroadcastUpdateInHandDate = "ListingBroadcastUpdateInHandDate",
    ListingBroadcastUpdateAllInPrice = "ListingBroadcastUpdateAllInPrice",
    ListingBroadcastUpdateUnitNetProceeds = "ListingBroadcastUpdateUnitNetProceeds",
    ListingBroadcastUpdateSplitType = "ListingBroadcastUpdateSplitType",
    ListingBroadcastUpdateDeliveryType = "ListingBroadcastUpdateDeliveryType",
    ListingViewed = "ListingViewed",
    ListingDelete = "ListingDelete",
    ListingUpdateQuantity = "ListingUpdateQuantity",
    ListingBroadcastUpdateQuantity = "ListingBroadcastUpdateQuantity",
    ListingUpdateListingNotes = "ListingUpdateListingNotes",
    ListingBroadcastUpdateListingNotes = "ListingBroadcastUpdateListingNotes",
    ListingUpdateSeating = "ListingUpdateSeating",
    ListingBroadcastUpdateSeating = "ListingBroadcastUpdateSeating",
    ListingPreDeliverBarcodes = "ListingPreDeliverBarcodes",
    ListingPreDeliverETickets = "ListingPreDeliverETickets",
    ListingRebroadcast = "ListingRebroadcast",
    ListingSyncUpdate = "ListingSyncUpdate",
    ListingUpdateNetProceedsFloor = "ListingUpdateNetProceedsFloor",
    ListingAutoPricingConfig = "ListingAutoPricingConfig",
    ListingAutoPricingResultUpdate = "ListingAutoPricingResultUpdate",
    ListingPreDeliverTicketExternalIds = "ListingPreDeliverTicketExternalIds",
    ListingPreDeliverTicketUrls = "ListingPreDeliverTicketUrls",
    ListingMarketplaceSeatingOverrideUpdate = "ListingMarketplaceSeatingOverrideUpdate",
    ListingRemoveTicketBarcodes = "ListingRemoveTicketBarcodes",
    ListingRemoveTicketUserDocuments = "ListingRemoveTicketUserDocuments",
    ListingUploadVerificationDocumentAction = "ListingUploadVerificationDocumentAction",
    ListingCompsViewed = "ListingCompsViewed",
    ListingOfflineSaleAdded = "ListingOfflineSaleAdded",
    ListingDocumentViewed = "ListingDocumentViewed",
    ListingDocumentDownloaded = "ListingDocumentDownloaded",
    ListingBroadcastUploadVerificationDocument = "ListingBroadcastUploadVerificationDocument",
    ListingBroadcastUpdateHideSeats = "ListingBroadcastUpdateHideSeats",
    ListingDocumentUploadActivity = "ListingDocumentUploadActivity",
    ListingUpdateUnitCost = "ListingUpdateUnitCost",
    ListingUpdateInternalNotes = "ListingUpdateInternalNotes",
    ListingNoFulfillUpdate = "ListingNoFulfillUpdate",
    ListingUpdateAdminHold = "ListingUpdateAdminHold",
    ListingListingGroupUpdate = "ListingListingGroupUpdate",
    ListingSaleConfirm = "ListingSaleConfirm",
    ListingSaleDeallocate = "ListingSaleDeallocate",
    ListingSaleMarketplaceInsert = "ListingSaleMarketplaceInsert",
    ListingUpdateTopTicketType = "ListingUpdateTopTicketType",
    ListingUpdateDuplicateAttribute = "ListingUpdateDuplicateAttribute",
    ListingUpdateEventId = "ListingUpdateEventId",
    SellerSupportCaseCreate = "SellerSupportCaseCreate",
    SellerSupportCaseReply = "SellerSupportCaseReply",
    PurchaseInsert = "PurchaseInsert",
    PurchaseTicketGroupsMerge = "PurchaseTicketGroupsMerge",
    PurchasePaymentsMerge = "PurchasePaymentsMerge",
    PurchaseCostsMerge = "PurchaseCostsMerge",
    PurchaseUpdate = "PurchaseUpdate",
    PurchaseTicketGroupUpdate = "PurchaseTicketGroupUpdate",
    PurchaseTicketGroupInsert = "PurchaseTicketGroupInsert",
    PurchaseTicketGroupDelete = "PurchaseTicketGroupDelete",
    PurchasePaymentUpdate = "PurchasePaymentUpdate",
    PurchasePaymentInsert = "PurchasePaymentInsert",
    PurchasePaymentDelete = "PurchasePaymentDelete",
    PurchaseCostUpdate = "PurchaseCostUpdate",
    PurchaseCostInsert = "PurchaseCostInsert",
    PurchaseCostDelete = "PurchaseCostDelete",
    PurchaseCancel = "PurchaseCancel",
    PurchaseVoid = "PurchaseVoid",
    PurchaseResetListings = "PurchaseResetListings",
    PurchaseOrderQualityStateUpdate = "PurchaseOrderQualityStateUpdate",
    SaleDocumentUpload = "SaleDocumentUpload",
    ListingDocumentUpload = "ListingDocumentUpload",
    InboundEmailReprocess = "InboundEmailReprocess",
}

export enum AuditActionType {
    TagCreate = "TagCreate",
    TagUpdate = "TagUpdate",
    TagDelete = "TagDelete",
    TagTypeCreate = "TagTypeCreate",
    TagTypeUpdate = "TagTypeUpdate",
    SaleInternalNotesUpdate = "SaleInternalNotesUpdate",
    SaleInternalNotesInsert = "SaleInternalNotesInsert",
    ListingSellerEventUpdate = "ListingSellerEventUpdate",
    PurchaseCommissionUpdate = "PurchaseCommissionUpdate",
    PurchaseCommissionInsert = "PurchaseCommissionInsert",
    PurchaseInternalNotesUpdate = "PurchaseInternalNotesUpdate",
    PurchaseInternalNotesInsert = "PurchaseInternalNotesInsert",
}

export interface ActivityLogAdditionalInformationDictionaryOfActivityLogValueChange {

    [key: string]: ActivityLogValueChange | any;
}

export interface ActivityLogValueChange {
    oldValue: string | null;
    newValue: string | null;
    message: ActivityLogMessage | null;
}

export interface ActivityLogMessage {
    errorCode: string | null;
    message: string | null;
    state: MarketplaceOperationResultState;
}

export enum MarketplaceOperationResultState {
    Succeeded = "Succeeded",
    FailedWithRetryableError = "FailedWithRetryableError",
    FailedWithNonRetryableError = "FailedWithNonRetryableError",
    FailedAndRequiresSellerAction = "FailedAndRequiresSellerAction",
    NotImplemented = "NotImplemented",
    Skipped = "Skipped",
}

export interface CatalogEntity {
    /** ViagogoEntityId */
    viagId: number | null;
    name: string;
    shortName: string | null;
}

export interface Event extends CatalogEntity {
    rowVer: number | null;
    /** PosEventIdS */
    posIds: string[];
    posId: string | null;
    /** ViagogoVirtualId (ViagogoEventId or ViagogoEventMappingId) */
    virtId: string;
    oldVirtIds: string[] | null;
    /** ViagogoEventMappingId */
    mpId: string | null;
    dates: DateTimeRange;
    datesUtc: DateTimeRange;
    onSaleDate: string | null;
    rawOnSaleDate: string | null;
    rawPreSaleDate: string | null;
    evType: string | null;
    evStat: ApiEventStatus | null;
    /** Performer Id */
    perfId: number | null;
    venId: number;
    venCfgId: number | null;
    genre: TopLevelCategory;
    /** Mapping Rejection Reason Id */
    mapRejRsnId: number | null;
    /** Mapping Rejection Reason Default Text */
    mapRejDftTxt: string | null;
}

export interface DateTimeRange {
    start: string | null;
    end: string | null;
}

export enum ApiEventStatus {
    Normal = "Normal",
    Postponed = "Postponed",
    Cancelled = "Cancelled",
    Rescheduled = "Rescheduled",
    Relocated = "Relocated",
    RelocatedAndRescheduled = "RelocatedAndRescheduled",
    Draft = "Draft",
    Deleted = "Deleted",
    Contingent = "Contingent",
}

export enum TopLevelCategory {
    Theatre = "Theatre",
    Sports = "Sports",
    Concert = "Concert",
    Festival = "Festival",
}

export interface Performer extends CatalogEntity {
    /** Categories */
    categ: TopLevelCategory[];
    /** Genre Id */
    genreId: number | null;
    /** Genre name */
    grName: string | null;
}

export interface Venue extends CatalogEntity {
    city: string | null;
    /** State/Province */
    state: string | null;
    ctryCode: string | null;
    cap: number | null;
    /** Do not include this object as first-class search-result items
Since this obj is embedded in another object as an info-only obj */
    excludeSearch: boolean;
}

export interface ActivityLogQuery {
    userId: string | null;
    includeUserOnly: boolean | null;
    impersonatedUserId: string | null;
    entityId: number | null;
    entityType: ActionOutboxEntityType | null;
    actionTypes: ActionType[] | null;
    auditActionTypes: AuditActionType[] | null;
    take: number | null;
    skip: number | null;
    /** Filter by tag name within audit data */
    tagName: string | null;
}

export enum DocumentType {
    ETicket = "ETicket",
    TicketTransfer = "TicketTransfer",
    AirBill = "AirBill",
    PKPass = "PKPass",
    GoogleWallet = "GoogleWallet",
    ListingVerification = "ListingVerification",
    QRCode = "QRCode",
}

export interface StateProvince {
    id: number;
    name: string;
    countryName: string;
    cId: number | null;
}

export interface City {
    id: number;
    name: string;
    stateProvinceName: string | null;
    countryName: string;
    cId: number | null;
}

export interface ReactAppContext {
    stage: string;
    appName: string;
    isNativeApp: boolean;
    cobrandId: CoBrandId;
    environment: string;
    features: FeatureDetail[];
    isDevelopment: boolean;
    version: string;
}

export enum CoBrandId {
    Viagogo = "Viagogo",
    TicketUtil = "TicketUtil",
    Starburst = "Starburst",
    ReachPro = "ReachPro",
    StubHub = "StubHub",
}

export interface FeatureDetail {
    id: Feature;
    state: FeatureState;
}

export enum Feature {
    AutoPricing = "AutoPricing",
    HomePageActivityLog = "HomePageActivityLog",
    OneTicketTransferApi = "OneTicketTransferApi",
    AdvanceAutopricingModes = "AdvanceAutopricingModes",
    CompListingMode_ParentListing = "CompListingMode_ParentListing",
    ExportInventory = "ExportInventory",
    ListingIdForCompListings = "ListingIdForCompListings",
    InventoryEventRecentTransactions = "InventoryEventRecentTransactions",
    ScaledSeatScore = "ScaledSeatScore",
    SeatSaver = "SeatSaver",
    ConfirmTransferWithoutProof = "ConfirmTransferWithoutProof",
    TeamManagement = "TeamManagement",
    BezierGraphControlPointsManager = "BezierGraphControlPointsManager",
    UndercutByRankListingGroup = "UndercutByRankListingGroup",
    UpdatedVenueMapPrompt = "UpdatedVenueMapPrompt",
    ReportSnapshot = "ReportSnapshot",
    DisplayBuildVersion = "DisplayBuildVersion",
    OverrideDailyFxRate = "OverrideDailyFxRate",
    PricedAtZeroFilter = "PricedAtZeroFilter",
    PricingCatchup = "PricingCatchup",
    PriceByWebsitePrice = "PriceByWebsitePrice",
    ExcludeFanInventory = "ExcludeFanInventory",
    CurrencyConversionSettingsTab = "CurrencyConversionSettingsTab",
    AutoPriceFrequency = "AutoPriceFrequency",
    DisableAutoSourcing = "DisableAutoSourcing",
    ArAgingReport = "ArAgingReport",
    MarketplacePaymentLinesDisplay = "MarketplacePaymentLinesDisplay",
    InventoryEventPageV2 = "InventoryEventPageV2",
    DynamicPricingBySTR = "DynamicPricingBySTR",
    GroupingDrip = "GroupingDrip",
    AutoPricingGroupSettings = "AutoPricingGroupSettings",
    SaleSkyboxNotesSection = "SaleSkyboxNotesSection",
    EnableDisableMarketplaces = "EnableDisableMarketplaces",
    AutoCompAndGroup = "AutoCompAndGroup",
    ExcludeFullySoldInGroup = "ExcludeFullySoldInGroup",
    ReportingV2 = "ReportingV2",
    AutoFulfillSetting = "AutoFulfillSetting",
    PricingSettingsInTable = "PricingSettingsInTable",
    SponsoredListings = "SponsoredListings",
    VenueMapCtrlPlusM = "VenueMapCtrlPlusM",
    ScoreSectionRowTable = "ScoreSectionRowTable",
    VenueMapRectSelect = "VenueMapRectSelect",
    ViewListingOriginalSeating = "ViewListingOriginalSeating",
    FulfillmentProviders = "FulfillmentProviders",
    EventListingTableHotkeys = "EventListingTableHotkeys",
    AutoGroupAndCompV2 = "AutoGroupAndCompV2",
    ListingGroupingMethods = "ListingGroupingMethods",
    GroupSoldListings = "GroupSoldListings",
    PricingV2DemandDashboard = "PricingV2DemandDashboard",
    CustomVenueRows = "CustomVenueRows",
    BulkActionGroupListings = "BulkActionGroupListings",
    PricingABTest = "PricingABTest",
    EnableNativeSyncToggle = "EnableNativeSyncToggle",
    BulkUpdateIndividualTicketGroup = "BulkUpdateIndividualTicketGroup",
    AutoCompRankOverrides = "AutoCompRankOverrides",
    UpgradedGroupListingView = "UpgradedGroupListingView",
    UpcomingOnSalesPage = "UpcomingOnSalesPage",
    RemoveUiGateOnUnmap = "RemoveUiGateOnUnmap",
    SortListingsInGroup = "SortListingsInGroup",
    ReorderListingInGroup = "ReorderListingInGroup",
    EditMapInListingTab = "EditMapInListingTab",
    BackfillDeliveryStrategyInventoryEventToSales = "BackfillDeliveryStrategyInventoryEventToSales",
    BackfillDeliveryStrategyPurchaseEventToSales = "BackfillDeliveryStrategyPurchaseEventToSales",
    BackfillDeliveryStrategyVendorAccountToSales = "BackfillDeliveryStrategyVendorAccountToSales",
    FullPageEventViewEntitySelection = "FullPageEventViewEntitySelection",
    CompQuantitiesFilter = "CompQuantitiesFilter",
    FullPageEventViewSideTableBulkEdit = "FullPageEventViewSideTableBulkEdit",
    DefaultNotToMergeHoldListings = "DefaultNotToMergeHoldListings",
    CustomDeliveryType = "CustomDeliveryType",
    ListingNotesAdditionalInfo = "ListingNotesAdditionalInfo",
    FullPageEventViewSideTableFilters = "FullPageEventViewSideTableFilters",
    BulkEditsToListingGroups = "BulkEditsToListingGroups",
    GroupedActivityLog = "GroupedActivityLog",
    ExcludeDefects = "ExcludeDefects",
    AllocateSingleTickets = "AllocateSingleTickets",
    PdfViewerToolbar = "PdfViewerToolbar",
    FufillmentMismatchDisplay = "FufillmentMismatchDisplay",
    DisplayTicketOrderedByPriority = "DisplayTicketOrderedByPriority",
    ShowSeatTraitOnMerge = "ShowSeatTraitOnMerge",
    EventMultiScreen = "EventMultiScreen",
    DefaultFilterRows = "DefaultFilterRows",
    RowSeatColumnSalePurchase = "RowSeatColumnSalePurchase",
    CommandMenu = "CommandMenu",
    ReconcileOrphanTickets = "ReconcileOrphanTickets",
    UseSelectedRowIdForMarketplaceSeatingOverride = "UseSelectedRowIdForMarketplaceSeatingOverride",
    SelectDeliveryStrategyInSeatSaver = "SelectDeliveryStrategyInSeatSaver",
    ListingGroupCompUi = "ListingGroupCompUi",
    YourListingsInComps = "YourListingsInComps",
    NewListingDefaultToSpeculativeRowId = "NewListingDefaultToSpeculativeRowId",
    UploadTicketFilesFlowV2 = "UploadTicketFilesFlowV2",
    RightNowStatsInMap = "RightNowStatsInMap",
    ConsignmentDeal = "ConsignmentDeal",
    FilterByCurrencyCodeMulti = "FilterByCurrencyCodeMulti",
    FilterByPaymentCurrencyCodeMulti = "FilterByPaymentCurrencyCodeMulti",
    AutoPricingTabInAccountSettings = "AutoPricingTabInAccountSettings",
    AttemptFulfillWhenToggleOnAutoFulfill = "AttemptFulfillWhenToggleOnAutoFulfill",
    SaleDetailDisplayTicketUrl = "SaleDetailDisplayTicketUrl",
    PreventInitialBroadcastForXDays = "PreventInitialBroadcastForXDays",
    AutoCompPersistAllConfigChanges = "AutoCompPersistAllConfigChanges",
    ManageMarketplacePayment = "ManageMarketplacePayment",
    HideAutoCompOnlyBulkEditOption = "HideAutoCompOnlyBulkEditOption",
    PreventDraftPOinUI = "PreventDraftPOinUI",
    MarketplacePaymentsTab = "MarketplacePaymentsTab",
    AllowSeatScoreCompListingMode = "AllowSeatScoreCompListingMode",
    DemandDashLastDaySupplyMetrics = "DemandDashLastDaySupplyMetrics",
    GroupingWizard = "GroupingWizard",
    IntelligiblePricePreviewForListingGroup = "IntelligiblePricePreviewForListingGroup",
    SimplifiedAutoPricingUiV2 = "SimplifiedAutoPricingUiV2",
    MoveToGroup = "MoveToGroup",
    IgnoreDuplicate = "IgnoreDuplicate",
    QuickFloorToolbar = "QuickFloorToolbar",
    BulkUpdatePurchaseCurrency = "BulkUpdatePurchaseCurrency",
    BulkWasteTickets = "BulkWasteTickets",
    AutoPricingBulkEditToDrawerWithPreview = "AutoPricingBulkEditToDrawerWithPreview",
    PurchasePaymentMethodEdit = "PurchasePaymentMethodEdit",
    CancelSaleKeepTickets = "CancelSaleKeepTickets",
    ConvertSaleCurrency = "ConvertSaleCurrency",
    DisplayDeactivatedUser = "DisplayDeactivatedUser",
    SVGVenueMapV3 = "SVGVenueMapV3",
    LockCommissionsOnPo = "LockCommissionsOnPo",
    CleanupWhiteSpace = "CleanupWhiteSpace",
    LinkPaymentLine = "LinkPaymentLine",
    PricingSectionSettingsAcrossEvents = "PricingSectionSettingsAcrossEvents",
    PurchaseCommissionFilterInSearchView = "PurchaseCommissionFilterInSearchView",
    MultiTicketGroupTable = "MultiTicketGroupTable",
    EventDiscoveryPage = "EventDiscoveryPage",
    SeatTraitsColumn = "SeatTraitsColumn",
    EventSelectorFilter = "EventSelectorFilter",
    BlockEventDiscoveryData = "BlockEventDiscoveryData",
    BulkUploadPurchaseV2Perf = "BulkUploadPurchaseV2Perf",
    ListingTableSplitTypeColumn = "ListingTableSplitTypeColumn",
    CompListingDisplayUpdate = "CompListingDisplayUpdate",
    CatalogMetricsV2 = "CatalogMetricsV2",
    HideSalePaymentConversionSection = "HideSalePaymentConversionSection",
    FlashSaleDiscountRestriction = "FlashSaleDiscountRestriction",
    EventMapRibbonYolo = "EventMapRibbonYolo",
    ReportV2CommissionsReport = "ReportV2CommissionsReport",
    KnowledgePortalPageTestData = "KnowledgePortalPageTestData",
    SearchView_ReadOnlyDB = "SearchView_ReadOnlyDB",
    BulkEditPricingSettingsUpdate = "BulkEditPricingSettingsUpdate",
    HomePageNotifications = "HomePageNotifications",
    EventsDetailedViewGrouping = "EventsDetailedViewGrouping",
    GlobalReportV1RedirectV2 = "GlobalReportV1RedirectV2",
    BlockInventorySummaryStats = "BlockInventorySummaryStats",
    AllocateSingleTicketListingRestrictionRemoval = "AllocateSingleTicketListingRestrictionRemoval",
    OnePagerGroupSelectionFunctionality = "OnePagerGroupSelectionFunctionality",
    ConsignmentFilterPurchaseSearchView = "ConsignmentFilterPurchaseSearchView",
    HideNavAndFilterBars = "HideNavAndFilterBars",
    ReportSinglePagedV1V2 = "ReportSinglePagedV1V2",
    EventDiscoveryCapacityAndPrimary = "EventDiscoveryCapacityAndPrimary",
    BackfillListingTicketTypeOverrideToSale = "BackfillListingTicketTypeOverrideToSale",
    ListingDetailsDeprecatedOnlySelectedSectionsFlag = "ListingDetailsDeprecatedOnlySelectedSectionsFlag",
    BulkUpdateSeatingForAllMarketplace = "BulkUpdateSeatingForAllMarketplace",
    MultiExpandGroups = "MultiExpandGroups",
    NewPurchaseDirectEmailVendorInput = "NewPurchaseDirectEmailVendorInput",
    SeatTraitsColumnSales = "SeatTraitsColumnSales",
    AccessibilityMode = "AccessibilityMode",
    DisplayMarketplaceSeatingOverride = "DisplayMarketplaceSeatingOverride",
    BulkCreatePurchase = "BulkCreatePurchase",
    SearchViewGroupRowWithEvent = "SearchViewGroupRowWithEvent",
    RemoveEventAccordian = "RemoveEventAccordian",
    UnsoldTicketsFilter = "UnsoldTicketsFilter",
    GroupPricingSettingsV2 = "GroupPricingSettingsV2",
    MarketplaceSaleAvoidIdPrefill = "MarketplaceSaleAvoidIdPrefill",
    CatalogV2_LocalStore = "CatalogV2_LocalStore",
    HomePageRecentSalesFast = "HomePageRecentSalesFast",
    PriceHistory_ShowNullMarketplaceAsAllMarketplace = "PriceHistory_ShowNullMarketplaceAsAllMarketplace",
    FallbackRowFilterWithOrdinalRank = "FallbackRowFilterWithOrdinalRank",
    TableSortInGroupingWizard = "TableSortInGroupingWizard",
    EditMarketplaceSaleId_Offline = "EditMarketplaceSaleId_Offline",
    EditMarketplaceSaleId_Marketplace = "EditMarketplaceSaleId_Marketplace",
    UseUtilitiesFeatureService = "UseUtilitiesFeatureService",
    TicketGroupV2PopulateHighSeat = "TicketGroupV2PopulateHighSeat",
    SearchViewVenueFilter = "SearchViewVenueFilter",
    OnSaleEventDetailsView = "OnSaleEventDetailsView",
    UnitCostInBulkPreview = "UnitCostInBulkPreview",
    GlobalReportV1RedirectV2_ActiveInventory = "GlobalReportV1RedirectV2_ActiveInventory",
    GlobalReportV1RedirectV2_DailySales = "GlobalReportV1RedirectV2_DailySales",
    GlobalReportV1RedirectV2_EventPandL = "GlobalReportV1RedirectV2_EventPandL",
    GlobalReportV1RedirectV2_MarketplacePerformance = "GlobalReportV1RedirectV2_MarketplacePerformance",
    GlobalReportV1RedirectV2_PerformerPandL = "GlobalReportV1RedirectV2_PerformerPandL",
    GlobalReportV1RedirectV2_SoldInventory = "GlobalReportV1RedirectV2_SoldInventory",
    GlobalReportV1RedirectV2_CommissionReport = "GlobalReportV1RedirectV2_CommissionReport",
    DisableMetricsQueryRefetch = "DisableMetricsQueryRefetch",
    ExcludeToIncludeFanInv = "ExcludeToIncludeFanInv",
    HideEventDiscoveryDemandData = "HideEventDiscoveryDemandData",
    ReportSnapshotBackgroundExport = "ReportSnapshotBackgroundExport",
    UseGrpcCache = "UseGrpcCache",
    ExportPaymentMonth = "ExportPaymentMonth",
    EventHeaderRework = "EventHeaderRework",
    ReportV2ExposeLatencyLivePage = "ReportV2ExposeLatencyLivePage",
    MarketplacePaymentSearch = "MarketplacePaymentSearch",
    FilterByEntityIdOptimization = "FilterByEntityIdOptimization",
    BulkUploadMarketplacePaymentLine = "BulkUploadMarketplacePaymentLine",
    BackfillCancelledProceeds = "BackfillCancelledProceeds",
    EditMarketplacePaymentLine = "EditMarketplacePaymentLine",
    AvoidRowVersionUpdateForSectionalUpdate = "AvoidRowVersionUpdateForSectionalUpdate",
    DeleteMarketplacePayment = "DeleteMarketplacePayment",
    DeleteMarketplacePaymentLine = "DeleteMarketplacePaymentLine",
    EditRevealSyncDate = "EditRevealSyncDate",
    ReportsSummaryFetchAll = "ReportsSummaryFetchAll",
    AddMarketplacePaymentLine = "AddMarketplacePaymentLine",
    MarketplacePaymentLineFilter = "MarketplacePaymentLineFilter",
    PurchaseLineItemReport = "PurchaseLineItemReport",
    LockMarketplacePayment = "LockMarketplacePayment",
    RemoveListView = "RemoveListView",
    EditMarketplacePayment = "EditMarketplacePayment",
    CompareGrpcCacheWithLiveCounts = "CompareGrpcCacheWithLiveCounts",
    AllowAddCostOnCancelledPO = "AllowAddCostOnCancelledPO",
    ReportV2ColumnFormat = "ReportV2ColumnFormat",
    RatioToReportCustomCol = "RatioToReportCustomCol",
    MarketplacePaymentDiscrepancy = "MarketplacePaymentDiscrepancy",
    AvgCntForReports = "AvgCntForReports",
    QuantityFiltersWithDefaults = "QuantityFiltersWithDefaults",
    UseGrpcCache_ListingCounts = "UseGrpcCache_ListingCounts",
    UseGrpcCache_SaleCounts = "UseGrpcCache_SaleCounts",
    UseGrpcCache_PurchaseCounts = "UseGrpcCache_PurchaseCounts",
    RowOffsetOnManualSections = "RowOffsetOnManualSections",
    EventDiscoveryTransactionPrice = "EventDiscoveryTransactionPrice",
    CostChangeReports = "CostChangeReports",
    AutoLinkSaleLineItemSetting = "AutoLinkSaleLineItemSetting",
    LogSectionalData = "LogSectionalData",
    SelectedSectionScoreRecommendations = "SelectedSectionScoreRecommendations",
    PersistentTagCreate = "PersistentTagCreate",
    DeletedEventStateDisplay = "DeletedEventStateDisplay",
    FavoritePaymentMethods = "FavoritePaymentMethods",
    EventPricingTeam = "EventPricingTeam",
    DateRangeSelectorV2 = "DateRangeSelectorV2",
    AutoSplitDiscontinuousListingSetting = "AutoSplitDiscontinuousListingSetting",
    EventSelectorV2 = "EventSelectorV2",
    GroupWizardInEdit = "GroupWizardInEdit",
    StandaloneEntityDetailModals = "StandaloneEntityDetailModals",
    DynamicUnderCutSettingsInOnePager = "DynamicUnderCutSettingsInOnePager",
    DefaultYesNoFilters = "DefaultYesNoFilters",
    PricingSettingStrategyWithFallback = "PricingSettingStrategyWithFallback",
    DisplayAllPaymentMethods = "DisplayAllPaymentMethods",
    AlignCurrenciesOnReports = "AlignCurrenciesOnReports",
    CompareGrpcCacheWithLiveMetrics = "CompareGrpcCacheWithLiveMetrics",
    EventDiscoveryNotifications = "EventDiscoveryNotifications",
    RowIdFilterWithRowRange = "RowIdFilterWithRowRange",
    SaleEditBarcode = "SaleEditBarcode",
    NonCumulativeMarketshareChart = "NonCumulativeMarketshareChart",
    TagsUiV3 = "TagsUiV3",
    PageLoadMonitoring = "PageLoadMonitoring",
    SellerEventAlertMutes = "SellerEventAlertMutes",
    RemovePriceIncreaseRoadbump = "RemovePriceIncreaseRoadbump",
    BroadcastByMarketplaceColumn = "BroadcastByMarketplaceColumn",
    CatchUpModeShortenUrl = "CatchUpModeShortenUrl",
    TableFooterColumnVirtualized = "TableFooterColumnVirtualized",
    TurnOffDoubleWriteToUserSetting = "TurnOffDoubleWriteToUserSetting",
    ZoneMapV2 = "ZoneMapV2",
    MobileInventoryEventPage = "MobileInventoryEventPage",
    MobileInventoryPortfolioPage = "MobileInventoryPortfolioPage",
    MobileInventoryDetailsView = "MobileInventoryDetailsView",
    SelectedSectionRecsByConfigVenueType = "SelectedSectionRecsByConfigVenueType",
    TableTotals_All = "TableTotals_All",
    TableTotals_Purchase = "TableTotals_Purchase",
    TableTotals_Sales = "TableTotals_Sales",
    TableTotals_Inventory = "TableTotals_Inventory",
    TableTotals_Payments = "TableTotals_Payments",
    TableTotals_Events = "TableTotals_Events",
    UseGrpcCache_AllowStaleData = "UseGrpcCache_AllowStaleData",
    SignalRHealthCheck = "SignalRHealthCheck",
    DefaultManualMaxDisplayQuantitySetting = "DefaultManualMaxDisplayQuantitySetting",
    ConsigneeSingleEntityUpdate = "ConsigneeSingleEntityUpdate",
    SurfacePricingStates = "SurfacePricingStates",
    NewMultiTgTableInput = "NewMultiTgTableInput",
    SearchViewPerformerFilter = "SearchViewPerformerFilter",
    AdminHoldWarningDuringAllocation = "AdminHoldWarningDuringAllocation",
    ReportBackgroundExport = "ReportBackgroundExport",
    EventHeaderRework_Purchase = "EventHeaderRework_Purchase",
    EventHeaderRework_Sales = "EventHeaderRework_Sales",
    BulkUploadSeatTraits = "BulkUploadSeatTraits",
    PurchaseOutstandingBalanceColumn = "PurchaseOutstandingBalanceColumn",
    BulkSetTotalTicketCost = "BulkSetTotalTicketCost",
    EnableSelectionByDefaultSetting = "EnableSelectionByDefaultSetting",
    BulkUploadSeatSavers = "BulkUploadSeatSavers",
    MaineEventComplianceMessage = "MaineEventComplianceMessage",
    ManualPriceStaggers = "ManualPriceStaggers",
    RecentSalesTableV3 = "RecentSalesTableV3",
    RememberScrollPositionEventList = "RememberScrollPositionEventList",
    SetCeilingOnPricingOnePager = "SetCeilingOnPricingOnePager",
    FavoriteVendors = "FavoriteVendors",
    SalesTableV2 = "SalesTableV2",
    AutoCleanupBrowserData = "AutoCleanupBrowserData",
    PurchaseInternalIdColumnDisplay = "PurchaseInternalIdColumnDisplay",
    ListingTableV2 = "ListingTableV2",
    UseGrpcCache_BatchEventIds = "UseGrpcCache_BatchEventIds",
    BulkEditAutoPricingPriceAgainstMySection = "BulkEditAutoPricingPriceAgainstMySection",
    ListingTableDeterminsticListingGroupSort = "ListingTableDeterminsticListingGroupSort",
    ReducedBroadcastStatusPullingFrequency = "ReducedBroadcastStatusPullingFrequency",
    BatchGetListingStatusCalls = "BatchGetListingStatusCalls",
    MobileSalePortfolioPage = "MobileSalePortfolioPage",
    MobilePurchasePortfolioPage = "MobilePurchasePortfolioPage",
    SurfaceFirstListingInGroup = "SurfaceFirstListingInGroup",
    StubHubListingFilterWithPurchaseQuantities = "StubHubListingFilterWithPurchaseQuantities",
    ToggleNotificationsSettings = "ToggleNotificationsSettings",
    ShowEventTagOnEventTile = "ShowEventTagOnEventTile",
    InventoryStatsInStubhubSidePanel = "InventoryStatsInStubhubSidePanel",
    BulkSplitListings = "BulkSplitListings",
    AdvancedSearchV2 = "AdvancedSearchV2",
    TicketGroupReport = "TicketGroupReport",
    BulkEditListingMaxDisplayQuantity = "BulkEditListingMaxDisplayQuantity",
    BulkEditListingPricingBasedOffUnitCost = "BulkEditListingPricingBasedOffUnitCost",
    ReachProSupport = "ReachProSupport",
    PurchaseTableV2 = "PurchaseTableV2",
    CleanUpOutdatedPricingState = "CleanUpOutdatedPricingState",
    SponsoredListingsV2 = "SponsoredListingsV2",
    DateFiltersRelativeExactCustom = "DateFiltersRelativeExactCustom",
    RefetchCatalogAndEntityOnNavigate_All = "RefetchCatalogAndEntityOnNavigate_All",
    RefetchCatalogAndEntityOnNavigate_Purchase = "RefetchCatalogAndEntityOnNavigate_Purchase",
    RefetchCatalogAndEntityOnNavigate_Sales = "RefetchCatalogAndEntityOnNavigate_Sales",
    RefetchCatalogAndEntityOnNavigate_Inventory = "RefetchCatalogAndEntityOnNavigate_Inventory",
    MinimalFiltersForMetrics_Inventory = "MinimalFiltersForMetrics_Inventory",
    UserSettingOnTableSorting = "UserSettingOnTableSorting",
    DataExportFormatDateAsAccountTimeZone = "DataExportFormatDateAsAccountTimeZone",
    MinMaxInCustomColumn = "MinMaxInCustomColumn",
    TableRowSelectionV2 = "TableRowSelectionV2",
    ShowSponsoredSalesAsSponsored = "ShowSponsoredSalesAsSponsored",
    EventDiscoveryInInventoryView = "EventDiscoveryInInventoryView",
    ListingGroupAccountSettings = "ListingGroupAccountSettings",
    CompanionModeInInsightView = "CompanionModeInInsightView",
    SponsoredListingsV2_EventDetailBoostTab = "SponsoredListingsV2_EventDetailBoostTab",
    FrontendTelemetryContext = "FrontendTelemetryContext",
    GlobalReportV1RedirectV2_PurchasedInventory = "GlobalReportV1RedirectV2_PurchasedInventory",
    GlobalReportV1RedirectV2_CanceledInventory = "GlobalReportV1RedirectV2_CanceledInventory",
    GlobalReportV1RedirectV2_All = "GlobalReportV1RedirectV2_All",
    RejectedPendingEventsFilter = "RejectedPendingEventsFilter",
    ReplaceUnsoldWithAvailableTickets = "ReplaceUnsoldWithAvailableTickets",
    ParkingEventsFilterSetting = "ParkingEventsFilterSetting",
    CreatePurchaseFromListing = "CreatePurchaseFromListing",
    CreateSaleInvoice = "CreateSaleInvoice",
    ShouldAutoCleanupBrowserCache = "ShouldAutoCleanupBrowserCache",
    ReportV2RealtimeOption = "ReportV2RealtimeOption",
    SponsoredListingsV2_CampaignManager = "SponsoredListingsV2_CampaignManager",
    InsightsViewTableFilters = "InsightsViewTableFilters",
    SponsoredListingsV2_CPC_Input = "SponsoredListingsV2_CPC_Input",
    GroupListingsAcrossEvents = "GroupListingsAcrossEvents",
    POCreationInternalNotesColumn = "POCreationInternalNotesColumn",
    CompListingsSeatNumbers = "CompListingsSeatNumbers",
    NoScrollDependencyOnVirtuoso = "NoScrollDependencyOnVirtuoso",
    SponsoredListingsV2_ReportingMetrics = "SponsoredListingsV2_ReportingMetrics",
    SponsoredListingsV2_FilterIsBoosted = "SponsoredListingsV2_FilterIsBoosted",
    RecentSalesV2PurchasedByColumn = "RecentSalesV2PurchasedByColumn",
    SponsoredListingsV2_BulkBoost = "SponsoredListingsV2_BulkBoost",
    FEPerf_AvoidReRenderListingTableRow = "FEPerf_AvoidReRenderListingTableRow",
    FEPerf_ReworkUserSettingsContext = "FEPerf_ReworkUserSettingsContext",
    FEPerf_CatalogDataContextWithSelector = "FEPerf_CatalogDataContextWithSelector",
    GetListingsPerEventInCatchUpMode = "GetListingsPerEventInCatchUpMode",
    AdvancedSearchV2_Purchase = "AdvancedSearchV2_Purchase",
    AdvancedSearchV2_Sales = "AdvancedSearchV2_Sales",
    AdvancedSearchV2_Inventory = "AdvancedSearchV2_Inventory",
    BoostUniversity = "BoostUniversity",
    UserTeams = "UserTeams",
    PurchaseDefaultDateFilterLast365Days = "PurchaseDefaultDateFilterLast365Days",
    DonateListing = "DonateListing",
    GroupedVirtuosoRowWrapperFix = "GroupedVirtuosoRowWrapperFix",
    ShowGigsbergInBroadcastTableForIntlEvents = "ShowGigsbergInBroadcastTableForIntlEvents",
    SponsoredListingsV2_SpecificZonesTargeting = "SponsoredListingsV2_SpecificZonesTargeting",
    SponsoredListingsV2_First3RowsOnly = "SponsoredListingsV2_First3RowsOnly",
    NumberInputWithLeadingZero = "NumberInputWithLeadingZero",
    SponsoredListingsV2_CampaignHubMap = "SponsoredListingsV2_CampaignHubMap",
    BulkUploadOfflineMarketplacePaymentLine = "BulkUploadOfflineMarketplacePaymentLine",
    CreatePOTicketGroupsInChunk = "CreatePOTicketGroupsInChunk",
    MarketOrders = "MarketOrders",
    ReworkListingPriceForm = "ReworkListingPriceForm",
    SpoilTicketsInSale = "SpoilTicketsInSale",
    AddTotalCostPurchaseUpload = "AddTotalCostPurchaseUpload",
    CustomPurchaseColumns = "CustomPurchaseColumns",
    ReEvaluatePredeliveryStateAndTopTicketType = "ReEvaluatePredeliveryStateAndTopTicketType",
    MarketplacePaymentConversion = "MarketplacePaymentConversion",
    WasteSale = "WasteSale",
    UseShLnLookup = "UseShLnLookup",
    BlockPricingCompListingEndpoint = "BlockPricingCompListingEndpoint",
    BlockPricingCalculationEndpoint = "BlockPricingCalculationEndpoint",
    BlockEventDashboardEndpoint = "BlockEventDashboardEndpoint",
    AlwaysGetEventLevelSettingsFromAutoPricer = "AlwaysGetEventLevelSettingsFromAutoPricer",
    WriteAutopriceConfigUpdateToSbt = "WriteAutopriceConfigUpdateToSbt",
    SetAsDefaultAllNewEvents = "SetAsDefaultAllNewEvents",
    AccountLevelFeatureCheck = "AccountLevelFeatureCheck",
    UpdateSaleStatusOnSiteCreation = "UpdateSaleStatusOnSiteCreation",
    BulkReturnTicket = "BulkReturnTicket",
    ExternalPosAndProcessorAuthEncryption = "ExternalPosAndProcessorAuthEncryption",
    FulfillmentRulesEventLevel = "FulfillmentRulesEventLevel",
    BackfillSalesFulfillerToEvent = "BackfillSalesFulfillerToEvent",
    RightHolderMarkAsFulfill = "RightHolderMarkAsFulfill",
    IncludeFanInventoryBroadcast = "IncludeFanInventoryBroadcast",
    GetListingAutoPricingSettingsReadListingPropsFromPricer = "GetListingAutoPricingSettingsReadListingPropsFromPricer",
    EnableMasterUiViewForConsignors = "EnableMasterUiViewForConsignors",
    FulfillmentRulesVenueLevel = "FulfillmentRulesVenueLevel",
    GetPurchasePerformanceImprovement = "GetPurchasePerformanceImprovement",
    ImprovePerfForUpdateListingSectionalApis = "ImprovePerfForUpdateListingSectionalApis",
    UserManagementMasterUiForConsignor = "UserManagementMasterUiForConsignor",
    MemorizeLastBroadcastListingMarketplace = "MemorizeLastBroadcastListingMarketplace",
    RemoveViewPricedListingsPerm = "RemoveViewPricedListingsPerm",
    GranularListingGroupSettingOverride = "GranularListingGroupSettingOverride",
    DefaultToMyRowOnSectionSelection = "DefaultToMyRowOnSectionSelection",
    DefaultGroupPricingSettings = "DefaultGroupPricingSettings",
    AutoPricingEmptySelectedSectionsNoComps = "AutoPricingEmptySelectedSectionsNoComps",
    RevealMarketUseProcessorConfig = "RevealMarketUseProcessorConfig",
    ShowAmpSectionRecs = "ShowAmpSectionRecs",
    ShowConcertsSectionBehindStageSectionRecs = "ShowConcertsSectionBehindStageSectionRecs",
    ShowSportsOrConcerts360SectionRecs = "ShowSportsOrConcerts360SectionRecs",
    FixFloorRelativeToMarket = "FixFloorRelativeToMarket",
    MultiFeatureReleaseNotes = "MultiFeatureReleaseNotes",
    ReconfirmCancelledSaleHandleByProcessor = "ReconfirmCancelledSaleHandleByProcessor",
    ApplyInHandDaysBeforeEvent = "ApplyInHandDaysBeforeEvent",
    CleanUpPricingSettingsInListingHistory = "CleanUpPricingSettingsInListingHistory",
    UseListingGroupDefaultsFromPricer = "UseListingGroupDefaultsFromPricer",
    AutoPricingIgnoreVeloCB = "AutoPricingIgnoreVeloCB",
    FixUpdateFloorAndCeilingIssues = "FixUpdateFloorAndCeilingIssues",
    EventVenueConfigIdFromEventService = "EventVenueConfigIdFromEventService",
    CalibrateTgUnitCostOnBackend = "CalibrateTgUnitCostOnBackend",
    AutoPricingCompRowOffsetMode = "AutoPricingCompRowOffsetMode",
    AutoPricingPausePriceUpdates = "AutoPricingPausePriceUpdates",
    AddCountryCodeInActionOutboxPayload = "AddCountryCodeInActionOutboxPayload",
    ExportCsvFilterColumns = "ExportCsvFilterColumns",
    AutoPricingCompFailureAction = "AutoPricingCompFailureAction",
    LinkProceedWithSaleLineItem = "LinkProceedWithSaleLineItem",
    AutoPricingWebsitePriceUndercuts = "AutoPricingWebsitePriceUndercuts",
    AutoPricingImprovedPricePreivewForVeloCB = "AutoPricingImprovedPricePreivewForVeloCB",
    AutoGeneratePONumbers = "AutoGeneratePONumbers",
    UseGrpcCacheV2ListingsGetCount = "UseGrpcCacheV2ListingsGetCount",
    UseGrpcCacheV2ListingsGetMetrics = "UseGrpcCacheV2ListingsGetMetrics",
    UnmappedInvToggle = "UnmappedInvToggle",
    TagMappingToDefaultBuyer = "TagMappingToDefaultBuyer",
    AdminHoldInventoryOnSaleRejection = "AdminHoldInventoryOnSaleRejection",
    UseGrpcCacheV2EventsFilter = "UseGrpcCacheV2EventsFilter",
    PurchaseOverPayLogicBehindSetting = "PurchaseOverPayLogicBehindSetting",
    UseGrpcCacheV2SalesGetCount = "UseGrpcCacheV2SalesGetCount",
    UseGrpcCacheV2SalesGetMetrics = "UseGrpcCacheV2SalesGetMetrics",
    UseGrpcCacheV2PurchasesGetCount = "UseGrpcCacheV2PurchasesGetCount",
    UseGrpcCacheV2PurchasesGetMetrics = "UseGrpcCacheV2PurchasesGetMetrics",
    BulkSetPurchaseOrderCost = "BulkSetPurchaseOrderCost",
    StubHubSubGenresInPOS = "StubHubSubGenresInPOS",
    EnableNativeSyncForTicketVault = "EnableNativeSyncForTicketVault",
    BulkUploadPurchaseListingPrivateNotes = "BulkUploadPurchaseListingPrivateNotes",
    OtherPurchaseOrderCostType = "OtherPurchaseOrderCostType",
    AdjustPurchaseFxRate = "AdjustPurchaseFxRate",
}

export enum FeatureState {
    Disabled = "Disabled",
    Restricted = "Restricted",
    GeneralAvailability = "GeneralAvailability",
    LimitedAvailability = "LimitedAvailability",
    InDevelopment = "InDevelopment",
}

export interface ReportingPagedResultOfReportingCampaignReport {
    totalItems: number;
    page: number;
    pageSize: number;
    items: ReportingCampaignReport[];
}

export interface ReportingCampaignReport {
    campaignId: number | null;
    eventIds: number[] | null;
    currentMetrics: ReportingPerformanceMetrics | null;
    totalMetrics: ReportingPerformanceMetrics | null;
}

export interface ReportingPerformanceMetrics {
    eventImpressions: number | null;
    participatingImpressions: number | null;
    adImpressions: number | null;
    platformAdSalesCount: number | null;
    platformAdSalesProceeds: number | null;
    adSalesCount: number | null;
    adSalesProceeds: number | null;
    clicks: number | null;
    adSpendUSD: number | null;
    potentialSales: number | null;
    potentialSalesProceeds: number | null;
}

export interface ReportingPagedResultOfReportingFlightReport {
    totalItems: number;
    page: number;
    pageSize: number;
    items: ReportingFlightReport[];
}

export interface ReportingFlightReport {
    campaignId: number | null;
    flightId: number | null;
    startDate: string | null;
    endDate: string | null;
    metrics: ReportingPerformanceMetrics | null;
}

export interface ReportingEventCampaignMetrics {
    campaigns: ReportingCampaignReport[] | null;
}

export interface GetCampaignMetricsByEventIdsRequest {
    eventIds: number[];
    startDate: string;
    endDate: string;
}

export interface ReportingCampaignMetricsResult {
    campaigns: ReportingCampaignReport[] | null;
}

export interface GetCampaignMetricsByIdsRequest {
    campaignIds: number[];
    startDate: string;
    endDate: string;
}

export interface ReportingFlightMetricsResult {
    flights: ReportingFlightReport[] | null;
}

export interface GetFlightsMetricsByCampaignIdsRequest {
    campaignFlights: CampaignFlightsRequest[];
    startDate: string;
    endDate: string;
}

export interface CampaignFlightsRequest {
    campaignId: number;
    flightIds: number[];
}

export interface ReportingEventSectionReport {
    eventId: number;
    sections: ReportingSectionReport[] | null;
}

export interface ReportingSectionReport {
    sectionId: number;
    metrics: ReportingPerformanceMetrics | null;
}

export interface GetSectionMetricsByEventIdsRequest {
    eventIds: number[];
    startDate: string;
    endDate: string;
    sectionIds: number[];
}

export interface AutoPoInboundEmail {
    inboundEmailId: number;
    subject: string | null;
    fromEmailAddress: string | null;
    toEmailAddress: string | null;
    receiveDate: string | null;
    createDate: string;
    purchaseOrderVendorId: number | null;
    partialPurchaseOrderId: number | null;
    purchaseOrderId: number | null;
    saleId: number | null;
    classificationType: AutoPoInboundEmailClassificationType | null;
}

export enum AutoPoInboundEmailClassificationType {
    NewPurchaseOrder = "NewPurchaseOrder",
    ExistingPurchaseOrder = "ExistingPurchaseOrder",
    Junk = "Junk",
    OneTimePass = "OneTimePass",
    Password = "Password",
    TicketsAvailable = "TicketsAvailable",
    PurchaseCancelled = "PurchaseCancelled",
    EventCancelled = "EventCancelled",
    EventPostponed = "EventPostponed",
    EnjoyTheEvent = "EnjoyTheEvent",
    TransferSent = "TransferSent",
    TransferAccepted = "TransferAccepted",
    TransferExpired = "TransferExpired",
    NewSale = "NewSale",
    ConfirmationDeadline = "ConfirmationDeadline",
    ShippingDeadline = "ShippingDeadline",
    SaleCancelled = "SaleCancelled",
    OtherMarketplaceContact = "OtherMarketplaceContact",
}

export interface AutoPoInboundEmailQuery {
    inboundEmailIds: number[] | null;
}

export interface AutoPoPartialPurchaseOrderInboundEmail {
    inboundEmailId: number;
    subject: string | null;
    fromEmailAddress: string | null;
    toEmailAddress: string | null;
    purchaseOrderVendorId: number | null;
    receiveDate: string | null;
    createDate: string;
    partialPurchaseOrderId: number | null;
    orderId: string | null;
    quantity: number | null;
    faceValue: number | null;
    purchaseOrderDate: string | null;
    totalCount: number;
}

export interface AutoPoInboundEmailPartialPurchaseOrderQuery {
    classificationTypes: AutoPoInboundEmailClassificationType[] | null;
    includeUnclassified: boolean | null;
    subjectSearchText: string | null;
    fromEmailAddress: string | null;
    toEmailAddress: string | null;
    textBodySearchText: string | null;
    classificationTypeUpdateDateFrom: string | null;
    classificationTypeUpdateDateTo: string | null;
}

export interface AutoPoPartialPurchaseOrder {
    partialPurchaseOrderId: number;
    orderId: string;
    eventName: string;
    eventDateTime: string | null;
    venueName: string;
    section: string;
    row: string;
    seatFrom: string;
    seatTo: string;
    quantity: number | null;
    faceValue: number | null;
    purchaseOrderDate: string | null;
}

export interface AutoPoInboundEmailThreadEmail {
    inboundEmailId: number;
    classificationType: AutoPoInboundEmailClassificationType | null;
    subject: string | null;
    fromEmailAddress: string | null;
    toEmailAddress: string | null;
    receiveDate: string | null;
    htmlBody: string | null;
    textBody: string | null;
    purchaseOrderId: number | null;
    saleId: number | null;
    partialPurchaseOrderId: number | null;
    orderId: string | null;
    quantity: number | null;
    faceValue: number | null;
    purchaseOrderDate: string | null;
    purchaseOrderVendorId: number | null;
    attachments: AutoPoInboundEmailAttachment[] | null;
}

export interface AutoPoInboundEmailAttachment {
    attachmentFileName: string;
    downloadUri: string;
}

export interface ValueTupleOfStringAndString {
    item1: string;
    item2: string;
}

export interface AutoPoSellerAccountCountryRestriction {
    country: string;
    isEnabled: boolean | null;
}

export interface AutoPoSellerAccountVendorRestriction {
    vendorId: number;
    isIncluded: boolean;
}

export interface BulkEditPreviewWithDetails {
    error: string | null;
    allItemsCount: number;
    preview: BulkEditPreview;
    sales: Sale[] | null;
    listings: Listing[] | null;
    purchases: PurchaseOrder[] | null;
    ticketGroups: PurchaseOrderTicketGroup[] | null;
}

export interface BulkEditPreview {
    bulkEditCountPreview: { [key in keyof typeof ActionOutboxEntityType]?: BulkEditCountPreview; };
    consigneeOwnership: { [key in keyof typeof ActionOutboxEntityType]?: { [key: string]: number[]; }; } | null;
}

export interface BulkEditCountPreview {
    entityType: ActionOutboxEntityType;
    totalCount: number;
    idsAffected: number[];
}

/** Base class to represent common info between Listing, Sale, or PurchaseOrder, which basically is an entity that contains metadata about a set of Tickets for a single Event */
export interface EntityWithTickets {
    /** The ID of this entity in the DB (ListingId, SaleId, or PurchaseOrderId) */
    id: number;
    /** The seller account id that this entity belongs to.
This field only populates in MasterView UI (not single-account UI) */
    accId: string | null;
    /** The event of which this entity is for. */
    posEvId: string;
    /** ViagogoEntityId */
    viagEvId: number | null;
    /** ViagogoEventMappingId */
    viagEvMapId: string | null;
    /** ViagogoVirtualId (ViagogoEventId or ViagogoEventMappingId) */
    viagVirtId: string;
    rowVer: number;
    insertBy: string | null;
    currency: string;
    /** Given a Sale can consist of tickets purchased at different times, this should be
the latest date that all tickets are in hand.  This is a seller-provided field
and it does not have to coincide with listings or purchase orders. */
    inHandAt: string | null;
    seating: Seating;
    /** The number of tickets in this set.
- For Sale, it would be the same as QuantitySold - but this is the physical number of allocated tickets.
- For Listing for PO, it would just mean the number of tickets listed. */
    ticketCnt: number;
    seatTraits: ListingNote[] | null;
    privNotes: string | null;
}

/** Base class to represent common info between Sale and Listing (with Marketplace related info) */
export interface MarketplaceEntityWithTickets extends EntityWithTickets {
    /** Marketplace where these tickets were listed and sold */
    mkp: Marketplace | null;
    /** Represent either the MarketplaceListingId or MarketplaceSaleId */
    idOnMkp: string | null;
}

export interface Sale extends MarketplaceEntityWithTickets {
    entityType: ActionOutboxEntityType;
    /** The ID of the Listing in POS that this Sale comes from. */
    listingId: number | null;
    originatedFromListingId: number | null;
    saleDate: string;
    ttlNetProcs: UiMoney | null;
    soldTktCost: UiMoney | null;
    pandL: UiMoney | null;
    /** Margin (SoldProceeds - SoldCost) / SoldProceeds */
    margin: number | null;
    charges: UiMoney | null;
    credits: UiMoney | null;
    /** The total payment amount in the original currency */
    totalPmt: UiMoney | null;
    /** The total payment amount in the converted currency */
    totalConvertedPmt: UiMoney | null;
    /** PaymentState */
    pmtState: PointOfSalePaymentState | null;
    /** MarketplacePaymentState */
    mkpPmtState: MarketplacePaymentState | null;
    /** MarketplaceFulfillmentState */
    mkpFulfState: MarketplaceFulfillmentState | null;
    fulfillState: PointOfSaleFulfillmentState;
    fulfillDate: string | null;
    actions: SaleActionType[];
    status: PointOfSaleSaleStatus;
    isSeatSaver: boolean;
    adCmpFlightId: number | null;
    qtySold: number;
    ticketType: TicketType | null;
    fulfillerId: string | null;
    tags: Tag[] | null;
    holdExpiredOn: string | null;
    isNoFulfill: boolean | null;
    /** MarketplaceContractState */
    mkpContrState: MarketplaceContractState | null;
    /** IsFulfillmentVersionMismatched */
    isFulfillVerMis: boolean;
    owners: SaleOwnershipInfo | null;
    /** IsPaymentReceived */
    pmtRcv: boolean | null;
    /** PaymentReferenceId */
    pmtRefId: string | null;
    /** PaymentAmountReceived */
    pmtAmtRcv: number | null;
    /** LastPaymentDate */
    lastPmtDate: string | null;
    /** PaymentCurrencyCode */
    pmtCurcy: string | null;
    poDate: string | null;
    poId: number | null;
    poVendOrdId: string | null;
    poVendAccEmail: string | null;
    /** DisableAutoSourcing */
    disAutoSource: boolean;
    /** Originated By. The seller User ID that created the Listing that the sale originally comes from.  */
    origBy: string | null;
    /** Comment notes */
    comNotes: SaleCommentNote[] | null;
    /** Is unprocessed order from processor */
    isUnprocessedOrdFromPro: boolean | null;
    /** IsWastageSale */
    isWastageSale: boolean | null;
    /** The quantity of tickets that were wasted */
    qtyWasted: number;
    cancellationReason: SaleCancellationReason | null;
    hasMarketplaceProblem: boolean | null;
    /** Internal notes, which are truncated to 80 characters if it's more than 80 characters. */
    internalNotesPreview: string | null;
    /** Indicates whether the InternalNotesPreview is truncated or not. */
    isInternalNotesPreviewTruncated: boolean | null;
}

export interface UiMoney {
    amt: number;
    disp: string | null;
    currency: string | null;
    dec: number;
}

export enum PointOfSalePaymentState {
    Unpaid = "Unpaid",
    Queued = "Queued",
    Paid = "Paid",
    PartiallyPaid = "PartiallyPaid",
    PendingReversal = "PendingReversal",
    Reversed = "Reversed",
}

export enum MarketplacePaymentState {
    Ineligible = "Ineligible",
    Unpaid = "Unpaid",
    Queued = "Queued",
    Paid = "Paid",
    PartiallyPaid = "PartiallyPaid",
    PendingReversal = "PendingReversal",
    Reversed = "Reversed",
}

export enum MarketplaceFulfillmentState {
    Ineligible = "Ineligible",
    Pending = "Pending",
    Processing = "Processing",
    PendingPickup = "PendingPickup",
    InTransit = "InTransit",
    Fulfilled = "Fulfilled",
    Failed = "Failed",
    PendingReshipment = "PendingReshipment",
}

export enum PointOfSaleFulfillmentState {
    Ineligible = "Ineligible",
    Pending = "Pending",
    Processing = "Processing",
    PendingPickup = "PendingPickup",
    InTransit = "InTransit",
    Fulfilled = "Fulfilled",
    Failed = "Failed",
    Resetted = "Resetted",
}

export enum SaleActionType {
    Confirm = "Confirm",
    Fulfill = "Fulfill",
    Reject = "Reject",
    Deallocate = "Deallocate",
    ExpireHold = "ExpireHold",
    Refulfill = "Refulfill",
    EditOffline = "EditOffline",
    Allocate = "Allocate",
    ResetFulfillment = "ResetFulfillment",
    RejectAllocation = "RejectAllocation",
    ConfirmAllocation = "ConfirmAllocation",
    MarkAsFulfilled = "MarkAsFulfilled",
    DownloadUserDocuments = "DownloadUserDocuments",
    Unwaste = "Unwaste",
    EditMarketplaceSale = "EditMarketplaceSale",
    SpoilTickets = "SpoilTickets",
    UnspoilTickets = "UnspoilTickets",
}

export enum PointOfSaleSaleStatus {
    PendingConfirmation = "PendingConfirmation",
    PendingFulfillment = "PendingFulfillment",
    ProcessingFulfillment = "ProcessingFulfillment",
    Fulfilled = "Fulfilled",
    FulfillmentFailed = "FulfillmentFailed",
    PendingRejection = "PendingRejection",
    Rejected = "Rejected",
    Hold = "Hold",
    CancelledHold = "CancelledHold",
    PendingAllocation = "PendingAllocation",
    ProvisionalAllocation = "ProvisionalAllocation",
    PendingReshipment = "PendingReshipment",
    Wasted = "Wasted",
}

export enum TicketType {
    Custom = "Custom",
    Paper = "Paper",
    ETicket = "ETicket",
    ETicketUrl = "ETicketUrl",
    Transfer = "Transfer",
    Barcode = "Barcode",
    Season = "Season",
    QRCode = "QRCode",
    SMPWallet = "SMPWallet",
}

export interface Tag {
    /** The key of of the tag associated with an entity */
    key: string;
    /** The value of the tag associated with an entity */
    value: string;
    valueType: TagsValueType | null;
    singleValueOnly: boolean | null;
    includeInReport: boolean | null;
    ordinal: number | null;
    persistentTagId: number | null;
    saleTagValueInheritModeId: TagValueInheritMode | null;
    sourceEntityId: number | null;
}

export enum TagsValueType {
    String = "String",
    Decimal = "Decimal",
    Int = "Int",
    Boolean = "Boolean",
    Json = "Json",
    Url = "Url",
    Marketplace = "Marketplace",
    Date = "Date",
    POSUser = "POSUser",
    Vendor = "Vendor",
    UserGroup = "UserGroup",
}

export enum TagValueInheritMode {
    SyncLiveValue = "SyncLiveValue",
    CopyValueOnCreate = "CopyValueOnCreate",
    DoNotInherit = "DoNotInherit",
}

export enum MarketplaceContractState {
    Provisional = "Provisional",
    CancelledProvisional = "CancelledProvisional",
    Contracted = "Contracted",
    MarketplaceDispute = "MarketplaceDispute",
    Complete = "Complete",
    CancelledUnknownFault = "CancelledUnknownFault",
    CancelledSellerFault = "CancelledSellerFault",
    CancelledMutual = "CancelledMutual",
    CancelledMarketplaceFault = "CancelledMarketplaceFault",
}

export interface SaleOwnershipInfo {
    fulfillerId: string | null;
    buyerIds: string[];
    pricerIds: string[];
    poInsertBys: string[];
    poIds: number[];
}

export interface SaleCommentNote {
    date: string | null;
    email: string | null;
    text: string | null;
}

export enum SaleCancellationReason {
    EventCancellation = "EventCancellation",
    SellerFault = "SellerFault",
    MarketplaceFault = "MarketplaceFault",
    NoFault = "NoFault",
    Other = "Other",
}

export enum Marketplace {
    StubHub = "StubHub",
    VividSeats = "VividSeats",
    SeatGeek = "SeatGeek",
    TickPick = "TickPick",
    Ticketmaster = "Ticketmaster",
    Offline = "Offline",
    AXS = "AXS",
    FanXchange = "FanXchange",
    Gametime = "Gametime",
    TicketEvolution = "TicketEvolution",
    TicketNetwork = "TicketNetwork",
    Automatiq = "Automatiq",
    Lyte = "Lyte",
    GoTickets = "GoTickets",
    B2BSales = "B2BSales",
    TicketNetworkMercury = "TicketNetworkMercury",
    Wastage = "Wastage",
    ReachPro = "ReachPro",
    Donation = "Donation",
    Gigsberg = "Gigsberg",
}

export interface Seating {
    section: string;
    sectionId: number | null;
    row: string | null;
    rowId: number | null;
    seatFr: string | null;
    seatTo: string | null;
    ticketIds: number[] | null;
    listingIds: number[] | null;
}

export interface ListingNote {
    listingNoteId: number;
    listingNoteText: string;
    listingNoteUntranslated: string;
    sellerAccountId: string | null;
    stubhubListingNoteId: number | null;
    type: ListingNoteType | null;
}

export enum ListingNoteType {
    Defect = "Defect",
    RestrictionOnUse = "Restriction on Use",
    Perk = "Perk",
    Information = "Information",
    ConnectedSeller = "ConnectedSeller",
    InternallyGenerated = "InternallyGenerated",
}

export interface Listing extends MarketplaceEntityWithTickets {
    rowId: number | null;
    entityType: ActionOutboxEntityType;
    dataIsLoaded: { [key in keyof typeof ListingDetailDataField]?: boolean; };
    /** Cost per ticket (from purchase order) */
    unitCst: UiMoney | null;
    status: ListingStatus;
    isUSEvent: boolean | null;
    /** Marketplace listing broadcast status */
    brdcstStatus: ListingBroadcastStatus | null;
    isSeatSaver: boolean;
    isAdminHold: boolean;
    adminHoldExpiredOn: string | null;
    adminHoldNotes: string | null;
    /** ValidPurchaseQuantity - computed value based on Quantity, MaxDisplayQuantity, and SplitType.
Will be an array of values that correspond to how many tickets from the listing buyers are
able to buy in one transaction. */
    vldPurQty: number[];
    /** This the number of tickets that have not yet sold or wasted and is always less than TicketCount. */
    availQty: number;
    /** MaxDisplayQuantity */
    maxDispQty: number;
    /** ManualMaxDisplayQuantity */
    manMaxDispQty: number | null;
    /** This is the number of tickets that have been sold */
    soldQty: number | null;
    /** This is the number of tickets that have been wasted */
    wastedQty: number | null;
    /** This is the number of tickets that are not sold, which is equivalent to AvailQty + WastedQty */
    unsoldQty: number;
    /** A number from 0 to 1 that represent a %
Null represent that the marketplace doesn't provide this info */
    preDelivState: PreDeliveryState;
    /** DeliveryType */
    delivType: DeliveryType;
    /** TopPriorityTicketType */
    topPriTktType: TicketType | null;
    isUndeliv: boolean;
    isNoFulfill: boolean | null;
    enableNativeSync: boolean | null;
    actions: ListingActionType[];
    isCurUserPo: boolean;
    poBys: string[] | null;
    poId: number | null;
    poOrderId: string | null;
    poDate: string | null;
    poVendAccEmail: string | null;
    poCreatedBys: string[] | null;
    isDeleted: boolean;
    mkpListings: MarketplaceListing[] | null;
    qcState: QualityControlState | null;
    pendProofState: PendingProofState | null;
    dupListingId: number | null;
    ignoreDup: boolean | null;
    /** MarketplaceVisibility */
    mkpVis: number | null;
    sectionType: VenueMapSectionType | null;
    /** Original Seat From for the listing, different from Seating.SeatFr which is the current seatFr available */
    orgSeatFr: string | null;
    orgSeatTo: string | null;
    /** Internal notes, which are truncated to 80 characters if it's more than 80 characters. */
    internalNotesPreview: string | null;
    /** Indicates whether the InternalNotesPreview is truncated or not. */
    isInternalNotesPreviewTruncated: boolean | null;
    noteIds: string | null;
    ltGrpId: string | null;
    ltGrpParentId: number | null;
    ltGrpPrior: number | null;
    ltGrpActive: boolean | null;
    isLtGrp: boolean;
    isFull: boolean;
    ltGrpUndercut: ListingGroupUndercutSetting | null;
    tags: Tag[] | null;
    splitType: SplitType;
    hideSeats: boolean;
    pricerId: string | null;
    listPrice: number;
    allInPrice: number;
    faceValue: UiMoney | null;
    lastPrcUpdOn: string | null;
    /** Indicates whether automatic pricing is enabled for this listing.
When true, the listing price will be automatically adjusted based on configured pricing rules and market conditions. */
    isAutoPrc: boolean | null;
    procsFloor: number | null;
    procsCeil: number | null;
    /** UndercutMode */
    undMode: AutoPricingUndercutMode | null;
    /** UndercutAbsoluteAmount */
    undAbsAmt: number | null;
    /** UndercutRelativeAmount */
    undRelAmt: number | null;
    /** UndercutNewPrice */
    undNewPrice: number | null;
    /** CompListingMode */
    compMode: AutoPricingCompListingMode | null;
    /** CompListingFloor */
    compFloor: number | null;
    /** CompLIstingCeiling */
    compCeil: number | null;
    /** IsCompListingQuantityScoreAdjustmentEnabled */
    isCompQtyScrAdj: boolean | null;
    /** CompListingQuantityScoreAdjustmentJson */
    compQtyScrAdjJson: string | null;
    /** CompListingOnlyForSameZoneEnabled */
    isCompForSameZone: boolean | null;
    /** CompListingOnlyForSelectedSectionsEnabled */
    isCompSelectedSections: boolean | null;
    /** CompListingExcludeFanInventory */
    compExclFanInv: boolean | null;
    /** CompListingExcludeDefects */
    compExclDefects: boolean | null;
    /** CompListingSelectedSectionSettings */
    compSectionSettings: SelectedSectionSettings | null;
    /** CircuitBreakerRelativeCeiling */
    cirBrRelCeil: number | null;
    /** CircuitBreakerRelativeFloor */
    cirBrRelFloor: number | null;
    /** CircuitBreakerMaxDiscountVelocityPercent */
    cirBrMaxDiscVelocPercent: number | null;
    /** CircuitBreakerMaxDiscountVelocityTicksInHours */
    cirBrMaxDiscVelocTicksInHrs: number | null;
    /** CircuitBreakerMinCompListingCount */
    cirBrMinCompCount: number | null;
    /** OutlierMode */
    outMode: AutoPricingOutlierMode | null;
    /** OutlierStandardDeviations */
    outlStdDev: number | null;
    /** OutlierKthLowestLimit */
    outKthLowestLim: number | null;
    /** OutlierKthLowestLimitAbsoluteSpacing */
    outKthLowestLimRelSpc: number | null;
    /** OutlierKthLowestLimitRelativeSpacing */
    outKthLowestLimAbsSpc: number | null;
    /** AutoPricingResultState */
    autoPrcResult: AutoPricingResultType | null;
    /** Categorized constraint type for AutoPricing result
Only populated when SurfacePricingStates feature flag is enabled */
    autoPrcConstraintType: AutoPricingConstraintType | null;
    /** The rowversion of the row that indicates when the circuitbreaker was reset for a listing */
    cirBrSuppRowVer: number | null;
    tktTypeRules: TicketTypeOverride | null;
    shownQuantity: number | null;
    wastedCost: UiMoney | null;
    unsoldCost: UiMoney | null;
    soldCost: UiMoney | null;
    totalCst: UiMoney | null;
    unsoldProceeds: number | null;
}

export enum ListingDetailDataField {
    Basic = "Basic",
    Tickets = "Tickets",
    Pricing = "Pricing",
    AutoPricing = "AutoPricing",
    Sales = "Sales",
    Purchase = "Purchase",
    Tags = "Tags",
    InternalNotes = "InternalNotes",
}

export enum ListingStatus {
    Disabled = "Disabled",
    FullySold = "Fully Sold",
    DelistingPending = "Delisting Pending",
    DelistingFailed = "Delist Failed",
    Delisted = "Delisted",
    ListingPending = "Listing Pending",
    ListingFailed = "List Failed",
    Listed = "Listed",
}

export enum ListingBroadcastStatus {
    Unknown = "Unknown",
    Broadcast = "Broadcast",
    BroadcastFailed = "BroadcastFailed",
    BroadcastWithError = "BroadcastWithError",
    Unbroadcast = "Unbroadcast",
    UnbroadcastFailed = "UnbroadcastFailed",
    UnbroadcastWithError = "UnbroadcastWithError",
}

export enum PreDeliveryState {
    NotPreDelivered = "No",
    PreDelivered = "Yes",
}

export enum DeliveryType {
    InApp = "In-app",
    PDF = "PDF",
    Paper = "Paper",
    MemberCard = "Member Card",
    Wallet = "Wallet",
    Custom = "Custom",
}

export enum ListingActionType {
    Broadcast = "Broadcast",
    Unbroadcast = "Unbroadcast",
    Split = "Split",
    SplitToOriginal = "SplitToOriginal",
    AddOfflineSale = "AddOfflineSale",
    AddMarketplaceSale = "AddMarketplaceSale",
    PredeliverBarcodes = "PredeliverBarcodes",
    PredeliverETickets = "PredeliverETickets",
    PredeliverQRCode = "PredeliverQRCode",
    PredeliverExternalIds = "PredeliverExternalIds",
    PredeliverTicketUrls = "PredeliverTicketUrls",
    RedeliverBarcodes = "RedeliverBarcodes",
    RedeliverETickets = "RedeliverETickets",
    RedeliverQRCode = "RedeliverQRCode",
    RedeliverExternalIds = "RedeliverExternalIds",
    RedeliverTicketUrls = "RedeliverTicketUrls",
    DownloadUserDocuments = "DownloadUserDocuments",
    FullySoldNoAction = "FullySoldNoAction",
    AddAdminHold = "AddAdminHold",
    RemoveAdminHold = "RemoveAdminHold",
    Waste = "Waste",
    Donate = "Donate",
}

export interface MarketplaceListing {
    mkpListingId: string | null;
    mkp: Marketplace;
    status: ListingStatus;
    markup: number | null;
    sellerAccountDefaultMarkup: number | null;
    sellerFee: number | null;
    netProcs: number | null;
    webPrice: number | null;
    isPriceByMkp: boolean;
    overrideSection: string | null;
    overrideRow: string | null;
    overrideSeats: string | null;
    overrideRowId: number | null;
    overrideSectionId: number | null;
    isEnabled: boolean;
    availQty: number | null;
    currency: string;
    errMsgs: string[] | null;
    errCodes: BroadcastErrorCode[] | null;
    pendProofState: PendingProofState | null;
    brdcstStatus: ListingBroadcastStatus | null;
}

export enum BroadcastErrorCode {
    Unknown = "Unknown",
    UpdatePrice = "UpdatePrice",
    UpdateTicketType = "UpdateTicketType",
    UpdateSplitType = "UpdateSplitType",
    UpdateInHandDate = "UpdateInHandDate",
    SplitListing = "SplitListing",
    MergeListing = "MergeListing",
    BroadcastListing = "BroadcastListing",
    UnbroadcastListing = "UnbroadcastListing",
    UpdateQuantity = "UpdateQuantity",
    HideSeats = "HideSeats",
    UpdateListingNotes = "UpdateListingNotes",
    UpdateSeating = "UpdateSeating",
    MarketplaceResaleRestricted = "MarketplaceResaleRestricted",
    MarketplaceManifestMismatch = "MarketplaceManifestMismatch",
    MarketplacePriceBelowFloor = "MarketplacePriceBelowFloor",
}

export enum PendingProofState {
    PendingProof = "PendingProof",
    PendingReview = "PendingReview",
    Approved = "Approved",
}

export enum QualityControlState {
    Pending = "Pending",
    Approved = "Approved",
    Rejected = "Rejected",
}

export enum VenueMapSectionType {
    ForcedRow = "ForcedRow",
    OptionalRow = "OptionalRow",
    NoRow = "NoRow",
    GeneralAdmission = "GeneralAdmission",
    NoRowPairs = "NoRowPairs",
    OptionalRowPairs = "OptionalRowPairs",
    ForcedRowPairs = "ForcedRowPairs",
    GeneralAdmissionWithQueueNumber = "GeneralAdmissionWithQueueNumber",
    GeneralAdmissionStanding = "GeneralAdmissionStanding",
    GeneralAdmissionSeating = "GeneralAdmissionSeating",
}

export interface ListingGroupUndercutSetting {
    /** UndercutAbsoluteAmount */
    undAbsAmt: number | null;
    /** UndercutRelativeAmount */
    undRelAmt: number | null;
    /** ActiveRankUndercutAbsoluteAmount */
    actRankUndAbsAmt: number | null;
    /** ActiveRankUndercutRelativeAmount */
    actRankUndRelAmt: number | null;
}

export enum SplitType {
    Any = "Any",
    None = "None",
    AvoidOne = "Avoid One",
    AvoidOneAndThree = "Avoid One and Three",
    Pairs = "Pairs",
}

export enum AutoPricingUndercutMode {
    Simple = "Simple",
    RowExtrapolation = "RowExtrapolation",
    Deal = "Deal",
    AverageOfCheapestListings = "AverageOfCheapestListings",
}

export enum AutoPricingCompListingMode {
    QualityScore = "QualityScore",
    SameSection = "SameSection",
    SameZone = "SameZone",
    SameEvent = "SameEvent",
    ParentListing = "ParentListing",
}

export interface SelectedSectionSettings {
    sectionIdFilter: number[] | null;
    rowIdFilter: number[] | null;
    sectionRowIdFilter: { [key: string]: string; } | null;
    sectionIdFilterFromZoneMap: boolean;
    includeBetterZones: boolean;
    rowOffset: number | null;
    sectionFilterMode: SectionFilterMode | null;
}

export enum SectionFilterMode {
    Custom = "Custom",
    SameSection = "SameSection",
    SameZone = "SameZone",
    AllSections = "AllSections",
}

export enum AutoPricingOutlierMode {
    StandardDeviations = "StandardDeviations",
    SkipLogic = "SkipLogic",
    KthLowest = "KthLowest",
}

export enum AutoPricingResultType {
    None = "None",
    PriceSuccess = "PriceSuccess",
    PriceBelowFloor = "PriceBelowFloor",
    InsufficientComparables = "InsufficientComparables",
    PriceBelowMaxAllowedDrop = "PriceBelowMaxAllowedDrop",
    PriceAboveCeiling = "PriceAboveCeiling",
    MissingUnitCost = "MissingUnitCost",
    MissingSeatScore = "MissingSeatScore",
    MissingZone = "MissingZone",
    CannotCalculateUndercut = "CannotCalculateUndercut",
    EffectiveCeilingBelowFloor = "EffectiveCeilingBelowFloor",
    PriceHitHardFloor = "PriceHitHardFloor",
    PriceHitRelativeFloor = "PriceHitRelativeFloor",
    PriceHitMaxAllowedDrop = "PriceHitMaxAllowedDrop",
    ConfigRowMissing = "ConfigRowMissing",
    SectionUnmapped = "SectionUnmapped",
    AllPriceUpdatesPaused = "AllPriceUpdatesPaused",
    PriceDecreasesPaused = "PriceDecreasesPaused",
}

export enum AutoPricingConstraintType {
    None = "None",
    HardConstraint = "HardConstraint",
    SoftConstraint = "SoftConstraint",
}

export interface TicketTypeOverride {
    overrides: TicketTypeOverrideForDeliveryType[];
}

export interface TicketTypeOverrideForDeliveryType {
    deliveryType: DeliveryType;
    ticketTypePriorities: TicketTypePriority[];
}

export interface TicketTypePriority {
    priority: number;
    ticketType: TicketType;
    isBlocked: boolean;
}

/** Base class of purchase order that has common fields for both request and response. */
export interface PurchaseOrder {
    id: number;
    entityType: ActionOutboxEntityType;
    accId: string | null;
    buyerId: string | null;
    insertBy: string | null;
    commissions: Commission[] | null;
    vendor: PurchaseVendor | null;
    secVendor: PurchaseVendor | null;
    vendAcc: PurchaseVendorAccount | null;
    secVendAcc: PurchaseVendorAccount | null;
    tags: Tag[] | null;
    /** The order number of the purchase from the PurchaseVendor */
    vendOrdId: string | null;
    poState: PurchaseOrderState;
    poDate: string | null;
    /** This is basically the number of ticket groups in this PO. */
    tktGrpCnt: number;
    /** This is for currency-input, */
    currency: string;
    pmtStat: PurchasePaymentStatus | null;
    pmtMethod: PurchasePaymentMethodType | null;
    privNotes: string | null;
    qcState: QualityControlState | null;
    isAutoPo: boolean | null;
    rowVer: number;
    isCommissionsLocked: boolean | null;
    originalCurrencyCode: string | null;
    conversionRate: number | null;
    conversionDate: string | null;
    pmtMtdFullDisp: PurchasePaymentMethod[] | null;
    ticketCnt: number;
    totalPmt: UiMoney | null;
    totalConvertedPmt: UiMoney | null;
    /** Outstanding Balance = TotalCost - (TotalConvertedPaymentAmount / TotalPaymentAmount) */
    outsBal: UiMoney | null;
    pmtConvRate: number | null;
    delivType: DeliveryType | null;
    totalCst: UiMoney | null;
    unitCst: UiMoney | null;
    viagVirtId: string | null;
}

export interface Commission {
    /** Buyer BuyerUserId */
    buyerUserId: string;
    /** The percentage of the commission */
    commissionPercentage: number;
}

export interface PurchaseVendor {
    id: number;
    name: string;
    isGlobal: boolean | null;
    vendAccCounts: number | null;
    delivType: DeliveryType | null;
    isNoFulfill: boolean | null;
    tktTypeRules: TicketTypeOverride | null;
}

export interface PurchaseVendorAccount {
    id: string;
    vendorId: number;
    name: string;
    email: string;
    password: string | null;
    dftPayMethodId: number | null;
    dftBuyerId: string | null;
}

export enum PurchaseOrderState {
    Active = "Active",
    Cancelled = "Cancelled",
    Void = "Void",
    Drafted = "Drafted",
}

export enum PurchasePaymentStatus {
    Unpaid = "Unpaid",
    PartiallyPaid = "Partially Paid",
    Paid = "Paid",
    Failed = "Failed",
    RefundNeeded = "RefundNeeded",
    Refunded = "Refunded",
    PartiallyRefunded = "PartiallyRefunded",
}

export enum PurchasePaymentMethodType {
    PayPal = "PayPal",
    ECheck = "eCheck",
    Check = "Check",
    MoneyOrder = "Money Order",
    Card = "Credit Card",
    Cash = "Cash",
    Credit = "Credit",
    COD = "COD",
    BankTransfer = "Bank Transfer",
    DebitCard = "Debit Card",
    CreditMemo = "Credit Balance",
    DebitNote = "Debit Note",
    Other = "Other",
}

export interface PurchasePaymentMethod {
    id: number;
    display: string;
    name: string;
    type: PurchasePaymentMethodType;
}

export interface PurchaseOrderTicketGroup extends PurchaseOrder {
    /** This is a thin version of ticket group to show in the purchase order table. */
    ticketGroupItems: IPurchaseOrderTicketGroupItem[] | null;
    isTktGrp: boolean | null;
    /** Has user document artifacts to download */
    canGetDocArts: boolean | null;
    tgId: number | null;
    tickets: Ticket[];
    isMultEv: boolean | null;
    seating: Seating | null;
    seatTraits: ListingNote[] | null;
    perfId: number | null;
    venId: number | null;
    entityCatalogData: EntityCatalogData | null;
}

export interface IPurchaseOrderTicketGroupItem {
    /** True if this instance is a ticket group, can be under a purchase order or containing purchase order info */
    isTktGrp: boolean | null;
    /** Has user document artifacts to download */
    canGetDocArts: boolean | null;
    tgId: number | null;
    viagVirtId: string;
    perfId: number | null;
    venId: number | null;
    /** True if this is a multi-event PO */
    isMultEv: boolean | null;
    seating: Seating | null;
    /** If this is a PO (IsTktGrp == false), this is the number of tickets in the whole PO.
Otherwise, this is the number of tickets in this ticket group. */
    ticketCnt: number;
    tickets: Ticket[];
    seatTraits: ListingNote[] | null;
    /** The overall delivery for the PO (if there are several, the first one is listed)
If this is a ticket group, this is the delivery for this ticket group. */
    delivType: DeliveryType | null;
    totalCst: UiMoney | null;
    unitCst: UiMoney | null;
    entityCatalogData: EntityCatalogData | null;
}

export interface Ticket {
    id: number;
    tgId: number;
    ord: number;
    /** This is the order that considers merged listings too, safe to use anywhere
        
NOTE - this is required to be kept Nullable as it should remains Null when setting to the server
making it non-null requires you to handle it or else it will get set to 0 for all seatings and that will have bad consequences */
    lstOrd: number | null;
    row: string | null;
    seat: string;
    barcode: string | null;
    ticketUrl: string | null;
    externalTicketId: string | null;
    eTicket: UserDocumentLinks | null;
    qrCode: UserDocumentLinks | null;
    holdId: number | null;
    spoiledSaleId: number | null;
    saleId: number | null;
    listingId: number | null;
    poId: number | null;
    unitCost: UiMoney | null;
    isWasted: boolean | null;
}

export interface UserDocument {
    entityId: number | null;
    documentId: string;
    pageNumber: number | null;
    pageId: string | null;
    documentType: DocumentType | null;
}

export interface UserDocumentLinks extends UserDocument {
    documentUri: string;
    pageUri: string;
}

/** Catalog data about the event, venue, and performer which can be used to extend other models (Listing, Sale, Ticket Group) to power Opensearch-based search experience which doesn't depend on a separate catalog service call. */
export interface EntityCatalogData {
    eventDateTime: string | null;
    eventName: string | null;
    eventShortName: string | null;
    eventStatus: ApiEventStatus | null;
    eventGenre: TopLevelCategory | null;
    eventSubGenre: number | null;
    venueId: number | null;
    venueName: string | null;
    venueCity: string | null;
    venueCityId: number | null;
    venueStateProvince: string | null;
    venueStateProvinceId: number | null;
    venueCountry: string | null;
    venueCountryCode: string | null;
    performerId: number | null;
    performerName: string | null;
}

export interface EntityWithTicketsQuery {
    entityIds: number[] | null;
    marketplaceEntityIds: string[] | null;
    eventOrMappingIds: string[] | null;
    eventIdsOverride: number[] | null;
    oldPosEventIds: string[] | null;
    performerIds: number[] | null;
    venueIds: number[] | null;
    countryCodes: string[] | null;
    stateProvinceIds: number[] | null;
    cityIds: number[] | null;
    purchaseOrderId: number | null;
    purchaseOrderIds: number[] | null;
    saleIds: number[] | null;
    listingIds: number[] | null;
    purchaseVendorId: number | null;
    vendorAccessControlProviderId: number | null;
    purchaseVendorAccountIds: string[] | null;
    purchaseVendorOrderId: string | null;
    purchaseBuyerId: string | null;
    purchaseOrderCreatedBy: string | null;
    purchaseCommissionUserId: string | null;
    purchaseDates: DateTimeRangeWithRelative | null;
    inHandDates: DateTimeRangeWithRelative | null;
    eventTimeFrameFilter: EventTimeFrameFilter | null;
    sections: string[] | null;
    rows: string[] | null;
    sectionContains: string | null;
    sectionEquals: string | null;
    sectionNotContains: string | null;
    rowContains: string | null;
    rowEquals: string | null;
    rowNotContains: string | null;
    isSeatSaver: boolean | null;
    /** This is currently only used to filter on the frontend application. */
    eventDates: DateTimeRangeWithRelative | null;
    /** This is currently only used to filter on the frontend application. */
    eventNotReviewedSinceDate: DateTimeRangeWithRelative | null;
    isMapped: boolean | null;
    isMappingRejected: boolean | null;
    searchText: string | null;
    /** Filter by boosted status (events with active campaigns).
true = only boosted events, false = only non-boosted events, null = all events.
Server-side filtering applied in GetCatalogCountForListings. */
    isBoosted: boolean | null;
    sortBy: EventSort | null;
    isSortDescending: boolean | null;
    tagName: string | null;
    tagValue: string | null;
    eventTagName: string | null;
    eventTagValue: string | null;
    lastSaleDates: DateTimeRangeWithRelative | null;
    noSaleDates: DateTimeRangeWithRelative | null;
    numberOfTicketsHeld: NumericRange | null;
    topLevelCategories: TopLevelCategory[] | null;
    parentCategories: number[] | null;
    internalNotes: string | null;
    internalNotesContains: string | null;
    internalNotesEquals: string | null;
    internalNotesNotContains: string | null;
    /** Output from the frontend application: `new Date().getTimezoneOffset()`
E.g. UTC-8 => 480
Used for RelativeTimeRange typed properties
Currently only used for reporting */
    timezoneOffsetMins: number | null;
    currencyCode: string | null;
    currencyCodes: string[] | null;
    eventStatuses: ApiEventStatus[] | null;
    /** This is only used to filter on the frontend application. */
    searchConfigId: string | null;
    purchaseVendorIds: number[] | null;
    purchaseBuyerIds: string[] | null;
    purchaseOrderCreatedBys: string[] | null;
    purchaseCommissionUserIds: string[] | null;
}

export interface ListingQuery extends EntityWithTicketsQuery {
    pricerSellerUserId: string | null;
    isPredelivered: boolean | null;
    isListed: boolean | null;
    deliveryType: DeliveryType | null;
    eventHasUnsoldTickets: boolean | null;
    hasUnsoldTickets: boolean | null;
    hasBroadcastError: boolean | null;
    isAutoPricingEnabled: boolean | null;
    isPricedAboveZero: boolean | null;
    lastPriceUpdateDates: DateTimeRangeWithRelative | null;
    lastPriceNoUpdateDates: DateTimeRangeWithRelative | null;
    autoPricingResultTypes: AutoPricingResultType[] | null;
    isSeatingUnmapped: boolean | null;
    isAdminHold: boolean | null;
    isDuplicate: boolean | null;
    hasListingGroupId: boolean | null;
    isPricedByMarketplace: boolean | null;
    isPendingProof: boolean | null;
    purchaseCancellationDates: DateTimeRangeWithRelative | null;
    purchaseCancelledOnly: boolean | null;
    isNoFulfill: boolean | null;
    unitCostHigh: number | null;
    unitCostLow: number | null;
    ticketType: TicketType | null;
    /** This is only used to filter on the frontend application. */
    viewMode: InventoryViewMode | null;
    eventUnpricedStatus: EventUnpricedStatus | null;
}

export interface DateTimeRangeWithRelative extends DateTimeRange {
    relativeStartSecs: number | null;
    relativeEndSecs: number | null;
    roundingMode: RelativeTimeRoundingMode | null;
}

export enum RelativeTimeRoundingMode {
    Day = "Day",
    Week = "Week",
    Month = "Month",
    Year = "Year",
}

export enum InventoryViewMode {
    TileView = "Tile View",
    MetricView = "Metric View",
    FlattenedView = "Flattened View",
}

export enum EventUnpricedStatus {
    AllUnpriced = "All",
    NoneUnpriced = "None",
    AnyUnpriced = "Any",
}

export enum EventTimeFrameFilter {
    Future = "Future Events",
    Past = "Past Events",
}

export enum EventSort {
    Date = "Sort by Date",
    MainDisplay = "Sort by Title",
}

export interface NumericRange {
    start: number | null;
    end: number | null;
}

export interface BulkEditProgress {
    updateKey: string;
    method: string;
    step: BulkEditStep;
    successCount: number;
    failureCount: number;
    warningCount: number;
    totalCount: number;
    status: string | null;
    error: string | null;
    warning: string | null;
    successPercent: number | null;
    failurePercent: number | null;
    warningPercent: number | null;
    countsByEntity: { [key in keyof typeof ActionOutboxEntityType]?: BulkEditCount; };
    retryableEntities: BulkEditPreview | null;
}

export enum BulkEditStep {
    Disabled = "Disabled",
    Initializing = "Initializing",
    InProgress = "InProgress",
    Done = "Done",
    Cancelled = "Cancelled",
    DoneWithRetryableEntities = "DoneWithRetryableEntities",
}

export interface BulkEditCount {
    totalCount: number;
    successCount: number;
    failureCount: number;
    warningCount: number;
    entityType: ActionOutboxEntityType;
    ttlCnt: number;
    succCnt: number;
    failCnt: number;
    warnCnt: number;
}

export enum ListingPriceAdjustmentType {
    CurrentPrice = "CurrentPrice",
    UnitCost = "UnitCost",
}

export enum PricingFloorCeilingAdjustmentType {
    MarketPrice = "MarketPrice",
    UnitCost = "UnitCost",
    CurrentFloor = "CurrentFloor",
}

export interface ValueTupleOfBulkEditPreviewAndListingDetailsUpdateInput {
    item1: BulkEditPreview;
    item2: ListingDetailsUpdateInput;
}

export interface ListingDetailsPricingUpdates {
    netProceedsFloor: number | null;
    netProceedsCeiling: number | null;
    skipPriceProtection: boolean | null;
    skipAutoPricing: boolean | null;
    autoPricingEnabled: boolean | null;
    undercutMode: AutoPricingUndercutMode | null;
    skipUndercut: boolean | null;
    undercutAbsoluteAmount: number | null;
    undercutRelativeAmount: number | null;
    undercutReferenceListingPosition: number | null;
    compListingMode: AutoPricingCompListingMode | null;
    skipCompListing: boolean | null;
    compListingFloor: number | null;
    compListingCeiling: number | null;
    compListingQuantityScoreAdjustmentEnabled: boolean | null;
    compListingQuantityScoreAdjustmentOverrides: { [key: string]: number; } | null;
    compListingQuantityScoreAdjustmentOverrideJson: string | null;
    compListingOnlyForSameZoneEnabled: boolean | null;
    compListingOnlyForSelectedSectionsEnabled: boolean | null;
    compListingExcludeFanInventory: boolean | null;
    compListingExcludeDefects: boolean | null;
    compListingIncludeUnmappedInventory: boolean | null;
    compListingSelectedSectionSettings: SelectedSectionSettings | null;
    compListingQuantityFilters: CompListingQuantity | null;
    skipAdvancePricing: boolean | null;
    circuitBreakerRelativeCeiling: number | null;
    circuitBreakerRelativeFloor: number | null;
    circuitBreakerMaxDiscountVelocityPercent: number | null;
    circuitBreakerMaxDiscountVelocityTicksInHours: number | null;
    circuitBreakerMinCompListingCount: number | null;
    velocityCircuitBreakerStateRowVersion: number | null;
    outlierMode: AutoPricingOutlierMode | null;
    outlierStandardDeviations: number | null;
    outlierKthLowestLimit: number | null;
    outlierKthLowestLimitRelativeSpacing: number | null;
    outlierKthLowestLimitAbsoluteSpacing: number | null;
    currencyCode: string | null;
}

export interface ListingDetailsUpdateInput extends ListingDetailsPricingUpdates {
    id: number;
    rowVersion: number | null;
    adminHoldExpirationDate: string | null;
    adminHoldNotes: string | null;
    marketplaceSeatOverrides: ListingMarketplaceSeatingOverride[];
    splitType: SplitType | null;
    hideSeatsFromMarketplace: boolean | null;
    faceValue: number | null;
    inHandDate: string | null;
    daysBeforeEvent: number | null;
    section: string | null;
    sectionId: number | null;
    row: string | null;
    rowId: number | null;
    internalNotes: string | null;
    ticketTypeRules: TicketTypeOverride | null;
    manualMaxDisplayQuantity: number | null;
    isNoFulfill: boolean | null;
    enableNativeSync: boolean | null;
    seatTraits: ListingNote[] | null;
    delivType: DeliveryType | null;
    updateSalesOfListings: boolean | null;
    pricerSellerUserId: string | null;
    listPrice: number | null;
    allInPrice: number | null;
    buyerUserId: string | null;
    marketplacePriceUpdates: ListingMarketplacePriceUpdateInput[];
    tags: Tag[] | null;
}

export interface ListingMarketplaceSeatingOverride {
    marketplace: Marketplace;
    overrideSection: string | null;
    overrideRow: string | null;
    overrideSeats: string | null;
    overrideRowId: number | null;
    overrideSectionId: number | null;
}

export interface ListingMarketplacePriceUpdateInput {
    listPrice: number | null;
    allInPrice: number | null;
    priceByMarketplace: boolean;
    marketplace: Marketplace;
    markup: number | null;
}

export interface CompListingQuantity {
    exactQuantities: number[];
    greaterThanOrEqualToQuantity: number | null;
}

export interface ValueTupleOfBulkEditPreviewAndListingDetailsAutoPricingSectionUpdatesV2 {
    item1: BulkEditPreview;
    item2: ListingDetailsAutoPricingSectionUpdatesV2;
}

export interface ListingDetailsAutoPricingSectionUpdatesV2 {
    id: number;
    rowVersion: number | null;
    currencyCode: string | null;
    netProceedsFloor: PosFieldOfNullableDecimal | null;
    netProceedsCeiling: PosFieldOfNullableDecimal | null;
    netProceedsFloorAdjustmentType: PricingFloorCeilingAdjustmentType | null;
    netProceedsFloorAdjustmentAmount: number | null;
    netProceedsFloorAdjustmentRelative: boolean | null;
    autoPricingEnabled: PosFieldOfNullableBoolean | null;
    undercutMode: PosFieldOfNullableAutoPricingUndercutMode | null;
    undercutAbsoluteAmount: PosFieldOfNullableDecimal | null;
    undercutRelativeAmount: PosFieldOfNullableDecimal | null;
    undercutReferenceListingPosition: PosFieldOfNullableInteger | null;
    compListingMode: PosFieldOfNullableAutoPricingCompListingMode | null;
    compListingFloor: PosFieldOfNullableDecimal | null;
    compListingCeiling: PosFieldOfNullableDecimal | null;
    compListingQuantityScoreAdjustmentEnabled: PosFieldOfNullableBoolean | null;
    compListingQuantityScoreAdjustmentOverrideJson: PosFieldOfString | null;
    compListingOnlyForSameZoneEnabled: PosFieldOfNullableBoolean | null;
    compListingOnlyForSelectedSectionsEnabled: PosFieldOfNullableBoolean | null;
    compListingExcludeFanInventory: PosFieldOfNullableBoolean | null;
    compListingExcludeDefects: PosFieldOfNullableBoolean | null;
    compListingIncludeUnmappedInventory: PosFieldOfNullableBoolean | null;
    compListingSelectedSectionSettings: PosFieldOfSelectedSectionSettings | null;
    includeExistingSelectedSections: boolean | null;
    venueZoneMapName: string | null;
    deriveCompsFromVenueZoneConfig: boolean | null;
    includeBetterZones: boolean | null;
    rowCompOffset: number | null;
    useDefaultQuantityFilters: boolean | null;
    circuitBreakerRelativeCeiling: PosFieldOfNullableDecimal | null;
    circuitBreakerRelativeFloor: PosFieldOfNullableDecimal | null;
    circuitBreakerMaxDiscountVelocityPercent: PosFieldOfNullableDecimal | null;
    circuitBreakerMaxDiscountVelocityTicksInHours: PosFieldOfNullableLong | null;
    circuitBreakerMinCompListingCount: PosFieldOfNullableInteger | null;
    outlierMode: PosFieldOfNullableAutoPricingOutlierMode | null;
    outlierStandardDeviations: PosFieldOfNullableDecimal | null;
    outlierKthLowestLimit: PosFieldOfNullableInteger | null;
    outlierKthLowestLimitRelativeSpacing: PosFieldOfNullableDecimal | null;
    outlierKthLowestLimitAbsoluteSpacing: PosFieldOfNullableDecimal | null;
    previewMarketPrices: { [key: string]: number; } | null;
}

export interface PosFieldOfNullableDecimal {
    value: number | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableBoolean {
    value: boolean | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableAutoPricingUndercutMode {
    value: AutoPricingUndercutMode | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableInteger {
    value: number | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableAutoPricingCompListingMode {
    value: AutoPricingCompListingMode | null;
    hasChanged: boolean;
}

export interface PosFieldOfString {
    value: string | null;
    hasChanged: boolean;
}

export interface PosFieldOfSelectedSectionSettings {
    value: SelectedSectionSettings | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableLong {
    value: number | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableAutoPricingOutlierMode {
    value: AutoPricingOutlierMode | null;
    hasChanged: boolean;
}

export interface BulkListingPriceCalculationResult {
    listingPriceCalculations: BulkListingPriceCalculation[];
    compListings: CompListing[];
    sellerCompListings: CompListing[];
    sellerAccountPosListingIds: number[];
}

export interface BaseListingPriceCalculation {
    listingId: number;
    websitePrice: UiMoney | null;
    autoPricingResultType: AutoPricingResultType | null;
    autoPricingConstraintType: AutoPricingConstraintType | null;
    errorMessage: string | null;
    underCutChosenListingId: number | null;
    /** Computed Floor, includes premiums */
    cmpFlr: UiMoney | null;
    /** Computed Ceiling, includes premiums */
    cmpCeil: UiMoney | null;
    /** UndercutAbsolute amount */
    udrAbs: number | null;
    /** UndercutRelative amount */
    udrRel: number | null;
    /** UndercutAbsolute Rank Premium */
    udrAbsPrm: number | null;
    /** UndercutRelative Rank Premium */
    udrRelPrm: number | null;
    /** NewPriceIncludeFanInventory - Calculated undercut price including fan inventory listings */
    newPrcInclFanInv: number | null;
    /** UndercutReferenceListingIds - List of listing Ids that were considered for undercutting */
    udrRefLstIds: number[] | null;
    /** UndercutReferencePrice - Calculated price to undercut, based on the undercut reference listings */
    udrRefPrc: UiMoney | null;
    /** SellerAccountPosListingIds - POS Listing Ids that are filtered with the price calculation comp criteria */
    sellerAccountPosListingIds: number[];
}

export interface BulkListingPriceCalculation extends BaseListingPriceCalculation {
    compStubHubListingIds: number[];
    outlierStubHubListingIds: number[];
    sellerCompStubHubListingIds: number[];
}

export interface CompListing {
    listingId: number;
    availableTickets: number | null;
    rowId: number | null;
    section: string | null;
    row: string | null;
    seatFrom: string | null;
    seatTo: string | null;
    sellerNetProceeds: UiMoney | null;
    sellerNetProceedsInUSD: UiMoney | null;
    sellerAllInPrice: UiMoney | null;
    currencyCode: string | null;
    listingNotes: ListingNote[] | null;
    isWithoutOutlier: boolean | null;
    isAnchor: boolean | null;
    isSellerCompListing: boolean | null;
    isFanInventory: boolean | null;
    validPurchaseQuantities: number[];
}

export interface ValueTupleOfInt64OfAndListingPriceCalculationsInEventInput {
    item1: number[];
    item2: ListingPriceCalculationsInEventInput;
}

export interface ListingPriceCalculationsInEventInput {
    compListingSetting: CompListingSettingUpdate;
    underCutSetting: UnderCutSettingUpdate;
    outlierSetting: OutlierSettingUpdate;
    netProceedsFloor: PosFieldOfNetProceedsFloorAdjustment | null;
    netProceedsCeiling: PosFieldOfUiMoney | null;
    rankPremium: PosFieldOfRankPremiumAdjustment | null;
    velocityCircuitBreakerStateMaxRowVersion: number | null;
}

export interface CompListingSettingUpdate {
    mode: PosFieldOfNullableAutoPricingCompListingMode | null;
    selectedSectionSettings: PosFieldOfSelectedSectionSettings | null;
    includeExistingSelectedSectionSettings: PosFieldOfNullableBoolean | null;
    onlyForSelectedSectionsEnabled: PosFieldOfNullableBoolean | null;
    quantityFilters: PosFieldOfCompListingQuantity | null;
    excludeFanInventory: PosFieldOfNullableBoolean | null;
    excludeDefects: PosFieldOfNullableBoolean | null;
    includeUnmappedInventory: PosFieldOfNullableBoolean | null;
}

export interface PosFieldOfCompListingQuantity {
    value: CompListingQuantity | null;
    hasChanged: boolean;
}

export interface UnderCutSettingUpdate {
    mode: PosFieldOfNullableAutoPricingUndercutMode | null;
    underCutAbsoluteAmount: PosFieldOfUiMoney | null;
    underCutRelativeAmount: PosFieldOfNullableDecimal | null;
    referenceListingPosition: PosFieldOfNullableInteger | null;
}

export interface PosFieldOfUiMoney {
    value: UiMoney | null;
    hasChanged: boolean;
}

export interface OutlierSettingUpdate {
    mode: PosFieldOfNullableAutoPricingOutlierMode | null;
    standardDeviations: PosFieldOfNullableDecimal | null;
    outlierLimit: PosFieldOfNullableInteger | null;
    absoluteOutlierSpacing: PosFieldOfUiMoney | null;
    relativeOutlierSpacing: PosFieldOfNullableDecimal | null;
}

export interface PosFieldOfNetProceedsFloorAdjustment {
    value: NetProceedsFloorAdjustment | null;
    hasChanged: boolean;
}

export interface NetProceedsFloorAdjustment {
    relativeAdjustmentType: PricingFloorCeilingAdjustmentType | null;
    absoluteAmount: UiMoney | null;
    relativeAmount: UiMoney | null;
    relativePercentage: number | null;
}

export interface PosFieldOfRankPremiumAdjustment {
    value: RankPremiumAdjustment | null;
    hasChanged: boolean;
}

export interface RankPremiumAdjustment {
    absoluteAmount: UiMoney | null;
    relativePercentage: number | null;
}

export interface ValueTupleOfBulkEditPreviewAndListingPricesUpdateInput {
    item1: BulkEditPreview;
    item2: ListingPricesUpdateInput;
}

export interface ListingPricesUpdateInput {
    id: number;
    listPrice: number | null;
    allInPrice: number | null;
    netProceedsFloor: number | null;
    netProceedsCeiling: number | null;
    autoPricingEnabled: boolean | null;
    marketplacePriceUpdates: ListingMarketplacePriceUpdateInput[];
}

export interface ValueTupleOfBulkEditPreviewAndISetOfMarketplaceAndISetOfMarketplace {
    item1: BulkEditPreview;
    item2: Marketplace[];
    item3: Marketplace[];
}

export interface ValueTupleOfBulkEditPreviewAndDeliveryTypeAndIListOfTicketTypePriority {
    item1: BulkEditPreview;
    item2: DeliveryType;
    item3: TicketTypePriority[];
}

export interface MergeListingGroupInputList {
    mergeListingGroupInputs: MergeListingGroupInput[];
}

export interface MergeListingGroupInput {
    listingGroupId: string;
    name: string;
    viagogoEventId: number | null;
    viagogoMappingId: string | null;
    desiredActiveListings: number | null;
    minActiveListings: number | null;
    maxActiveListings: number | null;
    targetPercentage: number | null;
    deprioritizedQuantities: string[] | null;
    listingGroupItems: ListingGroupItemInput[];
    groupUndercutSetting: ListingGroupUndercutSetting | null;
    marketplaceSettings: ListingGroupListingMarketplaceSettings | null;
    groupingMethods: ListingGroupingMethods | null;
    /** If true, the listing should pull pricing settings down from the group */
    inheritListingGroupSettings: boolean | null;
    /** If true, the listing should maintain pricing stagger */
    maintainPriceStagger: boolean | null;
}

export interface ListingGroupItemInput {
    listingId: number;
    priority: number;
    groupId: string | null;
    undercutSetting: ListingGroupUndercutSetting | null;
}

export interface ListingGroupListingMarketplaceSettings {
    listingMarketplaceSettings: { [key: string]: ListingMarketplaceSetting; } | null;
}

export interface ListingMarketplaceSetting {
    listingBroadcastStateId: number;
}

export interface ListingGroupingMethods {
    groupingMethods: ListingGroupingMethod[];
}

export interface ListingGroupingMethod {
    groupingOrder: number;
    groupingType: GroupingType;
    groupingValue: string | null;
    numberOfBucket: number | null;
    bucketType: BucketType | null;
}

export enum GroupingType {
    None = "None",
    Zone = "Zone",
    Section = "Section",
    Row = "Row",
    SeatScore = "SeatScore",
    Quantity = "Quantity",
    UnitCost = "UnitCost",
    Custom = "Custom",
}

export enum BucketType {
    None = "None",
    Clusters = "Clusters",
    SameSize = "SameSize",
}

export interface AutoGroupListingV2Input {
    mode: AutoCompAndAutoGroupMode;
    viagogoEventId: number;
    eventListingIds: number[];
    zoneSectionAreaGroupLookupJson: string;
    /** Determines how the row ordinal comps will be determinedjd */
    rowCompOffset: number;
    /** Determines how the RowArea names will be determined */
    rowGroupSetting: RowGroupSetting;
    venueZoneConfigType: VenueZoneConfigType;
    combineCornersAndEnds: boolean;
    rowCompOverrides: RowCompOverride[];
    useCustomRank: boolean;
    mergeListingGroupInputs: MergeListingGroupInput[] | null;
}

export enum AutoCompAndAutoGroupMode {
    AutoComp = "AutoComp",
    AutoGroup = "AutoGroup",
    AutoCompAndAutoGroup = "AutoCompAndAutoGroup",
}

export enum RowGroupSetting {
    SingleTwoToFiveSixPlus = "SingleTwoToFiveSixPlus",
    OneToFiveSixPlus = "OneToFiveSixPlus",
    OneToTenElevenPlus = "OneToTenElevenPlus",
    AllRows = "AllRows",
    OneTwoToFiveSixToTwelveThirteenPlus = "OneTwoToFiveSixToTwelveThirteenPlus",
}

export enum VenueZoneConfigType {
    Amphitheater = "Amphitheater",
    ConcertsSectionsBehindStage = "ConcertsSectionsBehindStage",
    SportsOrConcertsWith360 = "SportsOrConcertsWith360",
}

export interface RowCompOverride {
    rowOrdinalFrom: number;
    rowOrdinalTo: number;
    offsetOverride: number;
}

export interface ValueTupleOfBulkEditPreviewAndIListOfCommission {
    item1: BulkEditPreview;
    item2: Commission[];
}

export interface ValueTupleOfBulkEditPreviewAndIListOfListingNote {
    item1: BulkEditPreview;
    item2: ListingNote[];
}

export interface TicketBarcodeResponse {
    ticketId: number;
    barcode: string | null;
    section: string | null;
    row: string | null;
    seat: string | null;
}

export interface TicketBarcode {
    ticketId: number;
    barcode: string;
    section: string | null;
    row: string | null;
    seat: string | null;
}

export interface ImportFileResult {
    startedInBackground: boolean;
    success: boolean;
    successCount: number;
    failureCount: number;
    warningCount: number;
    totalCount: number;
    errors: string[];
    warnings: string[];
    errorRows: number[];
}

export interface ValueTupleOfBulkEditPreviewAndIDictionaryOfLongAndListOfInteger {
    item1: BulkEditPreview;
    item2: { [key: string]: number[]; };
}

export interface BulkEditListingGroupSettingsInput {
    viagogoEventId: number | null;
    desiredActiveListings: number | null;
    deprioritizedQuantities: string[] | null;
    groupUndercutSetting: ListingGroupUndercutSetting | null;
    marketplaceSettings: ListingGroupListingMarketplaceSettings | null;
    autoPricingInputs: AutoPricingInputs | null;
    listingGroupListingIds: number[] | null;
}

export interface AutoPricingInputs {
    autoPriceFrequency: number | null;
    scoreModel: ScoreModel | null;
    venueZoneConfigType: VenueZoneConfigType | null;
    venueZoneOverrideId: number | null;
    autoPricingDefaultQuantityFiltersJson: string | null;
    undercutMode: AutoPricingUndercutMode | null;
    undercutAbsoluteAmount: number | null;
    undercutRelativeAmount: number | null;
    undercutReferenceListingPosition: number | null;
    compListingMode: AutoPricingCompListingMode | null;
    compListingFloor: number | null;
    compListingCeiling: number | null;
    compListingQuantityScoreAdjustmentEnabled: boolean | null;
    compListingQuantityScoreAdjustmentOverrides: { [key: string]: number; } | null;
    compListingQuantityScoreAdjustmentOverrideJson: string | null;
    compListingOnlyForSameZoneEnabled: boolean | null;
    compListingOnlyForSelectedSectionsEnabled: boolean | null;
    compListingExcludeFanInventory: boolean | null;
    compListingExcludeDefects: boolean | null;
    compListingIncludeUnmappedInventory: boolean | null;
    compListingSelectedSectionSettings: SelectedSectionSettings | null;
    compListingQuantityFilters: CompListingQuantity | null;
    circuitBreakerRelativeCeiling: number | null;
    circuitBreakerRelativeFloor: number | null;
    circuitBreakerMaxDiscountVelocityPercent: number | null;
    circuitBreakerMaxDiscountVelocityTicksInHours: number | null;
    circuitBreakerMinCompListingCount: number | null;
    outlierMode: AutoPricingOutlierMode | null;
    outlierStandardDeviations: number | null;
    outlierKthLowestLimit: number | null;
    outlierKthLowestLimitRelativeSpacing: number | null;
    outlierKthLowestLimitAbsoluteSpacing: number | null;
}

export enum ScoreModel {
    Model1 = "Model1",
    Model2 = "Model2",
    Model3 = "Model3",
    Model4 = "Model4",
    VenueGeometry = "VenueGeometry",
    MergedVenueGeometry = "MergedVenueGeometry",
    Bezier = "Bezier",
    AdvancedVenueGeometry = "AdvancedVenueGeometry",
    BespokeBaseball = "BespokeBaseball",
    SqsClassifier = "sqsClassifier",
}

export interface BulkEditLog {
    entityType: ActionOutboxEntityType;
    bulkActionType: BulkActionType;
    bulkProcessingId: string;
    payload: BulkEditLogPayload;
    sellerUserId: string | null;
    startDate: string;
    endDate: string | null;
}

/** Enum used when saving bulk action logs and then retrieving them by action type for display. */
export enum BulkActionType {
    GroupListings = "GroupListings",
    ChangeEvent = "ChangeEvent",
    AdminHold = "AdminHold",
    MarkAsFulfilled = "MarkAsFulfilled",
    CancelPurchase = "CancelPurchase",
    DeleteTicketGroup = "DeleteTicketGroup",
    UploadPurchaseFile = "UploadPurchaseFile",
    BackfillDeliverySettings = "BackfillDeliverySettings",
    ConvertPurchasePayment = "ConvertPurchasePayment",
    WasteTickets = "WasteTickets",
    MergeSelectedListings = "MergeSelectedListings",
    UploadSeatSaversFile = "UploadSeatSaversFile",
    UpdateBroadcastSettings = "UpdateBroadcastSettings",
    UpdatePrices = "UpdatePrices",
    UpdateTagValues = "UpdateTagValues",
    UpdatePriceFloorCeiling = "UpdatePriceFloorCeiling",
    UpdateAutoPricingSettings = "UpdateAutoPricingSettings",
    UpdateGeneralSettings = "UpdateGeneralSettings",
    UpdateMarketplaceSeating = "UpdateMarketplaceSeating",
    UpdateTicketTypeRules = "UpdateTicketTypeRules",
    UpdateBuyerCommissions = "UpdateBuyerCommissions",
    UpdateInternalNotes = "UpdateInternalNotes",
    UpdateIsNoFulfill = "UpdateIsNoFulfill",
    UpdateDeliveryType = "UpdateDeliveryType",
    UpdateSeatTraits = "UpdateSeatTraits",
    UpdateMarketplacePrices = "UpdateMarketplacePrices",
    UpdatePurchaseCurrency = "UpdatePurchaseCurrency",
    UpdateBarcodes = "UpdateBarcodes",
    UpdateSaleFulfiller = "UpdateSaleFulfiller",
    DeleteSeatSavers = "DeleteSeatSavers",
    RemovePredelivery = "RemovePredelivery",
    ResetMergedListings = "ResetMergedListings",
    UngroupListings = "UngroupListings",
    EditListingGroupSetting = "EditListingGroupSetting",
    MarkPurchaseAsPaid = "MarkPurchaseAsPaid",
    MarkSaleAsPaid = "MarkSaleAsPaid",
    CancelSale = "CancelSale",
    AdjustCost = "AdjustCost",
    ReturnTicket = "ReturnTicket",
    SplitListings = "SplitListings",
}

export interface BulkEditLogPayload {
    method: string;
    latestStep: BulkEditStep;
    errors: string[];
    warnings: string[];
    entitiesByType: { [key in keyof typeof ActionOutboxEntityType]?: BulkEditCountWithId; };
    filterQuery: EntityWithTicketsQuery | null;
    /** Free form dict to save all params that we can */
    params: any | null;
    startDate: string;
    endDate: string;
}

export interface BulkEditCountWithId extends BulkEditCount {
    skipCount: number;
    idsToBeProcessed: string[];
    idsSkipped: string[];
    idsSuccessful: string[];
    idsFailed: string[];
    idsWarning: string[];
    idsToRetry: string[];
}

export interface BulkEditLogQuery {
    startDates: DateTimeRangeWithRelative | null;
    entityType: ActionOutboxEntityType | null;
    bulkActionTypes: BulkActionType[];
    timezoneOffsetMins: number | null;
}

export interface PurchaseOrderQuery extends EntityWithTicketsQuery {
    ticketGroupIds: number[] | null;
    purchaseMonths: string[] | null;
    /** Payment method type */
    paymentMethod: PurchasePaymentMethodType | null;
    paymentStatus: PurchasePaymentStatus | null;
    paymentDates: DateTimeRangeWithRelative | null;
    totalCostHigh: number | null;
    totalCostLow: number | null;
    unitCostHigh: number | null;
    unitCostLow: number | null;
    deliveryType: DeliveryType | null;
    purchaseOrderState: PurchaseOrderState | null;
    /** This is only used to filter on the frontend application. */
    viewMode: PurchaseViewMode | null;
    /** Exact payment method used */
    paymentMethodId: number | null;
    paymentCurrencyCodes: string[] | null;
    isConsignment: boolean | null;
}

export enum PurchaseViewMode {
    TileView = "Tile View",
    FlattenedView = "Flattened View",
    EventTileView = "Event Tile View",
}

export interface ValueTupleOfBulkEditPreviewAndPosFieldOfNullableGuid {
    item1: BulkEditPreview;
    item2: PosFieldOfNullableGuid;
}

export interface PosFieldOfNullableGuid {
    value: string | null;
    hasChanged: boolean;
}

export interface ValueTupleOfBulkEditPreviewAndString {
    item1: BulkEditPreview;
    item2: string;
}

export interface ValueTupleOfBulkEditPreviewAndNullableSaleCancellationReason {
    item1: BulkEditPreview;
    item2: SaleCancellationReason | null;
}

export enum BulkChangePriceMode {
    Increase = "Increase",
    Decrease = "Decrease",
    Override = "Override",
}

export enum BulkAdjustCostField {
    UnitCost = "UnitCost",
    TotalTicketCost = "TotalTicketCost",
    PurchaseOrderUnitCost = "PurchaseOrderUnitCost",
    PurchaseOrderTotalCost = "PurchaseOrderTotalCost",
}

export interface SaleQuery extends EntityWithTicketsQuery {
    soldOnMarketplace: Marketplace | null;
    saleStatus: PointOfSaleSaleStatus | null;
    saleStatuses: PointOfSaleSaleStatus[] | null;
    fulfillmentStates: PointOfSaleFulfillmentState[] | null;
    paymentState: PointOfSalePaymentState | null;
    marketplacePaymentState: MarketplacePaymentState | null;
    paymentReceived: boolean | null;
    paymentReferenceId: string | null;
    paymentDates: DateTimeRangeWithRelative | null;
    fulfillmentDates: DateTimeRangeWithRelative | null;
    cancellationDates: DateTimeRangeWithRelative | null;
    saleDates: DateTimeRangeWithRelative | null;
    ticketType: TicketType | null;
    fulfillerSellerUserId: string | null;
    listingInsertBy: string | null;
    isNoFulfill: boolean | null;
    unitCostHigh: number | null;
    unitCostLow: number | null;
    /** This is only used to filter on the frontend application. */
    viewMode: SalesViewMode | null;
}

export enum SalesViewMode {
    TileView = "Tile View",
    FlattenedView = "Flattened View",
}

export interface ValueTupleOfBulkEditPreviewAndSaleInput {
    item1: BulkEditPreview;
    item2: SaleInput;
}

export interface SaleInput {
    saleId: number;
    ticketType: PosFieldOfNullableTicketType | null;
    fulfillerSellerUserId: PosFieldOfNullableGuid | null;
    internalNotes: PosFieldOfString | null;
    tags: PosFieldArrayOfTag | null;
    lineItems: PosFieldArrayOfSaleLineItem | null;
    marketplacePaymentLines: PosFieldArrayOfSiteMarketplacePaymentLineInput | null;
    paymentReceived: PosFieldOfNullableBoolean | null;
    paymentReferenceId: PosFieldOfString | null;
    lastPaymentDate: PosFieldOfNullableDateTime | null;
    paymentAmountReceived: PosFieldOfNullableDecimal | null;
    paymentCurrency: PosFieldOfString | null;
    disableAutoSourcing: PosFieldOfNullableBoolean | null;
    isNoFulfill: PosFieldOfNullableBoolean | null;
    commissions: PosFieldArrayOfCommission | null;
    cancellationReason: PosFieldOfNullableSaleCancellationReason | null;
}

export interface PosFieldOfNullableTicketType {
    value: TicketType | null;
    hasChanged: boolean;
}

/** Note - doing PosFieldArray so it can be property generated to React TypeScript */
export interface PosFieldArrayOfTag {
    value: Tag[] | null;
    hasChanged: boolean;
}

/** Note - doing PosFieldArray so it can be property generated to React TypeScript */
export interface PosFieldArrayOfSaleLineItem {
    value: SaleLineItem[] | null;
    hasChanged: boolean;
}

export interface SaleLineItem {
    id: number;
    saleId: number;
    status: SaleLineItemStatus;
    costType: SaleCostType;
    costDate: string | null;
    dueDate: string | null;
    cost: number;
    currencyCode: string;
    description: string | null;
    saleLineItemChargeReason: SaleLineItemChargeReason | null;
    saleLineItemCreditReason: SaleLineItemCreditReason | null;
    marketplacePaymentLineId: number | null;
    isMarketplacePaymentLocked: boolean | null;
    paymentReceived: boolean | null;
    paymentReferenceId: string | null;
}

export enum SaleLineItemStatus {
    Paid = "Paid",
    Unpaid = "Unpaid",
}

export enum SaleCostType {
    Charge = "Charge",
    Credit = "Credit",
    Proceeds = "Proceeds",
    Taxes = "Taxes",
}

export enum SaleLineItemChargeReason {
    CancelledProceeds = "CancelledProceeds",
    DroppedOrderPenalty = "DroppedOrderPenalty",
    Compensation = "Compensation",
    Other = "Other",
}

export enum SaleLineItemCreditReason {
    ReversedPenalty = "ReversedPenalty",
    ReversedCharge = "ReversedCharge",
    ProceedRepayment = "ProceedRepayment",
    Other = "Other",
}

/** Note - doing PosFieldArray so it can be property generated to React TypeScript */
export interface PosFieldArrayOfSiteMarketplacePaymentLineInput {
    value: SiteMarketplacePaymentLineInput[] | null;
    hasChanged: boolean;
}

export interface SiteMarketplacePaymentLineInput {
    marketplacePaymentLineId: number | null;
    marketplacePaymentId: number | null;
    externalPaymentId: string;
    externalPaymentLineId: string;
    externalSaleId: string;
    saleId: number | null;
    currency: string;
    amount: number;
    isCredit: boolean;
    paymentLineType: MarketplacePaymentLineType;
    paymentState: MarketplacePaymentState | null;
    paymentDate: string | null;
    receivedDate: string | null;
    isLocked: boolean | null;
}

export enum MarketplacePaymentLineType {
    Credit = "Credit",
    Proceeds = "Proceeds",
    FullPrice = "FullPrice",
    SellerFee = "SellerFee",
    Penalty = "Penalty",
    AlternativeTickets = "AlternativeTickets",
    OrderNotFulfilled = "OrderNotFulfilled",
    CancelledEvent = "CancelledEvent",
    WitheldFunds = "WitheldFunds",
    LastMinuteSalesLateDelivery = "LastMinuteSalesLateDelivery",
    ExpiredShippingLabel = "ExpiredShippingLabel",
    DeliveryMethodChange = "DeliveryMethodChange",
    BuyerDeniedEntry = "BuyerDeniedEntry",
    WrongTicketsReturnShippingCost = "WrongTicketsReturnShippingCost",
    EarlyShippingLabelGeneration = "EarlyShippingLabelGeneration",
    WrongTrackingNumber = "WrongTrackingNumber",
    ExcessiveFailureRate = "ExcessiveFailureRate",
    SellerError = "SellerError",
    AlternativeTicketsBuyerCompensation = "AlternativeTicketsBuyerCompensation",
    RAGSellerFaultNoResponse = "RAGSellerFaultNoResponse",
    OverchargedSeller = "OverchargedSeller",
    ShippingRefund = "ShippingRefund",
    SellerRelationship = "SellerRelationship",
    RAGDeliveryDispute = "RAGDeliveryDispute",
    CSError = "CSError",
    LMSError = "LMSError",
    TaxRefund = "TaxRefund",
    Other = "Other",
    Charge = "Charge",
}

export interface PosFieldOfNullableDateTime {
    value: string | null;
    hasChanged: boolean;
}

/** Note - doing PosFieldArray so it can be property generated to React TypeScript */
export interface PosFieldArrayOfCommission {
    value: Commission[] | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableSaleCancellationReason {
    value: SaleCancellationReason | null;
    hasChanged: boolean;
}

export interface SalesFulfillerBackfillQuery {
    venueIds: number[] | null;
    eventId: number | null;
    fulfillerSellerUserId: string;
}

export interface ValueTupleOfBulkEditPreviewAndGuid {
    item1: BulkEditPreview;
    item2: string;
}

export interface ValueTupleOfIListOfIntegerAndIListOfInteger {
    item1: number[];
    item2: number[];
}

export interface BaseClientResponse {
    success: boolean;
    errorMessage: string | null;
    validationErrors: ValidationError[] | null;
}

export interface ValidationError {
    field: string;
    message: string;
    code: string;
}

export interface SponsoredListingsCampaignInput {
    /** The Viagogo Event ID associated with this campaign.
NOTE: unmapped event are not allowed to be boosted. */
    eventId: number;
    campaignId: number;
    dateRange: DateTimeRange;
    campaignName: PosFieldOfString;
    recurringFlightBudget: PosFieldOfNullableDecimal;
    currentFlightBudget: PosFieldOfNullableDecimal;
    flightDuration: PosFieldOfNullableFlightDuration;
    biddingMode: PosFieldOfNullableBiddingMode;
    baseBid: PosFieldOfNullableDecimal;
    targetTicketClassIds: PosFieldOfIListOfInteger;
    firstThreeRowsOnly: PosFieldOfNullableBoolean;
    editBudgetForActiveFlightOnly: PosFieldOfNullableBoolean;
}

export interface PosFieldOfNullableFlightDuration {
    value: FlightDuration | null;
    hasChanged: boolean;
}

export enum FlightDuration {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
}

export interface PosFieldOfNullableBiddingMode {
    value: BiddingMode | null;
    hasChanged: boolean;
}

export enum BiddingMode {
    Automatic = "Automatic",
    Manual = "Manual",
}

export interface PosFieldOfIListOfInteger {
    value: number[] | null;
    hasChanged: boolean;
}

export interface UpdateCampaignStateClientResponse extends BaseClientResponse {
}

export enum AdCampaignState {
    Active = "Active",
    Paused = "Paused",
    Deleted = "Deleted",
}

export interface SponsoredListingsCampaign {
    /** The Viagogo Event ID associated with this campaign.
NOTE: unmapped event are not allowed to be boosted. */
    eventId: number;
    performerId: number | null;
    campaignName: string;
    campaignId: number;
    totalBudget: number | null;
    totalSpend: number | null;
    baseBid: number | null;
    maxBid: number | null;
    recurringFlightBudget: number | null;
    flightDuration: FlightDuration | null;
    dateRange: DateTimeRange;
    biddingMode: BiddingMode;
    targetTicketClassIds: number[] | null;
    firstThreeRowsOnly: boolean;
    campaignState: AdCampaignState;
    currencyCode: string;
    activeFlight: SponsoredListingsFlight | null;
    campaignFlightIds: number[] | null;
    adGroups: SponsoredListingsAdGroup[] | null;
    flights: SponsoredListingsFlight[] | null;
    historicPotentialImpressions: number | null;
    actualImpressions: number | null;
    impressionShare: number | null;
    clicks: number | null;
    salesCount: number | null;
    salesProceeds: number | null;
    potentialSales: number | null;
    potentialRevenue: number | null;
    hasEnded: boolean;
}

export interface SponsoredListingsFlight {
    flightId: number;
    campaignId: number;
    dateRange: DateTimeRange;
    flightBudget: number;
    flightSpend: number | null;
    baseBid: number | null;
    maxBid: number | null;
    pacingOption: FlightPacingOption | null;
    isCurrent: boolean;
    historicPotentialImpressions: number | null;
    actualImpressions: number | null;
    impressionShare: number | null;
    clicks: number | null;
    salesCount: number | null;
    salesProceeds: number | null;
    potentialSales: number | null;
    potentialRevenue: number | null;
}

export enum FlightPacingOption {
    PaceToEndOfFlight = "PaceToEndOfFlight",
    ASAP = "ASAP",
}

export interface SponsoredListingsAdGroup {
    adGroupId: number;
    name: string;
    state: AdGroupState;
}

export enum AdGroupState {
    Active = "Active",
    Paused = "Paused",
    Deleted = "Deleted",
}

export interface BoostedSale {
    saleId: number;
    posEventId: string;
    adCampaignFlightId: number;
    currencyCode: string;
    listingId: number | null;
    originatedFromListingId: number | null;
    totalCost: number | null;
    totalNetProceeds: number;
}

export interface CatalogResults {
    events: { [key: string]: EventWithData; };
    performers: { [key: string]: Performer; };
    venues: { [key: string]: Venue; };
    viagIdToLatestIdLookup: { [key: string]: string; };
    posIdToViagIdLookup: { [key: string]: string; };
    countries: { [key: string]: Country; };
    purchaseCount: number;
}

export interface EventWithData {
    event: Event;
    counts: EventEntityCounts;
    entities: EventEntities;
}

export interface EventEntityCounts {
    viagVirtId: string;
    perfId: number | null;
    venId: number;
    rowVer: number | null;
    salesCnt: number | null;
    /** Listing count */
    listCnt: number | null;
    /** Priced listing count */
    pricedListCnt: number | null;
    /** Ungrouped listing count */
    ungrListCnt: number | null;
    /** Listing Group count */
    listGrpCnt: number | null;
    /** Ticket Group count */
    tktGrpsCnt: number | null;
    /** PurchaseOrderCount */
    poCnt: number | null;
}

export interface EventEntities {
    listings: Listing[] | null;
    listingsSummary: Listing | null;
    sales: Sale[] | null;
    salesSummary: Sale | null;
    ticketGroups: PurchaseOrderTicketGroup[] | null;
    ticketGroupsSummary: PurchaseOrderTicketGroup | null;
    getDataFail: boolean | null;
}

export interface Country {
    code: string | null;
    name: string | null;
}

export interface CatalogEntityMetricsResultsOfSaleMetrics {
    maxRowVersion: number | null;
    events: { [key: string]: SaleMetrics; };
    performers: { [key: string]: SaleMetrics; };
    venues: { [key: string]: SaleMetrics; };
    usedCache: boolean | null;
    cacheStale: boolean | null;
    cacheStaleTimeMs: number | null;
    missingPosEventIdsCount: number | null;
    top100MissingPosEventIds: string[] | null;
    metricsDif: { [key: string]: any; } | null;
    timeDif: { [key: string]: number; } | null;
}

export interface CatalogSaleMetricsResults extends CatalogEntityMetricsResultsOfSaleMetrics {
}

export interface SaleMetrics {
    /** Sold Ticket Quantity */
    qtySold: number;
    /** Unfulfilled Sales */
    saleUnfilled: number;
    /** Total net proceeds of sold tickets */
    netProcs: number | null;
    /** Total cost */
    ttlCst: number | null;
    currency: string | null;
    /** Margin */
    marg: number | null;
    tags: Tag[] | null;
}

export interface CatalogEntityMetricsResultsOfTicketGroupMetrics {
    maxRowVersion: number | null;
    events: { [key: string]: TicketGroupMetrics; };
    performers: { [key: string]: TicketGroupMetrics; };
    venues: { [key: string]: TicketGroupMetrics; };
    usedCache: boolean | null;
    cacheStale: boolean | null;
    cacheStaleTimeMs: number | null;
    missingPosEventIdsCount: number | null;
    top100MissingPosEventIds: string[] | null;
    metricsDif: { [key: string]: any; } | null;
    timeDif: { [key: string]: number; } | null;
}

export interface CatalogTicketGroupMetricsResults extends CatalogEntityMetricsResultsOfTicketGroupMetrics {
}

export interface TicketGroupMetrics {
    /** Total Ticket Quantity */
    tktQty: number;
    /** Total cost */
    ttlCst: number | null;
    currency: string | null;
    tags: Tag[] | null;
}

export interface EventGroupingQuery {
    groupingType: EventGroupingType;
    searchText: string | null;
    sortBy: EventGroupingSortBy | null;
    isSortDescending: boolean | null;
}

export enum EventGroupingType {
    Performer = "Performers",
    Venue = "Venues",
}

export enum EventGroupingSortBy {
    Name = "Name",
}

export interface EventSearchQuery {
    searchText: string | null;
    performerId: number | null;
    venueId: number | null;
    timeFrame: EventTimeFrameFilter | null;
}

export interface CatalogEntityMetricsResultsOfListingMetrics {
    maxRowVersion: number | null;
    events: { [key: string]: ListingMetrics; };
    performers: { [key: string]: ListingMetrics; };
    venues: { [key: string]: ListingMetrics; };
    usedCache: boolean | null;
    cacheStale: boolean | null;
    cacheStaleTimeMs: number | null;
    missingPosEventIdsCount: number | null;
    top100MissingPosEventIds: string[] | null;
    metricsDif: { [key: string]: any; } | null;
    timeDif: { [key: string]: number; } | null;
}

export interface CatalogListingMetricsResults extends CatalogEntityMetricsResultsOfListingMetrics {
    eventsDetailed: { [key: string]: ListingDetailedMetrics; };
}

export interface ListingMetrics {
    /** Total Ticket Quantity */
    tktQty: number;
    /** Sold Ticket Quantity */
    soldQty: number;
    unsoldQty: number;
    listQty: number;
    /** Unlisted ticket quantity */
    unlistQty: number;
    currency: string;
    /** Total cost of all tickets */
    ttlCst: number;
    /** Total cost of sold tickets */
    soldCst: number;
    /** Total cost of unsold tickets */
    unsoldCst: number;
    /** Total list price of all tickets */
    ttlListPrc: number;
    /** Total list price of unsold tickets */
    ttlUnsoldListPrc: number;
    /** Total net proceeds of sold tickets */
    netProcs: number;
    /** Total gross profit of sold tickets, i.e. SumNetProcs - SumSoldCst */
    pandL: number;
    tags: Tag[] | null;
}

export interface ListingDetailedMetrics extends ListingMetrics {
    /** Sell through rate */
    str: number;
    /** Revenue */
    rvn: number;
    /** Lift percentage */
    liftPerc: number;
    /** Average ticket price */
    atp: number;
    listedATP: number;
    /** Last price updated date */
    priceUpdatedOn: string | null;
}

export interface ListingMetricsInput {
    totalTicketQuantity: number | null;
    totalSoldQuantity: number | null;
    totalUnsoldQuantity: number | null;
    totalListedQuantity: number | null;
    totalUnlistedQuantity: number | null;
    currencyCode: string | null;
    /** Total cost of all tickets */
    totalCost: number | null;
    /** Total cost of sold tickets */
    totalSoldCost: number | null;
    /** Total cost of unsold tickets */
    totalUnsoldCost: number | null;
    /** Total list price of all tickets */
    totalListPrice: number | null;
    /** Total value of all listed tickets */
    totalListedValue: number | null;
    /** Total list price of unsold tickets */
    totalUnsoldListPrice: number | null;
    /** Total net proceeds of sold tickets */
    totalNetProceeds: number | null;
    /** Total gross profit of sold tickets */
    totalGrossProfit: number | null;
}

export interface ValueTupleOfEventAndVenueAndPerformer {
    item1: Event;
    item2: Venue;
    item3: Performer;
}

export interface EventMappingRequest {
    eventName: string;
    eventDate: string;
    isEventDateConfirmed: boolean | null;
    eventNote: string | null;
    venueName: string;
    city: string;
    stateProvince: string;
    countryCode: string;
}

export interface UpcomingOnSalesResult {
    catalog: CatalogResults;
    marketplaceEventInfos: { [key: string]: SellerEventMarketplaceEventInfo[]; };
}

export interface SellerEventMarketplaceEventInfo {
    viagogoEventId: number | null;
    marketplace: Marketplace;
    mappedEventId: string | null;
    websiteEventId: string | null;
    eventIdOverride: string | null;
    eventMappingId: string | null;
}

export interface OnSaleEventQuery {
    onSaleDates: DateTimeRangeWithRelative | null;
    performerIds: number[] | null;
    venueIds: number[] | null;
    countryCodes: string[] | null;
    stateProvinceIds: number[] | null;
    cityIds: number[] | null;
    topLevelCategories: TopLevelCategory[] | null;
    parentCategories: number[] | null;
    timezoneOffsetMins: number | null;
    viewMode: OnSaleEventViewMode | null;
    searchText: string | null;
    eventIds: number[] | null;
    listingQtyRange: NumericRange | null;
    ticketQtyRange: NumericRange | null;
    visitsL1HRange: NumericRange | null;
    visitsL24HRange: NumericRange | null;
    visitsL3DRange: NumericRange | null;
    visitsL7DRange: NumericRange | null;
    transL1HRange: NumericRange | null;
    transL24HRange: NumericRange | null;
    transL3DRange: NumericRange | null;
    transL7DRange: NumericRange | null;
    priceMinRange: NumericRange | null;
    priceP25Range: NumericRange | null;
    priceP50Range: NumericRange | null;
}

export enum OnSaleEventViewMode {
    MetricView = "Metric View",
}

export interface OnSaleEventMetrics {
    /** Event ID.
             */
    eId: number;
    eventVisits: OnSaleEventCountMetrics | null;
    eventTransactions: OnSaleEventCountMetrics | null;
    /** Min UnitNetProceeds
             */
    minUNP: number;
    /** P25 UnitNetProceeds
             */
    p25UNP: number;
    /** P50 UnitNetProceeds
             */
    p50UNP: number;
    /** Listing Count
             */
    ltgCnt: number;
    /** Ticket Count
             */
    tktCnt: number;
    /** Recent visits bucket.
             */
    vstBkt: number[];
    /** Recent visits ordinal index.
             */
    vstIdx: number;
}

export interface OnSaleEventCountMetrics {
    lastHour: number;
    lastDay: number;
    lastThreeDays: number;
    lastSevenDays: number;
}

export interface EventAttributes {
    eventId: number;
    inferredPrimary: string | null;
}

export interface CategoryResult {
    categoryId: number;
    imageUrl: string | null;
    description: string | null;
}

export interface CatalogResultsSlim {
    events: Event[];
    venues: Venue[];
    performers: Performer[];
    countries: Country[];
}

export interface CatalogCounts {
    entityCnts: EventEntityCounts[];
    /** Reason for this is a Purchase can include in multiple events, while
multiple events can include multiple purchases, so the count is for the
whole catalog, not per event like listings or sales */
    purchaseCount: number;
    usedCache: boolean | null;
    cacheStale: boolean | null;
    cacheStaleTimeMs: number | null;
    countDif: { [key: string]: any; } | null;
    timeDif: { [key: string]: number; } | null;
    missingPosEventIdsCount: number | null;
    top100MissingPosEventIds: string[] | null;
}

export interface InsertCatchUpModeEventIdsMapRequest {
    catchUpModeSource: CatchUpModeSource;
    eventIds: string[];
}

export enum CatchUpModeSource {
    InventoryEvents = "InventoryEvents",
    OnSaleEvents = "OnSaleEvents",
}

export interface CatchUpModeEventIdsMapResponse {
    mapId: string;
    catchUpModeSource: CatchUpModeSource;
    eventIdsJson: string;
    insertDate: string;
}

export interface ClientLogRequest {
    logLevel: LogLevel;
    applicationSource: string;
    errorId: string | null;
    error: string;
    pageUrl: string;
    componentStack: string | null;
    timestamp: string;
    additionalInfo: { [key: string]: any; } | null;
}

export enum LogLevel {
    Trace = "Trace",
    Verbose = "Verbose",
    Information = "Information",
    Warning = "Warning",
    Error = "Error",
    Critical = "Critical",
    None = "None",
}

export interface StopwatchLogEntry {
    applicationSource: string;
    logId: string | null;
    message: string;
    pageUrl: string;
    startTime: string;
    endTime: string;
    totalDurationMs: number;
    stopGaps: { [key: string]: StopwatchStopGap; };
    hasGrpcCacheFeature: boolean | null;
    usedJSHeapSize: number | null;
    totalJSHeapSize: number | null;
    jsHeapSizeLimit: number | null;
    browserCap: BrowserCap | null;
}

export interface StopwatchStopGap {
    name: string;
    time: string;
    logKey: string | null;
    browserCap: BrowserCap | null;
    usedJSHeapSize: number | null;
    totalJSHeapSize: number | null;
    jsHeapSizeLimit: number | null;
}

export interface BrowserCap {
    estimatedCpuLoad: EstimatedCpuLoad | null;
    estimatedNetworkSpeed: NetworkSpeed | null;
    domContentLoadedMs: number | null;
    loadCompleteMs: number | null;
    renderTimeMs: number | null;
    hardwareConcurrency: number | null;
    browserAgent: string | null;
}

export enum EstimatedCpuLoad {
    Unknown = "Unknown",
    Low = "Low",
    Medium = "Medium",
    High = "High",
}

export enum NetworkSpeed {
    Unknown = "Unknown",
    Slow = "Slow",
    Moderate = "Moderate",
    Fast = "Fast",
}

export enum CommandOptionType {
    NavigateHome = "NavigateHome",
    NavigateInventory = "NavigateInventory",
    NavigateSales = "NavigateSales",
    NavigatePurchases = "NavigatePurchases",
    NavigatePayments = "NavigatePayments",
    NavigateReports = "NavigateReports",
    NavigateSettings = "NavigateSettings",
    ToggleTheme = "ToggleTheme",
    ToggleSelectionMode = "ToggleSelectionMode",
    SelectAll = "SelectAll",
    ListingBulkEditListingGroupSettings = "ListingBulkEditListingGroupSettings",
    ListingsGroupListings = "ListingsGroupListings",
    ListingBulkEditMoveToGroup = "ListingBulkEditMoveToGroup",
    ListingBulkEditUngroupListings = "ListingBulkEditUngroupListings",
    ListingBulkEditAddTags = "ListingBulkEditAddTags",
    ListingBulkEditRemoveTags = "ListingBulkEditRemoveTags",
    ListingBroadcastListing = "ListingBroadcastListing",
    ListingUnbroadcastListing = "ListingUnbroadcastListing",
    ListingBulkEditAddHold = "ListingBulkEditAddHold",
    ListingBulkEditRemoveHold = "ListingBulkEditRemoveHold",
    ListingBulkEditIncreasePrice = "ListingBulkEditIncreasePrice",
    ListingBulkEditDecreasePrice = "ListingBulkEditDecreasePrice",
    ListingBulkEditAdjustFloor = "ListingBulkEditAdjustFloor",
    ListingBulkEditAdjustCeiling = "ListingBulkEditAdjustCeiling",
    ListingBulkEditAutoPricingSettings = "ListingBulkEditAutoPricingSettings",
    ListingBulkEditUpdateMarketplacePrices = "ListingBulkEditUpdateMarketplacePrices",
    ExpandAll = "ExpandAll",
    CollapseAll = "CollapseAll",
    ListingCatchupMode = "ListingCatchupMode",
    ListingBulkEditChangeEvent = "ListingBulkEditChangeEvent",
    ListingBulkEditTicketTypeRule = "ListingBulkEditTicketTypeRule",
    ListingBulkEditCommissionAction = "ListingBulkEditCommissionAction",
    ListingBulkEditMarketplaceSeating = "ListingBulkEditMarketplaceSeating",
    ListingBulkEditRemovePredelivery = "ListingBulkEditRemovePredelivery",
    ListingBulkEditAutoFulfill = "ListingBulkEditAutoFulfill",
    ListingBulkUpdateBarcodes = "ListingBulkUpdateBarcodes",
    ListingBulkEditDeliveryType = "ListingBulkEditDeliveryType",
    ListingBulkEditInternalNotes = "ListingBulkEditInternalNotes",
    ListingBulkEditUpdateListingSettings = "ListingBulkEditUpdateListingSettings",
    ListingBulkEditSeatTraits = "ListingBulkEditSeatTraits",
    ListingBulkEditWasteTickets = "ListingBulkEditWasteTickets",
    ListingBulkEditDeleteSeatSavers = "ListingBulkEditDeleteSeatSavers",
    ListingExportListing = "ListingExportListing",
    ListingBulkReturnTicket = "ListingBulkReturnTicket",
    SalesBulkEditDeallocate = "SalesBulkEditDeallocate",
    SalesBulkEditReject = "SalesBulkEditReject",
    SalesBulkUpdateBarcodes = "SalesBulkUpdateBarcodes",
    SalesBulkEditCommission = "SalesBulkEditCommission",
    SalesBulkEditAddTags = "SalesBulkEditAddTags",
    SalesBulkEditRemoveTags = "SalesBulkEditRemoveTags",
    SalesBulkEditMarkAsFulfilled = "SalesBulkEditMarkAsFulfilled",
    SalesBulkMarkSaleAsPaid = "SalesBulkMarkSaleAsPaid",
    SalesBulkEditAutoFulfill = "SalesBulkEditAutoFulfill",
    SalesBulkEditInternalNotes = "SalesBulkEditInternalNotes",
    SalesBulkEditGeneralSettings = "SalesBulkEditGeneralSettings",
    SalesExportSales = "SalesExportSales",
    PurchasesBulkAdjustCost = "PurchasesBulkAdjustCost",
    PurchaseBulkCancelPurchase = "PurchaseBulkCancelPurchase",
    PurchasesBulkConvertPurchasePayment = "PurchasesBulkConvertPurchasePayment",
    PurchaseBulkDeleteTicketGroup = "PurchaseBulkDeleteTicketGroup",
    PurchasesBulkEditCommissionAction = "PurchasesBulkEditCommissionAction",
    PurchasesBulkEditAddTag = "PurchasesBulkEditAddTag",
    PurchasesBulkEditRemoveTag = "PurchasesBulkEditRemoveTag",
    PurchasesBulkMarkPurchaseAsPaid = "PurchasesBulkMarkPurchaseAsPaid",
    PurchasesBulkUpdateDeliveryType = "PurchasesBulkUpdateDeliveryType",
    PurchasesBulkUpdateInternalNotes = "PurchasesBulkUpdateInternalNotes",
    PurchasesBulkChangeEvent = "PurchasesBulkChangeEvent",
    PurchasesBulkUpdatePurhcaseCurrencyCode = "PurchasesBulkUpdatePurhcaseCurrencyCode",
    PurchasesBulkUpdatePurchaseSettings = "PurchasesBulkUpdatePurchaseSettings",
    PurchasesBulkUpdateSeatTraits = "PurchasesBulkUpdateSeatTraits",
    PurchasesExportPurchases = "PurchasesExportPurchases",
}

export interface ContentData {
    body: string;
}

export interface DocumentUploadInfo {
    entityId: number;
    entityType: ActionOutboxEntityType;
    documentType: DocumentType;
    blobName: string;
    documentId: string;
    contentType: string;
}

export interface PosUiActionResult {
    entityId: number | null;
    entityType: ActionOutboxEntityType | null;
    status: number | null;
    message: string | null;
}

export interface PosUiActionResultWithDataOfUserDocumentLinks extends PosUiActionResult {
    data: UserDocumentLinks | null;
}

export interface DocumentPage {
    id: string;
    documentId: string;
    pageNumber: number;
    thumbUrl: string;
    documentUrl: string;
}

export interface VenueMapInfo {
    eventId: number;
    venueId: number;
    venueCfgId: number;
    svgMapVer: number | null;
    geoJsonVer: number | null;
    sections: SectionInfo[];
    sectionScores: SectionScoreOverride[];
    focalPt: FocalPointInfo | null;
    hasRow: boolean;
}

export interface SectionInfo {
    id: number;
    name: string;
    rows: RowInfo[];
    sectionType: VenueMapSectionType;
    dist: number | null;
    angle: number | null;
    directionalAngle: number | null;
    height: number | null;
    specRow: VenueMapRow | null;
}

export interface RowInfo {
    id: number;
    name: string | null;
    ordinal: number | null;
    tktClass: TicketClassInfo | null;
    seatQualityScore: number | null;
    isSpeculative: boolean;
}

export interface TicketClassInfo {
    id: number;
    name: string;
    color: string;
    cssPostFix: string;
}

export interface VenueMapRow {
    id: number;
    name: string | null;
    ordinal: number | null;
    ticketClassId: number | null;
    tktClass: VenueMapTicketClass | null;
    seatQualityScore: number | null;
    isSpeculative: boolean;
}

export interface VenueMapTicketClass {
    ticketClassId: number;
    ticketClassName: string;
    color: string;
    cssPostFix: string;
}

export interface SectionScoreOverride {
    sectionId: number;
    rowId: number;
    rowName: string | null;
    rowOrdinal: number | null;
    tkClsId: number | null;
    /** Score normalized to 0-100 according to max score of venue heat map */
    score: number | null;
    scoreRaw: number | null;
    isManualOverride: boolean | null;
}

export interface FocalPointInfo {
    x: number | null;
    y: number | null;
    angleDeg: number | null;
    isDirectional: boolean;
}

export interface EventListingConstraints {
    eventId: number;
    validListingNoteIds: number[] | null;
    validTicketTypes: number[] | null;
    isSeatRequired: boolean | null;
    validSplitTypes: number[] | null;
}

export interface MarketTransaction {
    listingId: number;
    transactionDateTime: string;
    section: string;
    row: string;
    seatFrom: string;
    seatTo: string;
    quantityPurchased: number;
    sellerUserId: string;
    sellerNetProceeds: number;
    sellerCurrencyCode: string;
}

export interface SellerEventNote {
    eventId: number | null;
    sellerEventNoteId: number;
    sellerUserId: string;
    content: string;
    createDate: string;
}

export interface SellerEventNoteResult extends SellerEventNote {
    sellerDisplayName: string;
}

export interface SellerAccountEventSetting {
    delivType: DeliveryType | null;
    isNoFulfill: boolean | null;
    tktTypeRules: TicketTypeOverride | null;
    inHandAt: string | null;
    vendorId: number | null;
}

export interface EventDiscoveryQuotaConfig {
    enabled: boolean | null;
    autoRenew: boolean | null;
    eventViewQuota: number;
    stubHubProceedsAdvantageAmount: number;
}

export interface OnSaleEventAccess {
    onSaleEventAccessLevel: OnSaleEventAccessLevel;
    eventDiscoveryConfig: EventDiscoveryConfig;
    eventDiscoveryQuota: SellerAccountEventDiscoveryQuota | null;
    recentViewed: boolean;
    hasAccessToView: boolean;
    hasQuota: boolean;
    noProceedsAdvantage: boolean;
}

export enum OnSaleEventAccessLevel {
    Granted = "Granted",
    RecentViewedWithAccess = "RecentViewedWithAccess",
    RecentViewedWithNoQuota = "RecentViewedWithNoQuota",
    RecentViewedWithNoProceedsAdvantage = "RecentViewedWithNoProceedsAdvantage",
    DeniedWithNoProceedsAdvantage = "DeniedWithNoProceedsAdvantage",
    DeniedWithNoQuota = "DeniedWithNoQuota",
}

export interface EventDiscoveryConfig {
    proceedsAdvantageDurationInHours: number;
    eventDiscoveryQuotaResetFrequencyInHours: number;
    quotaConfigs: EventDiscoveryQuotaConfig[];
}

export interface SellerAccountEventDiscoveryQuota {
    eventViewQuota: number;
    eventViewQuotaUsed: number;
    eventViewQuotaUsedResetFrequencyInHours: number;
    eventViewQuotaUsedNextResetDate: string;
}

export interface EventDiscoveryConfigSettings {
    eventDiscoveryConfig: EventDiscoveryConfig;
    sellerProceedsAdvantageConfig: SellerProceedsAdvantageConfig;
    sellerAccountEventDiscoveryQuota: SellerAccountEventDiscoveryQuota | null;
}

export interface SellerProceedsAdvantageConfig {
    hasActiveProceedsAdvantage: boolean;
    hasRenewableActiveProceedsAdvantage: boolean;
    activeProceedsAdvantageAmount: number;
}

export interface EventSectionMetrics {
    sectionId: number;
    pageVisits: EventIncrementalMetricsOfNullableInteger;
    mapSectionClicks: EventIncrementalMetricsOfNullableInteger;
    transactions: EventIncrementalMetricsOfNullableInteger;
    availableTickets: EventIncrementalMetricsOfNullableInteger;
    minPrice: EventIncrementalMetricsOfUiMoney;
    p25Price: EventIncrementalMetricsOfUiMoney;
    medianPrice: EventIncrementalMetricsOfUiMoney;
}

export interface EventIncrementalMetricsOfNullableInteger {
    currentMetricsValue: number | null;
    previousMetricsValue: number | null;
}

export interface EventIncrementalMetricsOfUiMoney {
    currentMetricsValue: UiMoney;
    previousMetricsValue: UiMoney;
}

export enum EventMetricsTimestamp {
    LastHour = "LastHour",
    LastDay = "LastDay",
    Last3Days = "Last3Days",
    LastWeek = "LastWeek",
}

export interface EventNotification {
    id: string;
    name: string;
    notificationType: EventNotificationType;
    status: EventNotificationStatus;
    filters: OnSaleEventQuery;
    userIdTargets: string[];
    webhookTargets: Webhook[];
}

export enum EventNotificationType {
    Email = "Email",
    Webhook = "Webhook",
}

export enum EventNotificationStatus {
    Active = "Active",
    Deactivated = "Deactivated",
}

export interface Webhook {
    id: number;
    name: string;
    url: string;
    authorizationHeader: string;
}

export interface FulfillmentProvider {
    fulfillmentProviderSellerUserId: string;
    fulfillmentProviderName: string;
    descriptionMessage: string;
    isEnabled: boolean;
    costPercentagePerTransfer: number | null;
    flatCostPerTransfer: number | null;
}

/** Response model for index freshness endpoint calls. */
export interface IndexFreshnessResponse {
    /** The last time the index was updated, or null if unavailable. */
    lastUpdatedAt: string | null;
    /** True when the result was served from cache; false when fetched live from OpenSearch. */
    cachedResult: boolean;
    /** Duration of the freshness check in milliseconds (includes cache lookup or live query time). */
    queryDurationMs: number;
}

export interface ProblemDetails {
    type: string | null;
    title: string | null;
    status: number | null;
    detail: string | null;
    instance: string | null;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export interface EventMarketplaceWebsiteMetrics {
    ticketsOnPlatform: EventMarketplaceWebsiteMetricOfInteger;
    eventVisitors: EventMarketplaceWebsiteMetricOfInteger;
    visitorsInCheckout: EventMarketplaceWebsiteMetricOfInteger;
    totalTicketPriceInCheckout: EventMarketplaceWebsiteMetricOfUiMoney;
}

export interface EventMarketplaceWebsiteMetricOfInteger {
    currentValue: number;
    previousValue: number;
}

export interface EventMarketplaceWebsiteMetricOfUiMoney {
    currentValue: UiMoney;
    previousValue: UiMoney;
}

export interface InventoryMetricsQueryId {
    posEventId: string | null;
    viagogoEventId: number | null;
}

export enum EventWebsiteMetricsTimePeriod {
    OneHour = "OneHour",
    OneDay = "OneDay",
}

export interface EventDemandFactor {
    type: EventDemandFactorType;
    value: string;
}

export enum EventDemandFactorType {
    Opponent = "Opponent",
    Weather = "Weather",
    Standing = "Standing",
    Stakes = "Stakes",
    SpotifyPopularity = "SpotifyPopularity",
    HomeTeamOdds = "HomeTeamOdds",
}

/** Represents the results for the inventory event dashboard. */
export interface InventoryEventDashboardResults {
    /** Gets or sets the marketplace shares as a dictionary with the marketplace as the key and the share percentage as the
value
             */
    mktShares: MarketplaceMarketShare[];
    /** Gets or sets the average ticket price (ATP) value, which represents the average cost of tickets listed by the
seller for the event
             */
    atp: TicketPricePercentiles;
    totalListings: number;
}

export interface MarketplaceMarketShare {
    mktPlc: Marketplace;
    share: number;
}

export interface TicketPricePercentiles {
    currency: string;
    listingCount: number;
    ticketCount: number;
    min: number;
    p25: number;
    p50: number;
    p75: number;
    max: number;
}

export enum SellerEventDashboardMetricsTimePeriod {
    Last7Days = "Last7Days",
    AllTime = "AllTime",
}

export interface EventSectionClearingPrices {
    sectionId: number | null;
    sectionName: string;
    p01: UiMoney;
    p25: UiMoney;
    p50: UiMoney;
    p75: UiMoney;
    p99: UiMoney;
    transactionCount: number;
    normalizedScore: number;
}

export enum EventSectionMetricsTimePeriod {
    LastSixHours = "LastSixHours",
    LastTwentyFourHours = "LastTwentyFourHours",
    LastThreeDays = "LastThreeDays",
    LastSevenDays = "LastSevenDays",
}

export interface EventSupplyMetrics {
    dateTime: string;
    listingCount: number;
    ticketCount: number;
    min: number;
    p25: number;
    p50: number;
    p75: number;
    max: number;
}

export enum EventSupplyMetricsTimePeriod {
    LastDay = "LastDay",
    LastSevenDays = "LastSevenDays",
    LastNinetyDays = "LastNinetyDays",
}

export interface ListingDetails extends Listing {
    purchaseInfos: UiPurchaseInfo[] | null;
    tickets: Ticket[] | null;
    /** Available Artifact Types */
    availArtTypes: ArtifactType[] | null;
    saleInfos: SaleDisplayInfo[] | null;
    proofOfPurchaseDocs: UserDocumentLinks[] | null;
    no_Op: MarketplaceListing | null;
}

export interface UiPurchaseInfo {
    purchaseOrderId: number;
    vendorOrderId: string | null;
    purchaseOrderDate: string | null;
    buyerUserId: string | null;
    vendor: UiPurchaseVendorInfo | null;
    vendorAccount: UiVendorAccountInfo | null;
    createdBy: string | null;
    internalNotes: string | null;
}

export interface UiPurchaseVendorInfo {
    vendorId: number;
    vendorName: string;
}

export interface UiVendorAccountInfo {
    vendorAccountId: string;
    vendorId: number;
    vendorAccountName: string | null;
    encryptedEmailAddress: string;
}

export enum ArtifactType {
    TicketUrl = "TicketUrl",
    ExternalId = "ExternalId",
    ETicket = "ETicket",
    ETicketUrl = "ETicketUrl",
    TransferProof = "TransferProof",
    Barcode = "Barcode",
    QRCode = "QRCode",
}

export interface SaleDisplayInfo {
    /** SaleId */
    id: number;
    /** MarketplaceSaleId */
    idOnMkp: string | null;
    /** Marketplace */
    mkp: Marketplace;
    /** SaleStatus */
    stat: PointOfSaleSaleStatus;
    /** ExternalId */
    externalId: string | null;
}

export interface EntitiesWithSummaryOfListing {
    items: Listing[];
    summary: Listing | null;
}

/** Model for SearchV2 result */
export interface EntitySearchResultOfIDictionaryOfStringAndEntitiesWithSummaryOfListingWithCatalogData {
    /** Actual entities returned from the search */
    entities: { [key: string]: EntitiesWithSummaryOfListingWithCatalogData; };
    /** PIT ID for next page requests, null if not using PIT (Point-In-Time) pagination */
    pitId: string | null;
    /** Total number of matching documents that may have not been returned yet due to pagination */
    totalItemsCount: number | null;
    /** Maximum number of documents reachable via offset pagination (from + size).
Corresponds to the OpenSearch index.max_result_window setting (default 10,000).
The frontend should use this to cap pagination: maxPages = maxResultWindow / pageSize. */
    maxResultWindow: number | null;
    searchAfter: any[] | null;
    /** Ordered list of event group IDs (ViagogoVirtualIds) in the order returned by OpenSearch.
Solves a JavaScript serialization problem: Object.entries() reorders integer-like keys
numerically per ECMAScript spec, which would override the OpenSearch sort order.
Use this to iterate Entities in the correct group order.
Note: this is coarser than SortedItemIds — it gives the order of event groups, not
individual items within or across groups. */
    sortedGroupIds: string[] | null;
    /** Ordered list of individual item IDs (SaleId / ListingId) in the globally-sorted order
returned by OpenSearch. This is finer-grained than SortedGroupIds: because the response
groups items by event, a single event group may contain mixed-rank items (e.g., one event
with both Transfer and Paper tickets). Flattening event-by-event would put those mixed items
out of global sort order. Use SortedItemIds to re-sort the flat list and restore the correct
global order for flattened/search views. */
    sortedItemIds: number[] | null;
}

export interface EntitiesWithSummaryOfListingWithCatalogData {
    items: ListingWithCatalogData[];
    summary: ListingWithCatalogData | null;
}

/** Extends the Listing model to include catalog data about the event, venue, and performer to power Opensearch-based search experience which doesn't depend on a separate catalog service call. */
export interface ListingWithCatalogData extends Listing {
    entityCatalogData: EntityCatalogData | null;
}

/** Extended version of ListingQuery with support for operations for each filter that is supported in search v2 with OpenSearch */
export interface ListingQueryV2 extends ListingQuery {
    pricerSellerUserIds: string[] | null;
    deliveryTypes: DeliveryType[] | null;
    ticketTypes: TicketType[] | null;
    splitTypes: SplitType[] | null;
    eventUnpricedStatuses: EventUnpricedStatus[] | null;
    operations: ListingQueryOperations | null;
    searchOptions: UISearchOptions | null;
    unitAllInPriceRange: NumericRange | null;
    quantityRange: NumericRange | null;
}

export interface EntityWithTicketsQueryOperations {
    entityIdsOp: FilterOperationType | null;
    marketplaceEntityIdsOp: FilterOperationType | null;
    eventOrMappingIdsOp: FilterOperationType | null;
    eventIdsOverrideOp: FilterOperationType | null;
    oldPosEventIdsOp: FilterOperationType | null;
    performerIdsOp: FilterOperationType | null;
    venueIdsOp: FilterOperationType | null;
    countryCodesOp: FilterOperationType | null;
    stateProvinceIdsOp: FilterOperationType | null;
    cityIdsOp: FilterOperationType | null;
    purchaseOrderIdsOp: FilterOperationType | null;
    saleIdsOp: FilterOperationType | null;
    listingIdsOp: FilterOperationType | null;
    purchaseVendorIdOp: FilterOperationType | null;
    vendorAccessControlProviderIdOp: FilterOperationType | null;
    purchaseVendorAccountIdsOp: FilterOperationType | null;
    purchaseVendorOrderIdOp: FilterOperationType | null;
    purchaseBuyerIdOp: FilterOperationType | null;
    purchaseOrderCreatedByOp: FilterOperationType | null;
    purchaseCommissionUserIdOp: FilterOperationType | null;
    purchaseDatesOp: FilterOperationType | null;
    inHandDatesOp: FilterOperationType | null;
    eventTimeFrameFilterOp: FilterOperationType | null;
    sectionOp: FilterOperationType | null;
    rowOp: FilterOperationType | null;
    isSeatSaverOp: FilterOperationType | null;
    eventDatesOp: FilterOperationType | null;
    eventNotReviewedSinceDateOp: FilterOperationType | null;
    isMappedOp: FilterOperationType | null;
    isMappingRejectedOp: FilterOperationType | null;
    searchTextOp: FilterOperationType | null;
    isBoostedOp: FilterOperationType | null;
    sortByOp: FilterOperationType | null;
    isSortDescendingOp: FilterOperationType | null;
    tagNameOp: FilterOperationType | null;
    tagValueOp: FilterOperationType | null;
    eventTagNameOp: FilterOperationType | null;
    eventTagValueOp: FilterOperationType | null;
    lastSaleDatesOp: FilterOperationType | null;
    noSaleDatesOp: FilterOperationType | null;
    numberOfTicketsHeldOp: FilterOperationType | null;
    topLevelCategoriesOp: FilterOperationType | null;
    parentCategoriesOp: FilterOperationType | null;
    internalNotesOp: FilterOperationType | null;
    currencyCodesOp: FilterOperationType | null;
    eventStatusesOp: FilterOperationType | null;
    searchConfigIdOp: FilterOperationType | null;
}

export interface ListingQueryOperations extends EntityWithTicketsQueryOperations {
    pricerSellerUserIdOp: FilterOperationType | null;
    isPredeliveredOp: FilterOperationType | null;
    isListedOp: FilterOperationType | null;
    deliveryTypeOp: FilterOperationType | null;
    eventHasUnsoldTicketsOp: FilterOperationType | null;
    hasUnsoldTicketsOp: FilterOperationType | null;
    hasBroadcastErrorOp: FilterOperationType | null;
    isAutoPricingEnabledOp: FilterOperationType | null;
    isPricedAboveZeroOp: FilterOperationType | null;
    lastPriceUpdateDatesOp: FilterOperationType | null;
    autoPricingResultTypesOp: FilterOperationType | null;
    isSeatingUnmappedOp: FilterOperationType | null;
    isAdminHoldOp: FilterOperationType | null;
    isDuplicateOp: FilterOperationType | null;
    hasListingGroupIdOp: FilterOperationType | null;
    isPricedByMarketplaceOp: FilterOperationType | null;
    isPendingProofOp: FilterOperationType | null;
    purchaseCancellationDatesOp: FilterOperationType | null;
    purchaseCancelledOnlyOp: FilterOperationType | null;
    isNoFulfillOp: FilterOperationType | null;
    ticketTypeOp: FilterOperationType | null;
    splitTypeOp: FilterOperationType | null;
    eventUnpricedStatusOp: FilterOperationType | null;
    unitAllInPriceRangeOp: FilterOperationType | null;
    quantityRangeOp: FilterOperationType | null;
    unitCostHighOp: FilterOperationType | null;
    unitCostLowOp: FilterOperationType | null;
}

export enum FilterOperationType {
    Equals = "Equals",
    NotEquals = "NotEquals",
    GreaterThan = "GreaterThan",
    LessThan = "LessThan",
    GreaterThanOrEqual = "GreaterThanOrEqual",
    LessThanOrEqual = "LessThanOrEqual",
    Between = "Between",
    In = "In",
    NotIn = "NotIn",
    Contains = "Contains",
    NotContains = "NotContains",
}

export interface UISearchOptions {
    take: number | null;
    skip: number | null;
    sort: UISortCriteria[] | null;
    includeAggregations: boolean | null;
    pitId: string | null;
    searchAfter: any[] | null;
}

export interface UISortCriteria {
    /** The field name to sort by */
    field: string | null;
    /** The sort order (asc/desc) */
    desc: boolean | null;
    /** Optional GUID-to-display-name map. When present for fields that support it
(e.g. purchasedBy), the Painless sort script resolves GUIDs to display names
so results sort alphabetically by the visible name rather than raw GUID bytes. */
    userNames: { [key: string]: string; } | null;
}

export interface SectionalListingsForEventsInput {
    listingQuery: ListingQuery;
    curListings: Listing[] | null;
}

export interface ValueTupleOfBooleanAndIListOfTicket {
    item1: boolean;
    item2: Ticket[];
}

export interface DuplicateListingDetails {
    listingId: number;
    lastUpdateDate: string;
    duplicateListingId: number;
    duplicateListingLastUpdateDate: string;
}

export interface ValueTupleOfLongAndListingDetailsUpdateInput {
    item1: number;
    item2: ListingDetailsUpdateInput;
}

export interface MergeListingsInput {
    listingIds: number[];
}

export interface BulkMergeListingsInput {
    listingIdLists: number[][];
    /** If provided, for each ListingIdList, the first listing Id in the list will be mapped
to the corresponding ConsigneeSellerAccountId in this dictionary.

Key: ListingId (for each ListingIdList, first listing Id in the list)
Value: ConsigneeSellerAccountId */
    consigneeOwnership: { [key: string]: string; } | null;
}

export interface ListingMergeSuggestion {
    listingIds: number[];
    eventId: number | null;
    eventMappingId: string | null;
    seatFrom: string | null;
    seatTo: string | null;
    accId: string | null;
}

export interface SplitListingInput {
    sourceListingId: number;
    numOfListings: number;
    /** Each of the sub-list will be considered 1 listing */
    ticketsByListingNumber: TicketByListingNumber[];
    alwaysUnbroadcastListing: boolean;
    useOriginalTicketGroupInfoForNewListings: boolean;
}

export interface TicketByListingNumber {
    ticket: Ticket;
    listingNumber: number;
}

export interface TicketExternalId {
    ticketId: number;
    externalId: string;
    section: string | null;
    row: string | null;
    seat: string | null;
}

export interface TicketUrl {
    ticketId: number;
    url: string;
    section: string | null;
    row: string | null;
    seat: string | null;
}

export interface ListingPriceHistory {
    unitNetProceeds: UiMoney;
    priceDate: string;
    marketplace: Marketplace | null;
    pricerUserId: string | null;
    applicationName: string | null;
}

export interface ValueTupleOfLongAndNullableInteger {
    item1: number;
    item2: number | null;
}

export interface ListingPriceCalculation extends BaseListingPriceCalculation {
    compListings: CompListing[];
}

export interface ValueTupleOfListingQueryAndListingCsvColumnSelectionConfig {
    item1: ListingQuery;
    item2: ListingCsvColumnSelectionConfig;
}

export interface ListingCsvColumnSelectionConfig {
    hasAutoPricingFeature: boolean | null;
}

export interface SeatSaverListingDetailsInput {
    event: Event;
    autoBroadcastCreatedListing: boolean;
    sellerOwnTickets: boolean | null;
    seatings: SeatSaverSeating[];
    deliveryType: DeliveryType;
    ticketTypeRules: TicketTypeOverride | null;
    inHandDate: string | null;
    daysBeforeEvent: number | null;
}

export interface SeatSaverSeating {
    section: string;
    sectionId: number | null;
    row: string | null;
    rowId: number | null;
    quantity: number | null;
    maxDisplayQuantity: number | null;
    listingNotes: ListingNote[] | null;
    unitNetProceeds: number | null;
    websitePrice: number | null;
    faceValue: number | null;
}

export interface BatchSwapListingGroupInput {
    listings: SwapListingGroupInput[];
    toListingGroupId: string;
}

export interface SwapListingGroupInput {
    listingId: number;
    listingGroupId: string | null;
    quantity: number;
    adminHoldExpirationDate: string | null;
}

export interface ReorderListingInGroupInput {
    listingGroupId: string;
    listingId: number;
    fromPosition: number;
    toPosition: number;
}

export interface ListingDetailsBroadcastSectionUpdates {
    id: number;
    rowVersion: number | null;
    adminHoldNotes: string | null;
    marketplaceSeatOverrides: ListingMarketplaceSeatingOverride[];
    enableNativeSync: boolean | null;
}

export interface ListingDetailsTicketSectionUpdates {
    id: number;
    rowVersion: number | null;
    splitType: SplitType | null;
    hideSeatsFromMarketplace: boolean | null;
    faceValue: number | null;
    inHandDate: string | null;
    daysBeforeEvent: number | null;
    section: string | null;
    sectionId: number | null;
    row: string | null;
    rowId: number | null;
    internalNotes: string | null;
    ticketTypeRules: TicketTypeOverride | null;
    manualMaxDisplayQuantity: number | null;
    isNoFulfill: boolean | null;
    seatTraits: ListingNote[] | null;
    delivType: DeliveryType | null;
    updateSalesOfListings: boolean | null;
    updatePredeliveryETicketArtifacts: boolean | null;
}

export interface ListingPricingSectionPosFieldUpdates {
    unitNetProceeds: PosFieldOfNullableDecimal | null;
    autoPricingEnabled: PosFieldOfNullableBoolean | null;
    netProceedsFloor: PosFieldOfNullableDecimal | null;
    netProceedsCeiling: PosFieldOfNullableDecimal | null;
    pricerSellerUserId: PosFieldOfNullableGuid | null;
}

export interface ListingDetailsPricingSectionUpdates {
    id: number;
    rowVersion: number | null;
    pricerSellerUserId: string | null;
    listPrice: number | null;
    allInPrice: number | null;
    netProceedsFloor: number | null;
    netProceedsCeiling: number | null;
    autoPricingEnabled: boolean | null;
    buyerUserId: string | null;
    marketplacePriceUpdates: ListingMarketplacePriceUpdateInput[];
    currencyCode: string | null;
}

export interface ListingDetailsAutoPricingSectionUpdates extends AutoPricingInputs {
    id: number;
    rowVersion: number | null;
    netProceedsFloor: number | null;
    netProceedsCeiling: number | null;
    skipAutoPricing: boolean | null;
    autoPricingEnabled: boolean | null;
    skipUndercut: boolean | null;
    skipCompListing: boolean | null;
    skipAdvancePricing: boolean | null;
    velocityCircuitBreakerStateRowVersion: number | null;
    currencyCode: string | null;
    sectionRowScoreRecommendations: SectionRowScoreRecommendations | null;
}

export interface SectionRowScoreRecommendations {
    eventId: number;
    venueConfigId: number;
    modelVersionId: number;
    recommendedSelectedSectionSettings: SelectedSectionSettings;
}

export interface ListingDetailsTagsSectionUpdates {
    id: number;
    rowVersion: number | null;
    tags: Tag[] | null;
}

export interface ListingStatusInfo {
    entityType: ActionOutboxEntityType;
    id: number;
    accId: string | null;
    status: ListingStatus;
    /** Marketplace listing broadcast status */
    brdcstStatus: ListingBroadcastStatus | null;
    /** Marketplace where these tickets were listed and sold */
    mkp: Marketplace | null;
    /** Represent either the MarketplaceListingId or MarketplaceSaleId */
    idOnMkp: string | null;
    pendProofState: PendingProofState | null;
    mkpListings: MarketplaceListingStatusInfo[];
}

export interface MarketplaceListingStatusInfo {
    mkpListingId: string | null;
    mkp: Marketplace;
    status: ListingStatus;
}

export interface ListingExperiment {
    viagogoEventId: number;
    listingGroupId: string | null;
    listingGroupName: string | null;
    targetPercentage: number | null;
    discountPercentage: number | null;
    startDate: string;
    endDate: string;
    insertBy: string;
}

export interface ListingGroup extends Listing {
    groupType: GroupType;
    groupName: string;
    deliveryTypes: ValueTupleOfDeliveryTypeAndNullableTicketType[];
    groupItems: IListingGroupItem[];
    desiredActiveListings: number | null;
    minActiveListings: number | null;
    maxActiveListings: number | null;
    targetPercentage: number | null;
    desiredAvailableQuantity: number | null;
    deprioritizedQuantities: string[] | null;
    marketplaceSettings: ListingGroupListingMarketplaceSettings | null;
    absoluteRankPremium: number | null;
    relativeRankPremium: number | null;
    /** This is for UI only - but it indicates that the entire group is locked from editing so that
when you're making edits to the groups you don't accidentally modify the groups again in parallel and create conflicts */
    isLockedFromEdits: boolean | null;
    /** Indicates whether the listing group's price stagger feature is enabled */
    isPrcStaggerOn: boolean | null;
}

export enum GroupType {
    Invisible = "Invisible",
    FullySold = "FullySold",
    Inactive = "Inactive",
    Active = "Active",
    Leader = "Leader",
}

export interface ValueTupleOfDeliveryTypeAndNullableTicketType {
    item1: DeliveryType;
    item2: TicketType | null;
}

export interface IListingGroupItem {
    ltGrpId: string | null;
    isLtGrp: boolean;
    isFull: boolean;
    id: number;
    insertBy: string | null;
    rowVer: number;
    ltGrpParentId: number | null;
    ltGrpPrior: number | null;
    seating: Seating;
    delivType: DeliveryType;
    topPriTktType: TicketType | null;
    /** This the number of tickets that have not yet sold and is always less than TicketCount. */
    availQty: number;
    wastedQty: number | null;
    ticketCnt: number;
    /** MaxDisplayQuantity */
    maxDispQty: number;
    /** ManualMaxDisplayQuantity */
    manMaxDispQty: number | null;
    ltGrpActive: boolean | null;
    unitCst: UiMoney | null;
    faceValue: UiMoney | null;
    currency: string;
    isDeleted: boolean;
    ltGrpUndercut: ListingGroupUndercutSetting | null;
    /** Marketplace listing broadcast status */
    brdcstStatus: ListingBroadcastStatus | null;
}

export interface PosUiActionResultWithDataOfAutoCompListingsPreview extends PosUiActionResult {
    data: AutoCompListingsPreview | null;
}

export interface AutoCompListingsPreview {
    zoneSectionAreaGroupLookup: ZoneSectionAreaGroupLookup;
}

export interface ZoneSectionAreaGroupLookup {
    zoneSectionAreaRankOverrides: ZoneSectionAreaRankOverride[];
    groupIdToSectionIdMap: { [key: string]: ZoneSectionArea[]; };
    groupIdToMedianSeatScoreMap: { [key: string]: number; };
    sectionIdToGroupIdMap: { [key: string]: string; };
    zoneNameToRankMap: { [key: string]: { [key: string]: number; }; };
    customSectionGroups: string[];
}

export interface ZoneSectionAreaRankOverride {
    zoneAreaName: string;
    rank: number;
    color: string;
}

export interface ZoneSectionArea {
    sectId: number;
    rank: number;
    zoneAreaName: string;
    ticketClassId: number;
    ticketClassName: string;
}

/** Input settings for the auto comparison preview. */
export interface AutoCompSettingsPreviewInput {
    viagogoEventId: number;
    venueZoneConfigType: VenueZoneConfigType;
    combineCornersAndEnds: boolean;
}

export interface PosUiActionResultWithDataOfAutoGroupListingsPreview extends PosUiActionResult {
    data: AutoGroupListingsPreview | null;
}

export interface AutoGroupListingsPreview {
    listingGroups: { [key: string]: AutoGroupListingsPreviewListingUpdate[]; };
}

export interface AutoGroupListingsPreviewListingUpdate {
    listingId: number;
    selectedSectionSettings: SelectedSectionSettings | null;
    onlyForSelectedSectionsEnabled: boolean | null;
    compListingMode: AutoPricingCompListingMode | null;
    compListingFloor: number | null;
    compListingCeiling: number | null;
    autoPricingEnabled: boolean | null;
    circuitBreakerMinCompListingCount: number | null;
    excludeFanInventory: boolean | null;
    area: RowArea;
    filteredAreas: RowArea[];
}

export interface RowArea extends RowInfo {
    sectId: number;
    normOrd: number;
    area: ConfigArea;
    sectName: string;
}

export interface ConfigArea {
    areaName: string;
    rank: number;
}

export interface AutoGroupListingsPreviewInput {
    viagogoEventId: number;
    eventListingIds: number[];
    zoneSectionAreaGroupLookupJson: string;
    /** Determines how the offset ordinal for row comps */
    rowCompOffset: number;
    /** Determines how the RowArea names will be determined */
    rowGroupSetting: RowGroupSetting;
    venueZoneConfigType: VenueZoneConfigType;
    combineCornersAndEnds: boolean;
    rowCompOverrides: RowCompOverride[];
    useCustomRank: boolean;
}

export interface PosUiActionResultWithDataOfIEnumerableOfMergeListingGroupInput extends PosUiActionResult {
    data: (MergeListingGroupInput | null)[] | null;
}

export interface ListingGroupCompData {
    totalCompListingCount: number;
    compListings: CompListing[];
}

/** Response model for listing aggregations */
export interface ListingAggregationResponse {
    /** Aggregated summary in target currency */
    summary: ListingAggregationSummary;
    /** Optional breakdown by original currency */
    byOriginalCurrency: CurrencyBreakdown[] | null;
    /** Metadata about the aggregation computation */
    metadata: AggregationResponseMetadata;
}

/** Aggregation summary for listing entities Based on calculations in ListingSummaryFactory */
export interface ListingAggregationSummary {
    /** Total number of tickets across all listings */
    totalTickets: number;
    /** Total number of available tickets */
    totalAvailableTickets: number;
    /** Total number of sold tickets (TicketCount - AvailableQty) */
    totalSoldTickets: number;
    /** Total number of wasted tickets */
    totalWastedTickets: number;
    /** Total max display quantity */
    totalMaxDisplayQuantity: number;
    /** Total manual max display quantity */
    totalManualMaxDisplayQuantity: number;
    /** Total shown quantity: Sum(ManMaxDispQty ?? MaxDispQty)
Matches ListingSummaryFactory.totalShownQuantity calculation */
    totalShownQuantity: number;
    /** Total cost of all tickets */
    totalCost: UiMoney | null;
    /** Total face value of all tickets */
    totalFaceValue: UiMoney | null;
    /** Total cost of sold tickets: (unitCost ?? faceValue) * soldQty */
    totalSoldCost: UiMoney | null;
    /** Total cost of unsold tickets: (unitCost ?? faceValue) * availQty */
    totalUnsoldCost: UiMoney | null;
    /** Total cost of wasted tickets: (unitCost ?? faceValue) * wastedQty */
    totalWastedCost: UiMoney | null;
    /** Total list price across all available tickets */
    totalListPrice: UiMoney | null;
    /** Total all-in price across all available tickets */
    totalAllInPrice: UiMoney | null;
    /** Aggregated unit cost (weighted average or total cost / total tickets) */
    aggregatedUnitCost: UiMoney | null;
    /** Aggregated face value (weighted average) */
    aggregatedFaceValue: UiMoney | null;
    /** Average list price per available ticket */
    averageListPrice: number;
    /** Average all-in price per available ticket */
    averageAllInPrice: number;
    /** Currency of the aggregated amounts */
    currency: string;
    /** Number of listings included in aggregation */
    listingCount: number;
}

/** Currency breakdown for response */
export interface CurrencyBreakdown {
    /** Currency code */
    currency: string;
    /** Number of documents in this currency */
    documentCount: number;
    /** Aggregated values in original currency */
    summary: ListingAggregationSummary;
}

/** Metadata for aggregation response */
export interface AggregationResponseMetadata {
    /** Total number of documents matched */
    totalDocuments: number;
    /** Number of different currencies found */
    currencyCount: number;
    /** Target currency used for final aggregation */
    targetCurrency: string;
    /** When the aggregation was computed */
    computedAt: string;
    /** Time taken for OpenSearch query (milliseconds) */
    openSearchTookMs: number;
    /** Time taken for server-side processing (milliseconds) */
    processingTookMs: number;
}

/** Generic request model for multi-currency aggregations */
export interface MultiCurrencyAggregationRequestOfListingSearchRequestV2AndListingFilterQueryV2 {
    /** The OpenSearch request containing filter criteria and options */
    request: ListingSearchRequestV2;
    /** Target currency for final aggregation results */
    targetCurrency: string;
    /** Whether to include currency-by-currency breakdown in response */
    includeCurrencyBreakdown: boolean;
}

export interface OpenSearchRequestOfListingFilterQueryV2 {
    filter: ListingFilterQueryV2;
    options: SearchOptions | null;
    allowedFields: string[] | null;
    appliedSecurityFilters: string[] | null;
    dataIsolationContext: { [key: string]: any; } | null;
}

export interface ListingSearchRequestV2 extends OpenSearchRequestOfListingFilterQueryV2 {
}

export interface ListingFilterQueryV2 {
    eventIds: FieldFilter | null;
    eventDates: FieldFilter | null;
    eventTimeFrameFilters: FieldFilter | null;
    clientTimezoneOffsetMins: number | null;
    eventStatuses: FieldFilter | null;
    topLevelCategories: FieldFilter | null;
    parentCategories: FieldFilter | null;
    eventOrMappingIds: FieldFilter | null;
    oldPosEventIds: FieldFilter | null;
    performerIds: FieldFilter | null;
    venueIds: FieldFilter | null;
    countryCodes: FieldFilter | null;
    stateProvinceIds: FieldFilter | null;
    cityIds: FieldFilter | null;
    eventNotReviewedSince: FieldFilter | null;
    lastSaleDates: FieldFilter | null;
    numberOfAvailableTickets: FieldFilter | null;
    eventHasUnsoldTickets: FieldFilter | null;
    hasUnpricedListings: FieldFilter | null;
    isListed: FieldFilter | null;
    hasBroadcastError: FieldFilter | null;
    isDuplicate: FieldFilter | null;
    hasListingGroupId: FieldFilter | null;
    isAdminHold: FieldFilter | null;
    isPendingProof: FieldFilter | null;
    listingIds: FieldFilter | null;
    lastPriceUpdateDates: FieldFilter | null;
    lastUpdateDates: FieldFilter | null;
    listingInsertByIds: FieldFilter | null;
    sellerAccountIds: FieldFilter | null;
    pricedByIds: FieldFilter | null;
    isAutoPricingEnabled: FieldFilter | null;
    autoPricingResultState: FieldFilter | null;
    isPriced: FieldFilter | null;
    isPricedByMarketplace: FieldFilter | null;
    currencyCodes: FieldFilter | null;
    isPredelivered: FieldFilter | null;
    deliveryTypes: FieldFilter | null;
    inHandDates: FieldFilter | null;
    ticketTypes: FieldFilter | null;
    isNoFulfill: FieldFilter | null;
    hasUnsoldTickets: FieldFilter | null;
    section: FieldFilter | null;
    row: FieldFilter | null;
    splitTypes: FieldFilter | null;
    isEventMappingRejected: FieldFilter | null;
    isEventMapped: FieldFilter | null;
    isSeatingUnmapped: FieldFilter | null;
    internalNotes: FieldFilter | null;
    tagPairs: TagPairFilter | null;
    eventTagPairs: TagPairFilter | null;
    purchaseOrderTagPairs: TagPairFilter | null;
    purchaseOrdersFilter: PurchaseOrderNestedFilter | null;
    unitCosts: FieldFilter | null;
    prices: FieldFilter | null;
    priceFilterIsConverted: boolean;
    quantity: FieldFilter | null;
    quantitySold: FieldFilter | null;
    quantityWasted: FieldFilter | null;
    isUndeliverable: FieldFilter | null;
    isSeatSaver: FieldFilter | null;
    and: ListingFilterQueryV2[] | null;
    or: ListingFilterQueryV2[] | null;
    orConditions: ListingFilterQueryV2[] | null;
    not: boolean | null;
    orListingInsertByUserId: string | null;
    orPricerSellerUserId: string | null;
    orPricerSellerUserIds: string[] | null;
    orPurchaseBuyerId: string | null;
    orPurchaseBuyerIds: string[] | null;
    dataIsolationContext: { [key: string]: any; } | null;
    allowedFields: string[] | null;
    appliedSecurityFilters: string[] | null;
}

export interface FieldFilter {
    operation: FilterOperationType;
    value: any | null;
    values: any[] | null;
    start: any | null;
    end: any | null;
    min: any | null;
    max: any | null;
}

export interface TagPairFilter {
    operation: TagPairOperation;
    pairs: TagPair[];
}

export enum TagPairOperation {
    AnyOf = "AnyOf",
    AllOf = "AllOf",
    Contains = "Contains",
    Equals = "Equals",
    NotExists = "NotExists",
    NotEquals = "NotEquals",
    NotContains = "NotContains",
}

export interface TagPair {
    name: string;
    value: string | null;
    operation: TagPairOperation | null;
}

export interface PurchaseOrderNestedFilter {
    purchaseOrderIds: FieldFilter | null;
    purchaseOrderDates: FieldFilter | null;
    purchaseOrderVendorOrderIds: FieldFilter | null;
    purchaseOrderVendorAccountIds: FieldFilter | null;
    purchaseOrderVendorIds: FieldFilter | null;
    buyerUserIds: FieldFilter | null;
    purchaseOrderInsertByUserIds: FieldFilter | null;
    encryptedEmailAddresses: FieldFilter | null;
    purchaseOrderVendorAccountNames: FieldFilter | null;
    purchaseOrderVendorNames: FieldFilter | null;
}

export interface SearchOptions {
    size: number | null;
    from: number | null;
    sort: SortCriteria[] | null;
    aggregations: AggregationDictionary | null;
    timeoutMs: number | null;
    includeAggregations: boolean;
    allowedFields: string[] | null;
    pitId: string | null;
    searchAfter: any[] | null;
    keepAlive: string | null;
    pitPaginationDisabled: boolean;
    usesPitPagination: boolean;
    terminateAfter: number | null;
    trackTotalHits: boolean | null;
}

export interface SortCriteria {
    field: string | null;
    order: string | null;
    userNames: { [key: string]: string; } | null;
}

export interface IsADictionaryBaseOfStringAndIAggregationContainer {
    Item: IAggregationContainer | null;
    BackingDictionary: { [key: string]: IAggregationContainer; } | null;
}

/** Describes aggregations that we would like to execute on OpenSearch. In OSC Aggregation always refers to an aggregation sent to OpenSearch and an Aggregate describes an aggregation returned from OpenSearch. */
export interface AggregationDictionary extends IsADictionaryBaseOfStringAndIAggregationContainer {
}

export interface IAggregationContainer {
    adjacencyMatrix: IAdjacencyMatrixAggregation | null;
    aggregations: AggregationDictionary | null;
    average: IAverageAggregation | null;
    averageBucket: IAverageBucketAggregation | null;
    bucketScript: IBucketScriptAggregation | null;
    bucketSelector: IBucketSelectorAggregation | null;
    bucketSort: IBucketSortAggregation | null;
    cardinality: ICardinalityAggregation | null;
    children: IChildrenAggregation | null;
    composite: ICompositeAggregation | null;
    cumulativeSum: ICumulativeSumAggregation | null;
    dateHistogram: IDateHistogramAggregation | null;
    autoDateHistogram: IAutoDateHistogramAggregation | null;
    dateRange: IDateRangeAggregation | null;
    derivative: IDerivativeAggregation | null;
    diversifiedSampler: IDiversifiedSamplerAggregation | null;
    extendedStats: IExtendedStatsAggregation | null;
    extendedStatsBucket: IExtendedStatsBucketAggregation | null;
    filter: IFilterAggregation | null;
    filters: IFiltersAggregation | null;
    geoBounds: IGeoBoundsAggregation | null;
    geoCentroid: IGeoCentroidAggregation | null;
    geoDistance: IGeoDistanceAggregation | null;
    geoHash: IGeoHashGridAggregation | null;
    geoLine: IGeoLineAggregation | null;
    geoTile: IGeoTileGridAggregation | null;
    global: IGlobalAggregation | null;
    histogram: IHistogramAggregation | null;
    ipRange: IIpRangeAggregation | null;
    matrixStats: IMatrixStatsAggregation | null;
    max: IMaxAggregation | null;
    maxBucket: IMaxBucketAggregation | null;
    meta: { [key: string]: any; } | null;
    min: IMinAggregation | null;
    minBucket: IMinBucketAggregation | null;
    missing: IMissingAggregation | null;
    movingAverage: IMovingAverageAggregation | null;
    movingFunction: IMovingFunctionAggregation | null;
    nested: INestedAggregation | null;
    /** A special single bucket aggregation that selects parent documents that
have the specified type, as defined in a join field. */
    parent: IParentAggregation | null;
    percentileRanks: IPercentileRanksAggregation | null;
    percentiles: IPercentilesAggregation | null;
    percentilesBucket: IPercentilesBucketAggregation | null;
    range: IRangeAggregation | null;
    rareTerms: IRareTermsAggregation | null;
    reverseNested: IReverseNestedAggregation | null;
    sampler: ISamplerAggregation | null;
    scriptedMetric: IScriptedMetricAggregation | null;
    serialDifferencing: ISerialDifferencingAggregation | null;
    significantTerms: ISignificantTermsAggregation | null;
    significantText: ISignificantTextAggregation | null;
    stats: IStatsAggregation | null;
    statsBucket: IStatsBucketAggregation | null;
    sum: ISumAggregation | null;
    sumBucket: ISumBucketAggregation | null;
    terms: ITermsAggregation | null;
    topHits: ITopHitsAggregation | null;
    valueCount: IValueCountAggregation | null;
    weightedAverage: IWeightedAverageAggregation | null;
    medianAbsoluteDeviation: IMedianAbsoluteDeviationAggregation | null;
    multiTerms: IMultiTermsAggregation | null;
    variableWidthHistogram: IVariableWidthHistogramAggregation | null;
}

export interface IAdjacencyMatrixAggregation {
    filters: INamedFiltersContainer | null;
}

export interface INamedFiltersContainer {
}

export interface IAverageAggregation {
}

export interface IAverageBucketAggregation {
}

export interface IBucketScriptAggregation {
    script: IScript | null;
}

/** A script to execute to provide custom computation */
export interface IScript {
    /** Language of script. */
    lang: string | null;
    /** Scripts are compiled and cached for faster execution.
If the same script can be used, just with different parameters provided,
it is preferable to use the ability to pass parameters to the script itself.
             */
    params: { [key: string]: any; } | null;
}

export interface IBucketSelectorAggregation {
    script: IScript | null;
}

/** A parent pipeline aggregation which sorts the buckets of its parent multi-bucket aggregation. Zero or more sort fields may be specified together with the corresponding sort order. Each bucket may be sorted based on its _key, _count or its sub-aggregations. In addition, parameters from and size may be set in order to truncate the result buckets. */
export interface IBucketSortAggregation {
    /** Buckets in positions prior to the set value will be truncated */
    from: number | null;
    /** The policy to apply when gaps are found in the data */
    gapPolicy: GapPolicy | null;
    /** The number of buckets to return. Defaults to all buckets of the parent aggregation
             */
    size: number | null;
    /** The list of fields to sort on */
    sort: ISort[] | null;
}

export enum GapPolicy {
    Skip = "skip",
    InsertZeros = "insert_zeros",
}

export interface ISort {
    /** Specifies how documents which are missing the sort field should
be treated. */
    missing: any | null;
    /** Controls what collection value is picked for sorting a document
when the field is a collection */
    mode: SortMode | null;
    /** Set a single resolution for the sort */
    numericType: NumericType | null;
    /** Specifies the path and filter to apply when sorting on a nested field */
    nested: INestedSort | null;
    /** Controls the order of sorting */
    order: SortOrder | null;
}

/** OpenSearch supports sorting by array or multi-valued fields. The mode option controls what array value is picked for sorting the document it belongs to. */
export enum SortMode {
    Min = "min",
    Max = "max",
    Sum = "sum",
    Average = "avg",
    Median = "median",
}

/** For numeric fields it is also possible to cast the values from one type to another using this option. This can be useful for cross-index search if the sort field is mapped differently on some indices. */
export enum NumericType {
    Long = "long",
    Double = "double",
    Date = "date",
    DateNanos = "date_nanos",
}

/** Sort on a field inside one or more nested objects. */
export interface INestedSort {
    /** A filter that the inner objects inside the nested path should match with in order for its field values to be taken into account
by sorting. A common pattern is to repeat the query/filter inside the nested filter or query.
By default no nested filter is active. */
    filter: QueryContainer | null;
    /** Same as top-level nested, but applies to another nested path within the current nested object. */
    nested: INestedSort | null;
    /** Defines on which nested object to sort. The actual sort field must be a direct field inside this nested object.
When sorting by nested field, this field is mandatory. */
    path: Field | null;
    /** The maximum number of children to consider per root document when picking the sort value. Defaults to unlimited. */
    maxChildren: number | null;
}

export interface QueryContainer {
}

export interface Field {
    /** A boost to apply to the field */
    boost: number | null;
    /** A format to apply to the field. */
    format: string | null;
    cachableExpression: boolean;
    /** An expression from which the name of the field can be inferred */
    expression: Expression | null;
    /** The name of the field */
    name: string | null;
    /** A property from which the name of the field can be inferred */
    property: PropertyInfo | null;
}

export interface Expression {
    nodeType: ExpressionType;
    type: string;
    canReduce: boolean;
}

export enum ExpressionType {
    Add = "Add",
    AddChecked = "AddChecked",
    And = "And",
    AndAlso = "AndAlso",
    ArrayLength = "ArrayLength",
    ArrayIndex = "ArrayIndex",
    Call = "Call",
    Coalesce = "Coalesce",
    Conditional = "Conditional",
    Constant = "Constant",
    Convert = "Convert",
    ConvertChecked = "ConvertChecked",
    Divide = "Divide",
    Equal = "Equal",
    ExclusiveOr = "ExclusiveOr",
    GreaterThan = "GreaterThan",
    GreaterThanOrEqual = "GreaterThanOrEqual",
    Invoke = "Invoke",
    Lambda = "Lambda",
    LeftShift = "LeftShift",
    LessThan = "LessThan",
    LessThanOrEqual = "LessThanOrEqual",
    ListInit = "ListInit",
    MemberAccess = "MemberAccess",
    MemberInit = "MemberInit",
    Modulo = "Modulo",
    Multiply = "Multiply",
    MultiplyChecked = "MultiplyChecked",
    Negate = "Negate",
    UnaryPlus = "UnaryPlus",
    NegateChecked = "NegateChecked",
    New = "New",
    NewArrayInit = "NewArrayInit",
    NewArrayBounds = "NewArrayBounds",
    Not = "Not",
    NotEqual = "NotEqual",
    Or = "Or",
    OrElse = "OrElse",
    Parameter = "Parameter",
    Power = "Power",
    Quote = "Quote",
    RightShift = "RightShift",
    Subtract = "Subtract",
    SubtractChecked = "SubtractChecked",
    TypeAs = "TypeAs",
    TypeIs = "TypeIs",
    Assign = "Assign",
    Block = "Block",
    DebugInfo = "DebugInfo",
    Decrement = "Decrement",
    Dynamic = "Dynamic",
    Default = "Default",
    Extension = "Extension",
    Goto = "Goto",
    Increment = "Increment",
    Index = "Index",
    Label = "Label",
    RuntimeVariables = "RuntimeVariables",
    Loop = "Loop",
    Switch = "Switch",
    Throw = "Throw",
    Try = "Try",
    Unbox = "Unbox",
    AddAssign = "AddAssign",
    AndAssign = "AndAssign",
    DivideAssign = "DivideAssign",
    ExclusiveOrAssign = "ExclusiveOrAssign",
    LeftShiftAssign = "LeftShiftAssign",
    ModuloAssign = "ModuloAssign",
    MultiplyAssign = "MultiplyAssign",
    OrAssign = "OrAssign",
    PowerAssign = "PowerAssign",
    RightShiftAssign = "RightShiftAssign",
    SubtractAssign = "SubtractAssign",
    AddAssignChecked = "AddAssignChecked",
    MultiplyAssignChecked = "MultiplyAssignChecked",
    SubtractAssignChecked = "SubtractAssignChecked",
    PreIncrementAssign = "PreIncrementAssign",
    PreDecrementAssign = "PreDecrementAssign",
    PostIncrementAssign = "PostIncrementAssign",
    PostDecrementAssign = "PostDecrementAssign",
    TypeEqual = "TypeEqual",
    OnesComplement = "OnesComplement",
    IsTrue = "IsTrue",
    IsFalse = "IsFalse",
}

export interface MemberInfo {
    module: Module;
    customAttributes: CustomAttributeData[];
    isCollectible: boolean;
    metadataToken: number;
}

export interface PropertyInfo extends MemberInfo {
    memberType: MemberTypes;
    isSpecialName: boolean;
    getMethod: MethodInfo | null;
    setMethod: MethodInfo | null;
}

export enum MemberTypes {
    Constructor = "Constructor",
    Event = "Event",
    Field = "Field",
    Method = "Method",
    Property = "Property",
    TypeInfo = "TypeInfo",
    Custom = "Custom",
    NestedType = "NestedType",
    All = "All",
}

export interface MethodBase extends MemberInfo {
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
}

export interface MethodInfo extends MethodBase {
    memberType: MemberTypes;
    returnParameter: ParameterInfo;
    returnType: string;
}

export interface ParameterInfo {
    attributes: ParameterAttributes;
    member: MemberInfo;
    name: string | null;
    parameterType: string;
    position: number;
    isIn: boolean;
    isLcid: boolean;
    isOptional: boolean;
    isOut: boolean;
    isRetval: boolean;
    defaultValue: any | null;
    rawDefaultValue: any | null;
    hasDefaultValue: boolean;
    customAttributes: CustomAttributeData[];
    metadataToken: number;
}

export enum ParameterAttributes {
    None = "None",
    In = "In",
    Out = "Out",
    Lcid = "Lcid",
    Retval = "Retval",
    Optional = "Optional",
    HasDefault = "HasDefault",
    HasFieldMarshal = "HasFieldMarshal",
    Reserved3 = "Reserved3",
    Reserved4 = "Reserved4",
    ReservedMask = "ReservedMask",
}

export interface Module {
    assembly: Assembly;
    fullyQualifiedName: string;
    name: string;
    mdStreamVersion: number;
    moduleVersionId: string;
    scopeName: string;
    moduleHandle: ModuleHandle;
    customAttributes: CustomAttributeData[];
    metadataToken: number;
}

export interface Assembly {
    definedTypes: string[];
    exportedTypes: string[];
    codeBase: string | null;
    entryPoint: MethodInfo | null;
    fullName: string | null;
    imageRuntimeVersion: string;
    isDynamic: boolean;
    location: string;
    reflectionOnly: boolean;
    isCollectible: boolean;
    isFullyTrusted: boolean;
    customAttributes: CustomAttributeData[];
    escapedCodeBase: string;
    manifestModule: Module;
    modules: Module[];
    globalAssemblyCache: boolean;
    hostContext: number;
    securityRuleSet: SecurityRuleSet;
}

export interface CustomAttributeData {
    attributeType: string;
    constructor: ConstructorInfo;
    constructorArguments: CustomAttributeTypedArgument[];
    namedArguments: CustomAttributeNamedArgument[];
}

export interface ConstructorInfo extends MethodBase {
    memberType: MemberTypes;
}

export enum MethodImplAttributes {
    IL = "Managed",
    Managed = "Managed",
    Native = "Native",
    OPTIL = "OPTIL",
    CodeTypeMask = "Runtime",
    Runtime = "Runtime",
    ManagedMask = "ManagedMask",
    Unmanaged = "ManagedMask",
    NoInlining = "NoInlining",
    ForwardRef = "ForwardRef",
    Synchronized = "Synchronized",
    NoOptimization = "NoOptimization",
    PreserveSig = "PreserveSig",
    AggressiveInlining = "AggressiveInlining",
    AggressiveOptimization = "AggressiveOptimization",
    InternalCall = "InternalCall",
    MaxMethodImplVal = "MaxMethodImplVal",
}

export enum CallingConventions {
    Standard = "Standard",
    VarArgs = "VarArgs",
    Any = "Any",
    HasThis = "HasThis",
    ExplicitThis = "ExplicitThis",
}

export interface CustomAttributeTypedArgument {
    argumentType: string;
    value: any | null;
}

export interface CustomAttributeNamedArgument {
    memberInfo: MemberInfo;
    typedValue: CustomAttributeTypedArgument;
    memberName: string;
    isField: boolean;
}

export enum SecurityRuleSet {
    None = "None",
    Level1 = "Level1",
    Level2 = "Level2",
}

export interface ModuleHandle {
    mdStreamVersion: number;
}

export enum SortOrder {
    Ascending = "asc",
    Descending = "desc",
}

export interface ICardinalityAggregation {
    precisionThreshold: number | null;
    rehash: boolean | null;
}

export interface IChildrenAggregation {
    type: RelationName | null;
}

export interface RelationName {
    name: string | null;
    type: string | null;
}

/** A multi-bucket aggregation that creates composite buckets from different sources. */
export interface ICompositeAggregation {
    /** Used to retrieve the composite buckets that are after the
last composite buckets returned in a previous round */
    after: CompositeKey | null;
    /** Defines how many composite buckets should be returned.
Each composite bucket is considered as a single bucket so
setting a size of 10 will return the first 10 composite buckets
created from the values source. */
    size: number | null;
    /** Controls the sources that should be used to build the composite buckets */
    sources: ICompositeAggregationSource[] | null;
}

export interface IsAReadOnlyDictionaryBaseOfStringAndObject {
    Count: number;
    Item: any | null;
    Keys: string[] | null;
    Values: any[] | null;
    BackingDictionary: { [key: string]: any; } | null;
}

/** A key for a CompositeBucket */
export interface CompositeKey extends IsAReadOnlyDictionaryBaseOfStringAndObject {
}

/** A values source for ICompositeAggregation */
export interface ICompositeAggregationSource {
    /** The field from which to extract value */
    field: Field | null;
    /** By default documents without a value for a given source are ignored. It is possible to include
them in the response as null by setting this to true */
    missingBucket: boolean | null;
    /** Defines the direction of sorting for each
value source. Defaults to Ascending */
    order: SortOrder | null;
}

export interface ICumulativeSumAggregation {
}

export interface IDateHistogramAggregation {
    /** Extend the bounds of the date histogram beyond the data itself,
forcing the aggregation to start building buckets on
a specific min and/or max value.
Using extended bounds only makes sense when MinimumDocumentCount is 0
as empty buckets will never be returned if it is greater than 0. */
    extendedBounds: ExtendedBoundsOfDateMath | null;
    /** The hard_bounds is a counterpart of extended_bounds and can limit the range of buckets in the histogram.
It is particularly useful in the case of open data ranges that can result in a very large number of buckets. */
    hardBounds: HardBoundsOfDateMath | null;
    /** The field to target */
    field: Field | null;
    /** Return a formatted date string as the key instead an epoch long */
    format: string | null;
    /** The calendar interval to use when bucketing documents */
    calendarInterval: UnionOfNullableDateIntervalAndDateMathTime | null;
    /** The fixed interval to use when bucketing documents */
    fixedInterval: Time | null;
    /** The minimum number of documents that a bucket must contain to be returned in the response.
The default is 0 meaning that buckets with no documents will be returned. */
    minimumDocumentCount: number | null;
    /** Defines how to treat documents that are missing a value. By default, they are ignored,
but it is also possible to treat them as if they have a value. */
    missing: string | null;
    /** Change the start value of each bucket by the specified positive (+) or negative offset (-) duration,
such as 1h for an hour, or 1d for a day. */
    offset: string | null;
    /** Defines an order in which returned buckets are sorted.
By default the returned buckets are sorted by their key ascending. */
    order: HistogramOrder | null;
    /** A script to execute to provide custom computation */
    script: IScript | null;
    /** Used to indicate that bucketing should use a different time zone.
Time zones may either be specified as an ISO 8601 UTC offset (e.g. +01:00 or -08:00)
or as a timezone id, an identifier used in the TZ database like America/Los_Angeles. */
    timeZone: string | null;
}

export interface ExtendedBoundsOfDateMath {
    maximum: DateMath | null;
    minimum: DateMath | null;
}

export interface DateMath {
}

export interface HardBoundsOfDateMath {
    maximum: DateMath | null;
    minimum: DateMath | null;
}

/** Represents the union of two types,  and . Used in scenarios where an OpenSearch API may accept more than one different input data structure. */
export interface UnionOfNullableDateIntervalAndDateMathTime {
}

/** Represents a time value */
export interface Time {
    factor: number | null;
    interval: TimeUnit | null;
    milliseconds: number | null;
}

export enum TimeUnit {
    Nanoseconds = "nanos",
    Microseconds = "micros",
    Millisecond = "ms",
    Second = "s",
    Minute = "m",
    Hour = "h",
    Day = "d",
}

export interface HistogramOrder {
    key: string | null;
    order: SortOrder;
}

export interface IAutoDateHistogramAggregation {
    field: Field | null;
    buckets: number | null;
    format: string | null;
    missing: string | null;
    offset: string | null;
    params: { [key: string]: any; } | null;
    script: IScript | null;
    timeZone: string | null;
    /** Specify the minimum rounding interval that should be used. This can make the collection process
more efficient, as the aggregation will not attempt to round at any interval lower than this. */
    minimumInterval: MinimumInterval | null;
}

export enum MinimumInterval {
    Second = "second",
    Minute = "minute",
    Hour = "hour",
    Day = "day",
    Month = "month",
    Year = "year",
}

export interface IDateRangeAggregation {
    field: Field | null;
    format: string | null;
    missing: any | null;
    ranges: IDateRangeExpression[] | null;
    timeZone: string | null;
}

export interface IDateRangeExpression {
    from: DateMath | null;
    key: string | null;
    to: DateMath | null;
}

export interface IDerivativeAggregation {
}

export interface IDiversifiedSamplerAggregation {
    executionHint: DiversifiedSamplerAggregationExecutionHint | null;
    field: Field | null;
    maxDocsPerValue: number | null;
    script: IScript | null;
    shardSize: number | null;
}

export enum DiversifiedSamplerAggregationExecutionHint {
    Map = "map",
    GlobalOrdinals = "global_ordinals",
    BytesHash = "bytes_hash",
}

export interface IExtendedStatsAggregation {
    sigma: number | null;
}

export interface IExtendedStatsBucketAggregation {
    sigma: number | null;
}

export interface IFilterAggregation {
    filter: QueryContainer | null;
}

export interface IFiltersAggregation {
    filters: UnionOfINamedFiltersContainerAndIEnumerableOfQueryContainer | null;
    otherBucket: boolean | null;
    otherBucketKey: string | null;
}

/** Represents the union of two types,  and . Used in scenarios where an OpenSearch API may accept more than one different input data structure. */
export interface UnionOfINamedFiltersContainerAndIEnumerableOfQueryContainer {
}

export interface IGeoBoundsAggregation {
    wrapLongitude: boolean | null;
}

export interface IGeoCentroidAggregation {
}

export interface IGeoDistanceAggregation {
    distanceType: GeoDistanceType | null;
    field: Field | null;
    origin: GeoLocation | null;
    ranges: IAggregationRange[] | null;
    unit: DistanceUnit | null;
}

export enum GeoDistanceType {
    Arc = "arc",
    Plane = "plane",
}

/** Represents a Latitude/Longitude as a 2 dimensional point that gets serialized as { lat, lon } */
export interface GeoLocation {
    /** Latitude */
    latitude: number;
    /** Longitude */
    longitude: number;
}

/** Range that defines a bucket for either the RangeAggregation or GeoDistanceAggregation. If you are looking to store ranges as part of your document please use explicit range class e.g DateRange, FloatRange etc */
export interface IAggregationRange {
    from: number | null;
    key: string | null;
    to: number | null;
}

export enum DistanceUnit {
    Inch = "in",
    Feet = "ft",
    Yards = "yd",
    Miles = "mi",
    NauticalMiles = "nmi",
    Kilometers = "km",
    Meters = "m",
    Centimeters = "cm",
    Millimeters = "mm",
}

/** A multi-bucket aggregation that works on geo_point fields and groups points into buckets that represent cells in a grid. The resulting grid can be sparse and only contains cells that have matching data. Each cell is labeled using a geohash which is of user-definable precision. */
export interface IGeoHashGridAggregation {
    /** The name of the field indexed with geopoints. */
    field: Field | null;
    /** The string length of the geohashes used to define cells/buckets in the results.
Defaults to Precision5. */
    precision: GeoHashPrecision | null;
    /** To allow for more accurate counting of the top cells returned in the final result the aggregation defaults to returning
max(10,(size x number-of-shards)) buckets from each shard. If this heuristic is undesirable,
the number considered from each shard can be over-ridden using this parameter. */
    shardSize: number | null;
    /** The maximum number of geohash buckets to return. Defaults to 10,000. When results are trimmed,
buckets are prioritised based on the volumes of documents they contain. */
    size: number | null;
    /** Restricts the points considered to those that fall within the bounds provided. */
    bounds: IBoundingBox | null;
}

export enum GeoHashPrecision {
    Precision1 = "Precision1",
    Precision2 = "Precision2",
    Precision3 = "Precision3",
    Precision4 = "Precision4",
    Precision5 = "Precision5",
    Precision6 = "Precision6",
    Precision7 = "Precision7",
    Precision8 = "Precision8",
    Precision9 = "Precision9",
    Precision10 = "Precision10",
    Precision11 = "Precision11",
    Precision12 = "Precision12",
}

export interface IBoundingBox {
    bottomRight: GeoLocation | null;
    topLeft: GeoLocation | null;
    wellKnownText: string | null;
}

export interface IGeoLineAggregation {
    point: GeoLinePoint | null;
    sort: GeoLineSort | null;
    includeSort: boolean | null;
    sortOrder: string | null;
    size: number | null;
}

export interface GeoLinePoint {
    field: Field | null;
}

export interface GeoLineSort {
    field: Field | null;
}

export interface IGeoTileGridAggregation {
    /** The name of the field indexed with GeoPoints. */
    field: Field | null;
    /** The zoom of the key used to define cells/buckets in the results. */
    precision: GeoTilePrecision | null;
    /** To allow for more accurate counting of the top cells returned in the final result the aggregation. */
    shardSize: number | null;
    /** The maximum number of geohash buckets to return. */
    size: number | null;
}

export enum GeoTilePrecision {
    Precision0 = "Precision0",
    Precision1 = "Precision1",
    Precision2 = "Precision2",
    Precision3 = "Precision3",
    Precision4 = "Precision4",
    Precision5 = "Precision5",
    Precision6 = "Precision6",
    Precision7 = "Precision7",
    Precision8 = "Precision8",
    Precision9 = "Precision9",
    Precision10 = "Precision10",
    Precision11 = "Precision11",
    Precision12 = "Precision12",
    Precision13 = "Precision13",
    Precision14 = "Precision14",
    Precision15 = "Precision15",
    Precision16 = "Precision16",
    Precision17 = "Precision17",
    Precision18 = "Precision18",
    Precision19 = "Precision19",
    Precision20 = "Precision20",
    Precision21 = "Precision21",
    Precision22 = "Precision22",
    Precision23 = "Precision23",
    Precision24 = "Precision24",
    Precision25 = "Precision25",
    Precision26 = "Precision26",
    Precision27 = "Precision27",
    Precision28 = "Precision28",
    Precision29 = "Precision29",
}

export interface IGlobalAggregation {
}

export interface IHistogramAggregation {
    extendedBounds: ExtendedBoundsOfDouble | null;
    hardBounds: HardBoundsOfDouble | null;
    field: Field | null;
    interval: number | null;
    minimumDocumentCount: number | null;
    missing: number | null;
    offset: number | null;
    order: HistogramOrder | null;
    script: IScript | null;
}

export interface ExtendedBoundsOfDouble {
    maximum: number;
    minimum: number;
}

export interface HardBoundsOfDouble {
    maximum: number;
    minimum: number;
}

export interface IIpRangeAggregation {
    field: Field | null;
    ranges: IIpRangeAggregationRange[] | null;
}

export interface IIpRangeAggregationRange {
    from: string | null;
    mask: string | null;
    to: string | null;
}

export interface IMatrixStatsAggregation {
    mode: MatrixStatsMode | null;
}

/** The matrix_stats aggregation treats each document field as an independent sample. The mode parameter controls what array value the aggregation will use for array or multi-valued fields. */
export enum MatrixStatsMode {
    Avg = "avg",
    Min = "min",
    Max = "max",
    Sum = "sum",
    Median = "median",
}

export interface IMaxAggregation {
}

export interface IMaxBucketAggregation {
}

export interface IMinAggregation {
}

export interface IMinBucketAggregation {
}

export interface IMissingAggregation {
    field: Field | null;
}

export interface IMovingAverageAggregation {
    minimize: boolean | null;
    model: IMovingAverageModel | null;
    predict: number | null;
    window: number | null;
}

export interface IMovingAverageModel {
}

export interface IMovingFunctionAggregation {
    script: string | null;
    window: number | null;
    shift: number | null;
}

export interface INestedAggregation {
    path: Field | null;
}

/** A special single bucket aggregation that selects parent documents that have the specified type, as defined in a join field. */
export interface IParentAggregation {
    /** The type for the child in the parent/child relationship */
    type: RelationName | null;
}

export interface IPercentileRanksAggregation {
    method: IPercentilesMethod | null;
    values: number[] | null;
    keyed: boolean | null;
}

export interface IPercentilesMethod {
}

export interface IPercentilesAggregation {
    method: IPercentilesMethod | null;
    percents: number[] | null;
    keyed: boolean | null;
}

export interface IPercentilesBucketAggregation {
    percents: number[] | null;
}

export interface IRangeAggregation {
    field: Field | null;
    ranges: IAggregationRange[] | null;
    script: IScript | null;
}

/** A multi-bucket value source based aggregation which finds "rare" terms — terms that are at the long-tail of the distribution and are not frequent. Conceptually, this is like a terms aggregation that is sorted by _count ascending. */
export interface IRareTermsAggregation {
    /** Terms that should be excluded from the aggregation */
    exclude: TermsExclude | null;
    /** The field to find rare terms in */
    field: Field | null;
    /** Terms that should be included in the aggregation */
    include: TermsInclude | null;
    /** The maximum number of documents a term should appear in.
Defaults to 1 */
    maximumDocumentCount: number | null;
    /** The value that should be used if a document does not have the field being aggregated */
    missing: any | null;
    /** The precision of the internal CuckooFilters. Smaller precision leads to better approximation,
but higher memory usage. Cannot be smaller than 0.00001. Defaults to 0.01 */
    precision: number | null;
}

/** Filters which terms to exclude from the response */
export interface TermsExclude {
    /** The regular expression pattern to determine terms to exclude from the response */
    pattern: string | null;
    /** Collection of terms to exclude from the response */
    values: string[] | null;
}

/** Filters which terms to include in the response */
export interface TermsInclude {
    /** The total number of partitions we are interested in */
    numberOfPartitions: number | null;
    /** The current partition of terms we are interested in */
    partition: number | null;
}

export interface IReverseNestedAggregation {
    path: Field | null;
}

export interface ISamplerAggregation {
    shardSize: number | null;
}

export interface IScriptedMetricAggregation {
    combineScript: IScript | null;
    initScript: IScript | null;
    mapScript: IScript | null;
    params: { [key: string]: any; } | null;
    reduceScript: IScript | null;
}

export interface ISerialDifferencingAggregation {
    lag: number | null;
}

export interface ISignificantTermsAggregation {
    /** The default source of statistical information for background term
frequencies is the entire index. This scope can be narrowed
through the use of a background filter to focus in on significant
terms within a narrower context */
    backgroundFilter: QueryContainer | null;
    /** Use chi square to calculate significance score */
    chiSquare: IChiSquareHeuristic | null;
    /** Exclude term values for which buckets will be created. */
    exclude: IncludeExclude | null;
    /** Determines the mechanism by which aggregations are executed */
    executionHint: TermsAggregationExecutionHint | null;
    /** The field on which to run the aggregation */
    field: Field | null;
    /** Use Google normalized distance to calculate significance score */
    googleNormalizedDistance: IGoogleNormalizedDistanceHeuristic | null;
    /** Include term values for which buckets will be created. */
    include: IncludeExclude | null;
    /** Return only terms that match equal to or more than a configurable
number of hits */
    minimumDocumentCount: number | null;
    /** Use mutual information to calculate significance score */
    mutualInformation: IMutualInformationHeuristic | null;
    /** Use percentage to calculate significance score.

A simple calculation of the number of documents in the foreground
sample with a term divided by the number of documents in the background
with the term. By default this produces a score greater than zero
 and less than one. */
    percentageScore: IPercentageScoreHeuristic | null;
    /** Use a script to calculate a custom significance score. */
    script: IScriptedHeuristic | null;
    /** Regulates the certainty a shard has if the term should actually be added to the candidate
list or not with respect to the MinimumDocumentCount.
Terms will only be considered if their local shard frequency within
the set is higher than the ShardMinimumDocumentCount. */
    shardMinimumDocumentCount: number | null;
    /** Controls the number of candidate terms produced by each shard from which
the Size of terms is selected. */
    shardSize: number | null;
    /** Defines how many term buckets should be returned out of the overall
terms list */
    size: number | null;
}

export interface IChiSquareHeuristic {
    backgroundIsSuperSet: boolean | null;
    includeNegatives: boolean | null;
}

export interface IncludeExclude {
}

/** Determines how the terms aggregation is executed */
export enum TermsAggregationExecutionHint {
    Map = "map",
    GlobalOrdinals = "global_ordinals",
    GlobalOrdinalsHash = "global_ordinals_hash",
    GlobalOrdinalsLowCardinality = "global_ordinals_low_cardinality",
}

export interface IGoogleNormalizedDistanceHeuristic {
    backgroundIsSuperSet: boolean | null;
}

export interface IMutualInformationHeuristic {
    backgroundIsSuperSet: boolean | null;
    includeNegatives: boolean | null;
}

export interface IPercentageScoreHeuristic {
}

export interface IScriptedHeuristic {
    script: IScript | null;
}

/** An aggregation that returns interesting or unusual occurrences of free-text terms in a set. */
export interface ISignificantTextAggregation {
    /** The default source of statistical information for background term
frequencies is the entire index. This scope can be narrowed
through the use of a background filter to focus in on significant
terms within a narrower context */
    backgroundFilter: QueryContainer | null;
    /** Use chi square to calculate significance score */
    chiSquare: IChiSquareHeuristic | null;
    /** Exclude term values for which buckets will be created. */
    exclude: IncludeExclude | null;
    /** Determines the mechanism by which aggregations are executed */
    executionHint: TermsAggregationExecutionHint | null;
    /** The field on which to run the aggregation */
    field: Field | null;
    /** Whether to filter out near-duplicate text */
    filterDuplicateText: boolean | null;
    /** Use Google normalized distance to calculate significance score */
    googleNormalizedDistance: IGoogleNormalizedDistanceHeuristic | null;
    /** Include term values for which buckets will be created. */
    include: IncludeExclude | null;
    /** Return only terms that match equal to or more than a configurable
number of hits */
    minimumDocumentCount: number | null;
    /** Use mutual information to calculate significance score */
    mutualInformation: IMutualInformationHeuristic | null;
    /** Use percentage to calculate significance score.

A simple calculation of the number of documents in the foreground
sample with a term divided by the number of documents in the background
with the term. By default this produces a score greater than zero
 and less than one. */
    percentageScore: IPercentageScoreHeuristic | null;
    /** Use a script to calculate a custom significance score. */
    script: IScriptedHeuristic | null;
    /** Regulates the certainty a shard has if the term should actually be added to the candidate
list or not with respect to the MinimumDocumentCount.
Terms will only be considered if their local shard frequency within
the set is higher than the ShardMinimumDocumentCount. */
    shardMinimumDocumentCount: number | null;
    /** Controls the number of candidate terms produced by each shard from which
the Size of terms is selected. */
    shardSize: number | null;
    /** Defines how many term buckets should be returned out of the overall
terms list */
    size: number | null;
    /** Ordinarily the indexed field name and the original JSON field being
retrieved share the same name. However with more complex field
mappings using features like copy_to the source JSON field(s)
and the indexed field being aggregated can differ.
In these cases it is possible to list the JSON _source fields
from which text will be analyzed using SourceFields */
    sourceFields: Field[] | null;
}

export interface IStatsAggregation {
}

export interface IStatsBucketAggregation {
}

export interface ISumAggregation {
}

export interface ISumBucketAggregation {
}

export interface ITermsAggregation {
    collectMode: TermsAggregationCollectMode | null;
    exclude: TermsExclude | null;
    executionHint: TermsAggregationExecutionHint | null;
    field: Field | null;
    include: TermsInclude | null;
    minimumDocumentCount: number | null;
    missing: any | null;
    order: TermsOrder[] | null;
    script: IScript | null;
    shardSize: number | null;
    showTermDocCountError: boolean | null;
    size: number | null;
}

/** Determines how the terms aggregation is executed */
export enum TermsAggregationCollectMode {
    DepthFirst = "depth_first",
    BreadthFirst = "breadth_first",
}

export interface TermsOrder {
    key: string | null;
    order: SortOrder;
}

export interface ITopHitsAggregation {
    docValueFields: Field[] | null;
    explain: boolean | null;
    from: number | null;
    highlight: IHighlight | null;
    scriptFields: IScriptFields | null;
    size: number | null;
    sort: ISort[] | null;
    source: UnionOfBooleanAndISourceFilter | null;
    storedFields: Field[] | null;
    trackScores: boolean | null;
    version: boolean | null;
}

export interface IHighlight {
    /** Defines what constitutes a boundary for highlighting when using the fast vector highlighter.
It's a single string with each boundary character defined in it. It defaults to .,!? \t\n. */
    boundaryChars: string | null;
    /** Controls how far to look for boundary characters. Defaults to 20. */
    boundaryMaxScan: number | null;
    /** When highlighting a field using the unified highlighter or the fast vector highlighter, you can specify how to break the highlighted
fragments using boundary_scanner */
    boundaryScanner: BoundaryScanner | null;
    /** You can further specify boundary_scanner_locale to control which Locale is used to search the text for these boundaries. */
    boundaryScannerLocale: string | null;
    /** Define how highlighted text will be encoded.
It can be either default (no encoding) or html (will escape html, if you use html highlighting tags). */
    encoder: HighlighterEncoder | null;
    fields: { [key: string]: IHighlightField; } | null;
    /** Fragmenter can control how text should be broken up in highlight snippets. However, this option is
applicable only for the Plain Highlighter */
    fragmenter: HighlighterFragmenter | null;
    /** Controls the margin to start highlighting from when using the fast vector highlighter */
    fragmentOffset: number | null;
    /** The size of the highlighted fragment, in characters. Defaults to 100 */
    fragmentSize: number | null;
    /** The query to use for highlighting */
    highlightQuery: QueryContainer | null;
    /** If this setting is set to a non-negative value, the highlighting stops at this defined maximum limit, and the
rest of the text is not processed, thus not highlighted and no error is returned. */
    maxAnalyzerOffset: number | null;
    maxFragmentLength: number | null;
    /** In the case where there is no matching fragment to highlight, the default is to not return anything. Instead, we can return a snippet of
text from
the beginning of the field by setting no_match_size (default 0) to the length of the text that you want returned. The actual length may be
shorter or longer than specified as it tries to break on a word boundary. */
    noMatchSize: number | null;
    /** The maximum number of fragments to return. Defaults to 5. */
    numberOfFragments: number | null;
    /** The order in which highlighted fragments are sorted */
    order: HighlighterOrder | null;
    /** Controls the post tag in which to wrap highights.
By default, the highlighting will wrap highlighted text in <em> and </em>.
Using the fast vector highlighter, there can be more tags, and the importance is ordered. */
    postTags: string[] | null;
    /** Controls the pre tag in which to wrap highights.
By default, the highlighting will wrap highlighted text in <em> and </em>.
Using the fast vector highlighter, there can be more tags, and the importance is ordered. */
    preTags: string[] | null;
    /** Use a specific "tag" schemas. */
    requireFieldMatch: boolean | null;
    /** Use a specific "tag" schemas. */
    tagsSchema: HighlighterTagsSchema | null;
}

export enum BoundaryScanner {
    Characters = "chars",
    Sentence = "sentence",
    Word = "word",
}

/** Indicates if the highlighted text should be HTML encoded */
export enum HighlighterEncoder {
    Default = "default",
    Html = "html",
}

export interface IHighlightField {
    /** Defines what constitutes a boundary for highlighting when using the fast vector highlighter.
It's a single string with each boundary character defined in it. It defaults to .,!? \t\n. */
    boundaryChars: string | null;
    /** Controls how far to look for boundary characters. Defaults to 20. */
    boundaryMaxScan: number | null;
    /** When highlighting a field using the unified highlighter or the fast vector highlighter, you can specify how to break
the highlighted
fragments using boundary_scanner */
    boundaryScanner: BoundaryScanner | null;
    /** You can further specify boundary_scanner_locale to control which Locale is used to search the text for these
boundaries. */
    boundaryScannerLocale: string | null;
    /** The field on which to perform highlighting. */
    field: Field | null;
    /** Forces the highlighting to highlight fields based on the source even if fields are stored separately. */
    forceSource: boolean | null;
    /** Fragmenter can control how text should be broken up in highlight snippets. However, this option is
applicable only for the Plain Highlighter */
    fragmenter: HighlighterFragmenter | null;
    /** Controls the margin to start highlighting from when using the fast vector highlighter */
    fragmentOffset: number | null;
    /** The size of the highlighted fragment, in characters. Defaults to 100 */
    fragmentSize: number | null;
    /** The query to use for highlighting */
    highlightQuery: QueryContainer | null;
    /** Combine matches on multiple fields to highlight a single field when using the fast vector highighter.
This is most intuitive for multifields that analyze the same string in different ways.
All matched fields must have term_vector set to with_positions_offsets, but only the field to
which the matches are combined is loaded so only that field would benefit from having store set to yes. */
    matchedFields: Field[] | null;
    /** If this setting is set to a non-negative value, the highlighting stops at this defined maximum limit, and the
rest of the text is not processed, thus not highlighted and no error is returned. */
    maxAnalyzerOffset: number | null;
    maxFragmentLength: number | null;
    /** The length of a snippet of text from the beginning of the field to return
when no match for highlighting is found. Default behaviour is to not return anything when a match is not found.
The actual length may be shorter than specified as it tries to break on a word boundary. */
    noMatchSize: number | null;
    /** The maximum number of fragments to return. Defaults to 5. */
    numberOfFragments: number | null;
    /** The order in which highlighted fragments are sorted. Only valid for the unified highlighter. */
    order: HighlighterOrder | null;
    /** Controls the number of matching phrases in a document that are considered. Prevents the
Fvh highlighter from analyzing too many phrases and consuming too much memory.
When using matched_fields, PhraseLimit phrases per matched field are considered. Raising the limit
increases query time
and consumes more memory. Only supported by the Fvh highlighter. Defaults to 256. */
    phraseLimit: number | null;
    /** Controls the post tag in which to wrap highights.
By default, the highlighting will wrap highlighted text in <em> and </em>.
Using the fast vector highlighter, there can be more tags, and the importance is ordered. */
    postTags: string[] | null;
    /** Controls the pre tag in which to wrap highights.
By default, the highlighting will wrap highlighted text in <em> and </em>.
Using the fast vector highlighter, there can be more tags, and the importance is ordered. */
    preTags: string[] | null;
    /** Determines if only fields that hold a query match will be highlighted. Set to false
will cause any field to be highlighted regardless of whether the query matched specifically on them. Default behaviour
is true. */
    requireFieldMatch: boolean | null;
    /** Use a specific "tag" schemas. */
    tagsSchema: HighlighterTagsSchema | null;
    /** The type of highlighter to use. Can be a defined or custom highlighter */
    type: UnionOfHighlighterTypeAndString | null;
}

/** Fragmenter can control how text should be broken up in highlight snippets. However, this option is applicable only for the Plain Highlighter */
export enum HighlighterFragmenter {
    Simple = "simple",
    Span = "span",
}

/** Sorts highlighted fragments */
export enum HighlighterOrder {
    Score = "score",
}

/** Use a built-in tag schema */
export enum HighlighterTagsSchema {
    Styled = "styled",
}

/** Represents the union of two types,  and . Used in scenarios where an OpenSearch API may accept more than one different input data structure. */
export interface UnionOfHighlighterTypeAndString {
}

export interface IScriptFields {
}

/** Represents the union of two types,  and . Used in scenarios where an OpenSearch API may accept more than one different input data structure. */
export interface UnionOfBooleanAndISourceFilter {
}

export interface IValueCountAggregation {
}

export interface IWeightedAverageAggregation {
    /** The optional numeric response formatter */
    format: string | null;
    /** The configuration for the field or script that provides the values */
    value: IWeightedAverageValue | null;
    /** A hint about the values for pure scripts or unmapped fields  */
    valueType: ValueType | null;
    /** The configuration for the field or script that provides the weights */
    weight: IWeightedAverageValue | null;
}

/** The configuration for a field or script that provides a value or weight for WeightedAverageAggregation */
export interface IWeightedAverageValue {
    /** The field that values should be extracted from */
    field: Field | null;
    /** defines how documents that are missing a value should be treated.
            The default behavior is different for value and weight:
            By default, if the value field is missing the document is ignored and the aggregation
            moves on to the next document.
            If the weight field is missing, it is assumed to have a weight of 1 (like a normal average).
             */
    missing: number | null;
    /** A script to derive the value and the weight from */
    script: IScript | null;
}

/** The type of value */
export enum ValueType {
    String = "string",
    Long = "long",
    Double = "double",
    Number = "number",
    Date = "date",
    DateNanos = "date_nanos",
    Ip = "ip",
    Numeric = "numeric",
    GeoPoint = "geo_point",
    Boolean = "boolean",
}

/** This single-value aggregation approximates the median absolute deviation of its search results.                       	Median absolute deviation is a measure of variability. It is a robust statistic, meaning that it is useful for describing data that may have outliers, or may not be normally distributed. For such data it can be more descriptive than standard deviation.                       	It is calculated as the median of each data point’s deviation from the median of the entire sample. That is, for a random variable X, the median absolute deviation is median(|median(X) - Xi|). */
export interface IMedianAbsoluteDeviationAggregation {
    /** TDigest algorithm component that controls memory usage and approximation error.
By increasing the compression value, you can increase the accuracy
at the cost of more memory. Larger compression values also make
the algorithm slower since the underlying tree data structure grows in
size, resulting in more expensive operations. The default compression value is 100. */
    compression: number | null;
}

export interface IMultiTermsAggregation {
    collectMode: TermsAggregationCollectMode | null;
    minimumDocumentCount: number | null;
    order: TermsOrder[] | null;
    script: IScript | null;
    shardMinimumDocumentCount: number | null;
    shardSize: number | null;
    showTermDocCountError: boolean | null;
    size: number | null;
    terms: ITerm[] | null;
}

export interface ITerm {
    field: Field | null;
    missing: any | null;
}

export interface IVariableWidthHistogramAggregation {
    /** The field to target. */
    field: Field | null;
    buckets: number | null;
    initialBuffer: number | null;
    shardSize: number | null;
}

/** Result of a secure listing search with mapped Listing DTOs */
export interface SecureListingSearchMappedResult {
    /** The mapped Listing DTOs ready for UI consumption */
    listings: ListingWithCatalogData[];
    /** Total number of matching documents */
    total: number;
    /** Time taken for the search in milliseconds */
    took: number;
    /** Maximum score of the results (for relevance ranking) */
    maxScore: number | null;
    /** Whether the search timed out */
    timedOut: boolean;
    /** Applied security filters for debugging */
    appliedSecurityFilters: string[] | null;
    /** Number of fields that were allowed for the user */
    allowedFieldCount: number;
    /** Parsed aggregation results */
    aggregations: { [key: string]: AggregationResult; } | null;
    /** PIT ID for next page requests, null if not using PIT (Point-In-Time) pagination */
    pitId: string | null;
    /** Search after values for next page cursor (null if no more pages) */
    searchAfter: any[] | null;
    /** Whether there are more pages available */
    hasNextPage: boolean;
}

export interface AggregationResult {
    value: any;
    displayName: string;
    type: AggregationType;
    metadata: { [key: string]: any; } | null;
}

export enum AggregationType {
    Sum = "Sum",
    Count = "Count",
    Average = "Average",
    Min = "Min",
    Max = "Max",
    DistinctCount = "DistinctCount",
    Script = "Script",
}

export interface LoginContext {
    isSuccess: boolean;
    user: UserDetail | null;
    returnUrl: string | null;
    authorizationUrl: string | null;
    version: string | null;
}

export interface UserDetail {
    userId: string;
    displayName: string;
    userName: string;
    localeLanguage: string;
    activeAccount: SellerAccount;
    features: Feature[];
    hasManyAccounts: boolean;
    impersonatorDisplayName: string | null;
    permissions: Permission[];
    ownerIds: string[] | null;
}

export interface SellerAccount {
    id: string;
    accountName: string;
    impersonatedUserId: string | null;
    impersonatedUsername: string | null;
    currencyCode: string | null;
    sellerAccountSettings: SellerAccountSettings;
    marketplaceSettings: MarketplaceAccountSetting[];
    isConsignor: boolean | null;
    isConsignee: boolean | null;
    sellerAccountState: SellerAccountState | null;
    sellerAccountType: SellerAccountType | null;
    isCached: boolean;
}

export interface SellerAccountSettings {
    defaultSplitType: number | null;
    ticketTypeRules: string | null;
    inHandDatePaddingInDays: number | null;
    defaultHideSeatNumbers: boolean | null;
    priceFloor: number | null;
    defaultMaxQuantityDisplay: number | null;
    saleListingPriceBoundary: number | null;
    inHandDaysBeforeEvent: number | null;
    defaultManualMaxDisplayQuantity: number | null;
    adminHoldIndefinitelyForCancelledSales: boolean | null;
}

export interface MarketplaceAccountSetting {
    isEnabled: boolean;
    mkp: Marketplace;
    markup: number | null;
    sellerFee: number | null;
    hasApiToken: boolean;
    hasApiRefreshToken: boolean;
    tokenExpired: boolean;
    seatSaverFee: number | null;
    isSyncHandledByProcessor: boolean;
    processor: Processor | null;
}

export enum Processor {
    Automatiq = "Automatiq",
    TicketSuite = "TicketSuite",
    OneTicket = "OneTicket",
    Taciyon = "Taciyon",
    TicketAttendant = "TicketAttendant",
    Reveal = "Reveal",
    VictoryLive = "VictoryLive",
    TicketVault = "TicketVault",
}

export enum SellerAccountState {
    Migrating = "Migrating",
    Active = "Active",
    Churned = "Churned",
    Blocked = "Blocked",
}

export enum SellerAccountType {
    Sandbox = "Sandbox",
    Live = "Live",
    Employee = "Employee",
    Processor = "Processor",
    BrokerReadonly = "BrokerReadonly",
    Trial = "Trial",
    International = "International",
    DI = "DI",
}

export enum Permission {
    Sales_ViewAll = "Sales_ViewAll",
    Sales_ViewRecent = "Sales_ViewRecent",
    Sales_ViewRecentFromExternalMarketplace = "Sales_ViewRecentFromExternalMarketplace",
    Sales_ConfirmReject = "Sales_ConfirmReject",
    Sales_Fulfill = "Sales_Fulfill",
    Sales_CreateForExternalMarketplaces = "Sales_CreateForExternalMarketplaces",
    Sales_ViewProceeds = "Sales_ViewProceeds",
    Sales_ViewRecentProceeds = "Sales_ViewRecentProceeds",
    Sales_ViewCostAndMargin = "Sales_ViewCostAndMargin",
    Sales_ViewPaymentState = "Sales_ViewPaymentState",
    Sales_ViewFulfillmentArtifacts = "Sales_ViewFulfillmentArtifacts",
    Sales_ManageHold = "Sales_ManageHold",
    Sales_AddTagType = "Sales_AddTagType",
    Sales_UpdateTags = "Sales_UpdateTags",
    Sales_ViewSalesOnIsPricerOf = "Sales_ViewSalesOnIsPricerOf",
    Sales_UpdateSalesInfo = "Sales_UpdateSalesInfo",
    Sales_UpdateSalesInfoOnIsPricerOf = "Sales_UpdateSalesInfoOnIsPricerOf",
    Sales_UpdateSalesInfoOnIsFulfillerOf = "Sales_UpdateSalesInfoOnIsFulfillerOf",
    Sales_FulfillOnIsFulfillerOf = "Sales_FulfillOnIsFulfillerOf",
    Sales_ViewSalesOnPurchasedBy = "Sales_ViewSalesOnPurchasedBy",
    Sales_UpdateSaleOnPurchasedBy = "Sales_UpdateSaleOnPurchasedBy",
    Sales_FulfillOnPurchasedBy = "Sales_FulfillOnPurchasedBy",
    Sales_FulfillOnPricerOf = "Sales_FulfillOnPricerOf",
    Sales_UpdateTagsOnPurchasedBy = "Sales_UpdateTagsOnPurchasedBy",
    Sales_UpdateTagsOnIsPricerOf = "Sales_UpdateTagsOnIsPricerOf",
    Sales_UpdateTagsOnIsFulfillerOf = "Sales_UpdateTagsOnIsFulfillerOf",
    Sales_ConfirmRejectOnIsPricerOf = "Sales_ConfirmRejectOnIsPricerOf",
    Sales_ConfirmRejectOnPurchasedBy = "Sales_ConfirmRejectOnPurchasedBy",
    Sales_ViewFulfillmentArtifactsOnPurchasedBy = "Sales_ViewFulfillmentArtifactsOnPurchasedBy",
    Sales_ViewFulfillmentArtifactsOnIsPricerOf = "Sales_ViewFulfillmentArtifactsOnIsPricerOf",
    Sales_ConfirmRejectOnIsFulfillerOf = "Sales_ConfirmRejectOnIsFulfillerOf",
    Sales_ViewSalesOnIsFulfillerOf = "Sales_ViewSalesOnIsFulfillerOf",
    Sales_ViewFulfillmentArtifactsOnIsFulfillerOf = "Sales_ViewFulfillmentArtifactsOnIsFulfillerOf",
    Sales_CreateOfflineSale = "Sales_CreateOfflineSale",
    Sales_ManageOfflineSale = "Sales_ManageOfflineSale",
    Sales_ManageOfflineSaleCreatedBy = "Sales_ManageOfflineSaleCreatedBy",
    Sales_ConfirmTransferWithoutProof = "Sales_ConfirmTransferWithoutProof",
    Sales_ResetFulfillment = "Sales_ResetFulfillment",
    Sales_ViewHomePageMetrics = "Sales_ViewHomePageMetrics",
    Sales_Export = "Sales_Export",
    Sales_ViewColumnTotals = "Sales_ViewColumnTotals",
    Sales_CreateDonationSale = "Sales_CreateDonationSale",
    Sales_ManageDonationSale = "Sales_ManageDonationSale",
    Inventory_ViewAll = "Inventory_ViewAll",
    Inventory_ViewRecent = "Inventory_ViewRecent",
    Inventory_ViewRecentFromExternalMarketplace = "Inventory_ViewRecentFromExternalMarketplace",
    Inventory_ViewAllMarketplaceAttributes = "Inventory_ViewAllMarketplaceAttributes",
    Inventory_ViewExternalMarketplaceAttributes = "Inventory_ViewExternalMarketplaceAttributes",
    Inventory_ViewFulfillmentArtifacts = "Inventory_ViewFulfillmentArtifacts",
    Inventory_SetPrice = "Inventory_SetPrice",
    Inventory_SetPriceOnPurchasedBy = "Inventory_SetPriceOnPurchasedBy",
    Inventory_SetPriceOnIsPricerOf = "Inventory_SetPriceOnIsPricerOf",
    Inventory_Predelivery = "Inventory_Predelivery",
    Inventory_BroadcastUnbroadcast = "Inventory_BroadcastUnbroadcast",
    Inventory_BroadcastUnbroadcastOnPurchasedBy = "Inventory_BroadcastUnbroadcastOnPurchasedBy",
    Inventory_EditPricing = "Inventory_EditPricing",
    Inventory_UpdateListingInfo = "Inventory_UpdateListingInfo",
    Inventory_UpdateListingInfoOnPurchasedBy = "Inventory_UpdateListingInfoOnPurchasedBy",
    Inventory_AddTagType = "Inventory_AddTagType",
    Inventory_UpdateTags = "Inventory_UpdateTags",
    Inventory_UpdateTagsOnPurchasedBy = "Inventory_UpdateTagsOnPurchasedBy",
    Inventory_ViewListingOnIsPricerOf = "Inventory_ViewListingOnIsPricerOf",
    Inventory_UpdateListingInfoOnIsPricerOf = "Inventory_UpdateListingInfoOnIsPricerOf",
    Inventory_UpdateTagsOnIsPricerOf = "Inventory_UpdateTagsOnIsPricerOf",
    Inventory_PredeliveryOnPurchasedBy = "Inventory_PredeliveryOnPurchasedBy",
    Inventory_PredeliveryOnIsPricerOf = "Inventory_PredeliveryOnIsPricerOf",
    Inventory_ViewListingsOnPurchasedBy = "Inventory_ViewListingsOnPurchasedBy",
    Inventory_ViewFulfillmentArtifactsOnPurchasedBy = "Inventory_ViewFulfillmentArtifactsOnPurchasedBy",
    Inventory_ViewFulfillmentArtifactsOnIsPricerOf = "Inventory_ViewFulfillmentArtifactsOnIsPricerOf",
    Inventory_BroadcastUnbroadcastOnIsPricerOf = "Inventory_BroadcastUnbroadcastOnIsPricerOf",
    Inventory_AddSeatSaver = "Inventory_AddSeatSaver",
    Inventory_ManageSeatSaver = "Inventory_ManageSeatSaver",
    Inventory_ManageSeatSaverCreatedBy = "Inventory_ManageSeatSaverCreatedBy",
    Inventory_UpdateDeliveryStrategy = "Inventory_UpdateDeliveryStrategy",
    Inventory_UpdateDeliveryStrategyOnIsPricerOf = "Inventory_UpdateDeliveryStrategyOnIsPricerOf",
    Inventory_UpdateDeliveryStrategyOnPurchasedBy = "Inventory_UpdateDeliveryStrategyOnPurchasedBy",
    Inventory_ManageAdminHolds = "Inventory_ManageAdminHolds",
    Inventory_Export = "Inventory_Export",
    Inventory_ViewColumnTotals = "Inventory_ViewColumnTotals",
    SellerAccount_Admin = "SellerAccount_Admin",
    SellerSupportCase_Create = "SellerSupportCase_Create",
    SellerSupportCase_View = "SellerSupportCase_View",
    Purchases_ViewAll = "Purchases_ViewAll",
    Purchases_ViewRecent = "Purchases_ViewRecent",
    Purchases_Edit = "Purchases_Edit",
    Purchases_EditOwned = "Purchases_EditOwned",
    Purchases_Create = "Purchases_Create",
    Purchases_AddTagType = "Purchases_AddTagType",
    Purchases_UpdateTags = "Purchases_UpdateTags",
    Purchases_UpdateTagsOwned = "Purchases_UpdateTagsOwned",
    Purchases_ViewOwned = "Purchases_ViewOwned",
    Purchases_UpdateBuyerCommission = "Purchases_UpdateBuyerCommission",
    Purchases_UpdateBuyerCommissionOwned = "Purchases_UpdateBuyerCommissionOwned",
    Purchases_UpdateDeliveryType = "Purchases_UpdateDeliveryType",
    Purchases_UpdateDeliveryTypeOwned = "Purchases_UpdateDeliveryTypeOwned",
    Purchases_UpdateCustomDeliveryType = "Purchases_UpdateCustomDeliveryType",
    Purchases_UpdateCustomDeliveryTypeOwned = "Purchases_UpdateCustomDeliveryTypeOwned",
    Purchases_UpdateSeatTraits = "Purchases_UpdateSeatTraits",
    Purchases_UpdateSeatTraitsOwned = "Purchases_UpdateSeatTraitsOwned",
    Purchases_LockUnlockCommission = "Purchases_LockUnlockCommission",
    Purchases_LockUnlockCommissionOwned = "Purchases_LockUnlockCommissionOwned",
    Purchases_EditVendor = "Purchases_EditVendor",
    Purchases_Export = "Purchases_Export",
    Purchases_ViewColumnTotals = "Purchases_ViewColumnTotals",
    Purchases_ManagePaymentMethod = "Purchases_ManagePaymentMethod",
    Events_ViewAll = "Events_ViewAll",
    Events_AddTagType = "Events_AddTagType",
    Events_UpdateTags = "Events_UpdateTags",
    Events_SetPrice = "Events_SetPrice",
    Events_Edit = "Events_Edit",
    Events_ManageEventDiscovery = "Events_ManageEventDiscovery",
    Events_TeamPricing = "Events_TeamPricing",
    Accounts_ViewAll = "Accounts_ViewAll",
    Account_SetPrice = "Account_SetPrice",
    TicketGroups_ViewAll = "TicketGroups_ViewAll",
    Webhook_View = "Webhook_View",
    Webhook_Create = "Webhook_Create",
    Webhook_Edit = "Webhook_Edit",
    EventConfig_Edit = "EventConfig_Edit",
    EventConfig_Create = "EventConfig_Create",
    EventConfig_View = "EventConfig_View",
    Reports_CreateReports = "Reports_CreateReports",
    Reports_UpdateReports = "Reports_UpdateReports",
    Reports_UpdateReportsOwned = "Reports_UpdateReportsOwned",
    Reports_ViewInventoryReports = "Reports_ViewInventoryReports",
    Reports_ViewSalesReports = "Reports_ViewSalesReports",
    Reports_ViewAll = "Reports_ViewAll",
    Reports_ViewGlobalReports = "Reports_ViewGlobalReports",
    Reports_ViewSharedReports = "Reports_ViewSharedReports",
    Accounting_ViewAll = "Accounting_ViewAll",
    Accounting_ViewPaymentsOnSale = "Accounting_ViewPaymentsOnSale",
    Accounting_ViewStubhubPayments = "Accounting_ViewStubhubPayments",
    Accounting_ViewAutoPricingSettings = "Accounting_ViewAutoPricingSettings",
    AdPlatform_Edit = "AdPlatform_Edit",
    AdPlatform_CampaignsViewAll = "AdPlatform_CampaignsViewAll",
    AdPlatform_CampaignsCreate = "AdPlatform_CampaignsCreate",
    AdPlatform_CampaignsEdit = "AdPlatform_CampaignsEdit",
    General_ViewReleaseNotes = "General_ViewReleaseNotes",
    General_ViewNotifications = "General_ViewNotifications",
    General_ViewHelpCenter = "General_ViewHelpCenter",
}

export interface LoginRequest {
    code: string | null;
    state: string | null;
}

export interface MarketOrderListResponse {
    orders: MarketOrderResponse[];
    totalCount: number;
}

export interface MarketOrderResponse {
    marketOrderId: number;
    partitionId: number;
    sellerAccountId: string;
    sellerUserId: string;
    eventId: number;
    zone: string;
    zoneId: number | null;
    section: string | null;
    sectionId: number | null;
    rowBetterThan: string | null;
    rowId: number | null;
    sellerType: MarketOrderSellerType;
    maxPriceAmount: number;
    maxPriceCurrencyCode: string;
    totalTickets: number;
    filledTickets: number;
    status: MarketOrderStatus;
    startDate: string | null;
    endDate: string | null;
    inventoryThreshold: number | null;
    packSizes: string | null;
    createDate: string;
    updateDate: string;
}

export enum MarketOrderSellerType {
    Fan = "Fan",
    Broker = "Broker",
}

export enum MarketOrderStatus {
    Active = "Active",
    Paused = "Paused",
    Expired = "Expired",
    Filled = "Filled",
    Cancelled = "Cancelled",
}

export interface MarketOrderQuery {
    eventId: number;
    status: MarketOrderStatus | null;
    take: number | null;
    skip: number | null;
}

export interface CreateMarketOrderRequest {
    eventId: number;
    zone: string;
    zoneId: number | null;
    section: string | null;
    sectionId: number | null;
    rowBetterThan: string | null;
    rowId: number | null;
    sellerType: MarketOrderSellerType;
    maxPriceAmount: number;
    maxPriceCurrencyCode: string;
    totalTickets: number;
    packSizes: string | null;
    startDate: string | null;
    endDate: string | null;
    inventoryThreshold: number | null;
}

export interface UpdateMarketOrderRequest {
    marketOrderId: number;
    zone: string;
    zoneId: number | null;
    section: string | null;
    sectionId: number | null;
    rowBetterThan: string | null;
    rowId: number | null;
    sellerType: MarketOrderSellerType;
    maxPriceAmount: number;
    maxPriceCurrencyCode: string;
    totalTickets: number;
    packSizes: string | null;
    startDate: string | null;
    endDate: string | null;
    inventoryThreshold: number | null;
    status: MarketOrderStatus | null;
}

export interface DeleteMarketOrderRequest {
    marketOrderId: number;
}

export interface MarketOrderPurchaseOrderListResponse {
    purchaseOrders: MarketOrderPurchaseOrderResponse[];
    totalCount: number;
}

export interface MarketOrderPurchaseOrderResponse {
    marketOrderPurchaseOrderId: number;
    partitionId: number;
    sellerAccountId: string;
    marketOrderId: number;
    purchaseOrderId: number;
    createDate: string;
}

export interface MarketOrderPurchaseOrderQuery {
    marketOrderId: number | null;
    eventId: number | null;
    take: number | null;
    skip: number | null;
}

export interface CreateMarketOrderPurchaseOrderRequest {
    marketOrderId: number;
    purchaseOrderId: number;
}

export interface EntitiesWithSummaryOfMarketplaceSalePayment {
    items: MarketplaceSalePayment[];
    summary: MarketplaceSalePayment | null;
}

export interface MarketplaceSalePayment {
    /** MarketplacePaymentLineId */
    id: number;
    /** Marketplace */
    mkp: Marketplace | null;
    /** ExternalPaymentId */
    extPmtId: string;
    /** PaymentReferenceId */
    pmtRefId: string | null;
    pmtDate: string | null;
    recvDate: string | null;
    state: MarketplacePaymentState;
    /** PaymentAmount */
    pmtAmt: UiMoney;
    /** ProceedsAmount */
    proceedsAmt: UiMoney | null;
    credit: UiMoney | null;
    charge: UiMoney | null;
    convertedPmtAmt: UiMoney | null;
    mkpPmtTerm: MarketplacePaymentTerm | null;
    manualPmtAmt: UiMoney | null;
    manualProceedsAmt: UiMoney | null;
    manualCreditAmt: UiMoney | null;
    manualChargeAmt: UiMoney | null;
    isLocked: boolean | null;
}

export enum MarketplacePaymentTerm {
    PaymentUponSaleConfirmation = "PaymentUponSaleConfirmation",
    PaymentUponDelivery = "PaymentUponDelivery",
    PaymentPostEvent = "PaymentPostEvent",
}

export interface MarketplacePaymentQuery {
    marketplace: Marketplace | null;
    marketplacePaymentState: MarketplacePaymentState | null;
    paymentDates: DateTimeRangeWithRelative | null;
    sortBy: EventSort | null;
    isSortDescending: boolean | null;
    hasPaymentLineUnmappedToSale: boolean | null;
    hasPaymentLineUnmappedToSaleLineItem: boolean | null;
    hasPaymentTotalDiscrepancy: boolean | null;
    hasProceedsTotalDiscrepancy: boolean | null;
    hasCreditTotalDiscrepancy: boolean | null;
    hasChargeTotalDiscrepancy: boolean | null;
    currencyCodes: string[] | null;
    /** Dummy property for the UI to match the interface */
    viewMode: string | null;
    /** Output from the frontend application: `new Date().getTimezoneOffset()`
E.g. UTC-8 => 480
Used for RelativeTimeRange typed properties
Currently only used for reporting */
    timezoneOffsetMins: number | null;
}

export interface MonthContainingMarketplacePaymentsResult {
    firstOfMonth: string;
    totalPaymentAmount: UiMoney | null;
}

export interface MarketplacePaymentLineWithSaleInfo {
    /** MarketplacePaymentLineId */
    id: number;
    /** Marketplace */
    marketplace: Marketplace | null;
    /** MarketplacePaymentId */
    posPmtId: number;
    /** ExternalPaymentId */
    extPmtId: string;
    /** ExternalPaymentLineId */
    extLineId: string;
    state: MarketplacePaymentState;
    date: string | null;
    recvDate: string | null;
    /** IsCredit */
    isCred: boolean;
    /** Amount */
    amt: UiMoney;
    type: MarketplacePaymentLineType;
    isAddedToSale: boolean | null;
    isLocked: boolean | null;
    saleId: number | null;
    extSaleId: string;
    saleStatus: PointOfSaleSaleStatus | null;
    /** The event of which this entity is for. */
    posEvId: string | null;
    viagEvId: number | null;
    viagEvMapId: string | null;
    viagVirtId: string | null;
    seating: Seating | null;
    convertedPmtAmt: UiMoney | null;
}

export interface MarketplacePaymentLineQuery {
    hasUnlinkedChargesCredits: boolean | null;
    externalSaleIdContains: string | null;
    /** Dummy property for the UI to match the interface */
    viewMode: string | null;
    /** Output from the frontend application: `new Date().getTimezoneOffset()`
E.g. UTC-8 => 480
Used for RelativeTimeRange typed properties
Currently only used for reporting */
    timezoneOffsetMins: number | null;
}

export interface MarketplacePaymentSaleLineInput {
    marketplacePaymentLineId: number;
    marketplacePaymentId: number;
    externalPaymentLineId: PosFieldOfString | null;
    paymentLineType: PosFieldOfNullableMarketplacePaymentLineType | null;
    saleId: PosFieldOfNullableLong | null;
    externalSaleId: PosFieldOfString | null;
    amount: PosFieldOfNullableDecimal | null;
    currency: PosFieldOfString | null;
}

export interface PosFieldOfNullableMarketplacePaymentLineType {
    value: MarketplacePaymentLineType | null;
    hasChanged: boolean;
}

export interface MarketplacePaymentInput {
    marketplacePaymentId: number;
    externalPaymentId: PosFieldOfString | null;
    marketplace: PosFieldOfNullableMarketplace | null;
    paymentDate: PosFieldOfNullableDateTime | null;
    paymentReferenceId: PosFieldOfString | null;
    paymentCurrency: PosFieldOfString | null;
    manualPaymentAmount: PosFieldOfNullableDecimal | null;
    manualProceedsAmount: PosFieldOfNullableDecimal | null;
    manualCreditAmount: PosFieldOfNullableDecimal | null;
    manualChargeAmount: PosFieldOfNullableDecimal | null;
}

export interface PosFieldOfNullableMarketplace {
    value: Marketplace | null;
    hasChanged: boolean;
}

export interface UiCurrency {
    code: string;
    dec: number;
    sym: string;
}

export interface Notification {
    notificationId: number;
    notificationType: NotificationType;
    entityType: ActionOutboxEntityType;
    entityId: number;
    notificationState: NotificationState;
    createDateTime: string;
    expirationDateTime: string;
    posEventId: string | null;
    section: string | null;
    row: string | null;
    piggybackRow: string | null;
    seatFrom: string | null;
    seatTo: string | null;
    marketplace: Marketplace | null;
    marketplaceEntityId: string | null;
    event: Event | null;
    performer: Performer | null;
    venue: Venue | null;
}

export enum NotificationType {
    SaleNew = "SaleNew",
    SaleFulfilmentFailed = "SaleFulfilmentFailed",
    SaleMarketplaceCancelled = "SaleMarketplaceCancelled",
    ListingHideSeatsFailed = "ListingHideSeatsFailed",
    ListingUpdateAllInPriceFailed = "ListingUpdateAllInPriceFailed",
    ListingUpdateInHandDateFailed = "ListingUpdateInHandDateFailed",
    ListingUpdateSplitTypeFailed = "ListingUpdateSplitTypeFailed",
    ListingUpdateDeliveryTypeFailed = "ListingUpdateDeliveryTypeFailed",
    ListingUpdateUnitNetProceedsFailed = "ListingUpdateUnitNetProceedsFailed",
    ListingBroadcastFailed = "ListingBroadcastFailed",
    ListingUnbroadcastFailed = "ListingUnbroadcastFailed",
    ListingMergeFailed = "ListingMergeFailed",
    ListingSplitFailed = "ListingSplitFailed",
    ListingPriceUpdate = "ListingPriceUpdate",
    AutopriceBelowFloor = "AutopriceBelowFloor",
    AutopriceInsufficientCompListings = "AutopriceInsufficientCompListings",
    AutopriceFirebrake = "AutopriceFirebrake",
    SellerSupportCaseNewReply = "SellerSupportCaseNewReply",
}

export enum NotificationState {
    Active = "Active",
    Inactive = "Inactive",
}

export interface UpdateListingGroupAutoPriceSettingsFromOnePagerRequest {
    autoPricingSettings: ListingGroupAutoPriceSettings;
    hasChangesInCompSettings: boolean;
    hasChangesInUndercutSettings: boolean;
    hasChangesInOutlierSettings: boolean;
}

export interface ListingGroupAutoPriceSettings extends AutoPricingInputs {
    desiredActiveListings: number | null;
    deprioritizedQuantities: string[] | null;
    /** Rank Premium UndercutAbsoluteAmount */
    undAbsAmt: number | null;
    /** Rank Premium UndercutRelativeAmount */
    undRelAmt: number | null;
    netProceedsFloor: number | null;
    netProceedsCeiling: number | null;
    autoPricingEnabled: boolean | null;
    /** Starting amount for manual price rank premiums in a group. Listings
of rank n will have a rank premium of StartingUnitNetProceeds + (n-1) * RankPremium
set as their unit net proceeds. */
    startingUnitNetProceeds: number | null;
}

export interface EventAutoPricingSettingsInputs extends AutoPricingInputs {
    compRowOffsetMode: CompRowOffsetMode | null;
}

export enum CompRowOffsetMode {
    Ordinal = "Ordinal",
    Text = "Text",
}

export interface EventConfigScoreOverride {
    id: number;
    name: string;
    eventIds: number[] | null;
    cfgId: number;
    cfgPayload: string | null;
    scoreOverrides: SectionScoreOverride[];
    isActive: boolean | null;
    isTemplate: boolean | null;
    viagogoEventId: number | null;
    venueId: number | null;
    categoryId: number | null;
}

export interface SellerAccountEventConfigScoreOverrides {
    eventConfigScoreOverrideId: number;
    configPayload: string;
    name: string;
    eventId: number | null;
    createDate: string;
    updateDate: string;
}

export interface SellThroughRateHistory {
    sellThroughRatePercentage: number;
    timelineDate: string;
}

export interface AutoPricingSettingsCollection extends AutoPricingInputs {
    autoPricingSettingsCollectionId: number | null;
    strategyName: string;
}

export interface UpsertAutoCompSettingsInput {
    viagogoEventId: number;
    venueZoneConfigType: string;
    rowCompOffset: number;
    rowGroupSetting: string;
    sectionGroupCustomRankEnabled: boolean;
    rowCompOverrides: RowCompOverrideInput[];
    zoneSectionAreaGroupLookupJson: string;
}

export interface RowCompOverrideInput {
    rowOrdinalFrom: number;
    rowOrdinalTo: number;
    offsetOverride: number;
}

export interface AutoCompSettingsResult {
    venueZoneConfigType: VenueZoneConfigType | null;
    rowCompOffset: number;
    rowGroupSetting: RowGroupSetting | null;
    sectionGroupCustomRankEnabled: boolean;
    rowCompOverrides: RowCompOverride[] | null;
}

export interface VenueMapZoneConfigInfo {
    defaultVenueZoneConfigType: VenueZoneConfigType;
    venueMapZoneConfigs: { [key in keyof typeof VenueZoneConfigType]?: { [key: string]: SectionSectionGroup; }; };
}

export interface SectionSectionGroup {
    sectId: number;
    areaRank: number;
    sectionGroupRank: number;
    sectionGroupAreaType: SectionGroupAreaType | null;
    sectionGroupAreaName: string | null;
    ticketClassId: number | null;
    ticketClassName: string | null;
    sectionGroupColor: string;
}

export enum SectionGroupAreaType {
    Unknown = "Unknown",
    Center = "Center",
    LeftRight = "LeftRight",
    FarLeftFarRight = "FarLeftFarRight",
    Front = "Front",
    Sides = "Sides",
    SideT1 = "SideT1",
    SideT2 = "SideT2",
    Ends = "Ends",
    Rear = "Rear",
    Corners = "Corners",
}

export interface EventsPricingConfig {
    sharedConfigId: number | null;
    canUseZoneMap: boolean;
}

export interface VenueZoneConfigOverride {
    name: string;
    eventId: number | null;
    configId: number | null;
    venueId: number | null;
    sectionSectionGroupLookup: { [key: string]: SectionSectionGroup; };
}

export interface UpsertVenueZoneSectionGroupOverridesInput {
    viagogoEventId: number;
    venueZoneOverrideId: number | null;
    name: string;
    sectionSectionGroupsJson: string;
    saveAsNewMap: boolean;
}

export interface EventMapConfigMetadata {
    /** The selected or default VenueZoneConfigType */
    defaultVenueZoneConfigType: VenueZoneConfigType;
    /** The selected or default VenueZoneConfigType */
    selectedVenueMapConfigType: VenueZoneConfigType | null;
    /** The selected custom VenueZone override id. If this value is null then we will always use the DefaultVenueZoneConfigType
as a fallback, but the override will always take precedence */
    selectedOverrideId: number | null;
    /** The selected custom VenueZone override name */
    selectedOverrideName: string | null;
    /** Data needed to render the preview of the selected config when hovering over the "View Event Map" button */
    selectedVenueMapConfig: { [key: string]: SectionSectionGroup; };
}

export interface SqsSectionRowRecommendations {
    modelVersionId: number;
    rowRecommendations: { [key: string]: SelectedSectionSettings; };
}

export enum VelocityCircuitBreakerSuppressionType {
    Reset = "Reset",
    Permanent = "Permanent",
}

export interface SellerEventWithVenue {
    sellerEventId: string;
    viagogoEventId: number;
    venueId: number;
    venueConfigId: number;
}

export interface PurchaseOrderDetails extends PurchaseOrder {
    additionalCosts: CostDetail[] | null;
    ticketGroups: TicketGroup[];
    miniCatalog: CatalogResults | null;
    payments: PurchasePayment[] | null;
    transferId: string | null;
    hasMergedListings: boolean | null;
    hasSplitListings: boolean | null;
    deal: PurchaseOrderDeal | null;
}

export interface CostDetail {
    id: number;
    cost: UiMoney | null;
    costType: PurchaseOrderCostType;
    date: string;
    description: string | null;
}

export enum PurchaseOrderCostType {
    Tax = "Tax",
    Shipping = "Shipping",
    CreditCardFee = "Credit Card Fee",
    BulkDiscount = "Bulk Discount",
    Cancelled = "Cancelled",
    Other = "Other",
}

export interface TicketGroup extends EntityWithTickets {
    entityType: ActionOutboxEntityType;
    tickets: Ticket[];
    unitCst: UiMoney;
    totalCst: UiMoney | null;
    expectedVal: UiMoney | null;
    webPrice: UiMoney | null;
    taxPaid: UiMoney | null;
    isFaceVal: boolean;
    faceVal: UiMoney | null;
    delivType: DeliveryType;
    delivCst: UiMoney | null;
    poId: number | null;
    vendOrdId: string | null;
    /** Available Artifact Types */
    availArtTypes: ArtifactType[];
    /** Has user document artifacts to download */
    canGetDocArts: boolean | null;
    venId: number | null;
    perfId: number | null;
}

export interface PurchasePayment {
    paymentId: number;
    paymentStatus: PurchasePaymentStatus;
    paymentDueDate: string;
    paymentDate: string | null;
    paymentAmount: UiMoney;
    currencyCode: string;
    convertedPaymentAmount: UiMoney | null;
    convertedCurrencyCode: string | null;
    conversionRate: number | null;
    conversionDate: string | null;
    conversionUserId: string | null;
    paymentMethod: PurchasePaymentMethod;
}

export interface PurchaseOrderDeal {
    dealId: string | null;
    dealType: DealType;
    dealDetails: PurchaseOrderDealDetails;
}

export enum DealType {
    Sor = "Sor",
    Guaranteed = "Guaranteed",
}

export interface PurchaseOrderDealDetails {
    guaranteedAmountPaid: number | null;
    dealStartDate: string | null;
    dealEndDate: string | null;
    configSplitType: DealSplitType;
    dealConfigId: string | null;
    dealFallbackConfig: PurchaseOrderDealConfig | null;
    dealConfigs: PurchaseOrderDealConfig[] | null;
}

export enum DealSplitType {
    Quantity = "Quantity",
    Sales = "Sales",
    None = "None",
}

export interface PurchaseOrderDealConfig {
    dealConfigHurdleId: string | null;
    thresholdSplitDirection: DealThresholdSplitDirection | null;
    thresholdValue: number | null;
    vendorCommission: PurchaseOrderDealCommission;
    purchaserCommissions: PurchaseOrderDealCommission[];
    priority: number | null;
}

export enum DealThresholdSplitDirection {
    Above = "Above",
    Below = "Below",
}

export interface PurchaseOrderDealCommission {
    userId: string;
    splitValue: number;
}

export interface EntitiesWithSummaryOfPurchaseOrder {
    items: PurchaseOrder[];
    summary: PurchaseOrder | null;
}

/** Model for SearchV2 result */
export interface EntitySearchResultOfEntitiesWithSummaryOfPurchaseOrderTicketGroup {
    /** Actual entities returned from the search */
    entities: EntitiesWithSummaryOfPurchaseOrderTicketGroup;
    /** PIT ID for next page requests, null if not using PIT (Point-In-Time) pagination */
    pitId: string | null;
    /** Total number of matching documents that may have not been returned yet due to pagination */
    totalItemsCount: number | null;
    /** Maximum number of documents reachable via offset pagination (from + size).
Corresponds to the OpenSearch index.max_result_window setting (default 10,000).
The frontend should use this to cap pagination: maxPages = maxResultWindow / pageSize. */
    maxResultWindow: number | null;
    searchAfter: any[] | null;
    /** Ordered list of event group IDs (ViagogoVirtualIds) in the order returned by OpenSearch.
Solves a JavaScript serialization problem: Object.entries() reorders integer-like keys
numerically per ECMAScript spec, which would override the OpenSearch sort order.
Use this to iterate Entities in the correct group order.
Note: this is coarser than SortedItemIds — it gives the order of event groups, not
individual items within or across groups. */
    sortedGroupIds: string[] | null;
    /** Ordered list of individual item IDs (SaleId / ListingId) in the globally-sorted order
returned by OpenSearch. This is finer-grained than SortedGroupIds: because the response
groups items by event, a single event group may contain mixed-rank items (e.g., one event
with both Transfer and Paper tickets). Flattening event-by-event would put those mixed items
out of global sort order. Use SortedItemIds to re-sort the flat list and restore the correct
global order for flattened/search views. */
    sortedItemIds: number[] | null;
}

export interface EntitiesWithSummaryOfPurchaseOrderTicketGroup {
    items: PurchaseOrderTicketGroup[];
    summary: PurchaseOrderTicketGroup | null;
}

/** Extended version of PurchaseOrderQuery with support for operations for each filter that is supported in search v2 with OpenSearch */
export interface PurchaseOrderQueryV2 extends PurchaseOrderQuery {
    deliveryTypes: DeliveryType[] | null;
    paymentMethods: PurchasePaymentMethodType[] | null;
    paymentMethodIds: number[] | null;
    paymentStatuses: PurchasePaymentStatus[] | null;
    operations: PurchaseQueryOperations | null;
    searchOptions: UISearchOptions | null;
}

export interface PurchaseQueryOperations extends EntityWithTicketsQueryOperations {
    ticketGroupIdsOp: FilterOperationType | null;
    purchaseMonthsOp: FilterOperationType | null;
    /** Payment method type */
    paymentMethodOp: FilterOperationType | null;
    paymentStatusOp: FilterOperationType | null;
    paymentDatesOp: FilterOperationType | null;
    totalCostHighOp: FilterOperationType | null;
    totalCostLowOp: FilterOperationType | null;
    unitCostHighOp: FilterOperationType | null;
    unitCostLowOp: FilterOperationType | null;
    deliveryTypeOp: FilterOperationType | null;
    purchaseOrderStateOp: FilterOperationType | null;
    /** Exact payment method used */
    paymentMethodIdOp: FilterOperationType | null;
    paymentCurrencyCodesOp: FilterOperationType | null;
    isConsignmentOp: FilterOperationType | null;
}

export interface AccessControlProvider {
    id: number;
    name: string;
}

export interface ValueTupleOfISetOfIntegerAndISetOfGuid {
    item1: number[];
    item2: string[];
}

export interface PurchaseVendorAccountDetails extends PurchaseVendorAccount {
    delivType: DeliveryType | null;
    isNoFulfill: boolean | null;
    tktTypeRules: TicketTypeOverride | null;
    favPmtMethodIds: number[] | null;
}

export enum PurchasingIdInUseResultType {
    NoneMatching = "NoneMatching",
    SameOrderId = "SameOrderId",
    SameOrderIdAndVendorId = "SameOrderIdAndVendorId",
}

export interface MonthContainingPurchaseOrdersResult {
    firstOfMonth: string;
    purchaseCount: number;
    numOfTickets: number;
    totalCost: UiMoney | null;
}

export interface TimePeriodContainingPurchaseOrderResult {
    firstOfTimePeriod: string;
    purchaseCount: number;
    numOfTickets: number;
    totalCost: UiMoney | null;
}

export enum TimePeriodType {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
}

export interface PurchaseOrderDetailsInput {
    id: number;
    vendorOrderId: PosFieldOfString | null;
    purchaseDate: PosFieldOfNullableDateTime | null;
    buyerUserId: PosFieldOfNullableGuid | null;
    currencyCode: PosFieldOfString | null;
    commissions: PosFieldArrayOfCommission | null;
    vendor: PosFieldOfPurchaseVendor | null;
    vendorAccount: PosFieldOfPurchaseVendorAccount | null;
    partialVendorAccount: PartialPurchaseVendorAccount | null;
    secondaryVendorAccount: PosFieldOfPurchaseVendorAccount | null;
    partialSecondaryVendorAccount: PartialPurchaseVendorAccount | null;
    secondaryVendor: PosFieldOfPurchaseVendor | null;
    additionalCosts: PosFieldArrayOfCostDetail | null;
    payments: PosFieldArrayOfPurchasePayment | null;
    transferId: PosFieldOfString | null;
    tags: PosFieldArrayOfTag | null;
    privateNotes: PosFieldOfString | null;
    qcState: PosFieldOfNullableQualityControlState | null;
    isAutoPo: boolean;
    ticketGroups: TicketGroupInput[];
    deal: PosFieldOfPurchaseOrderDealInput | null;
    isCommissionsLocked: PosFieldOfNullableBoolean | null;
}

export interface PosFieldOfPurchaseVendor {
    value: PurchaseVendor | null;
    hasChanged: boolean;
}

export interface PosFieldOfPurchaseVendorAccount {
    value: PurchaseVendorAccount | null;
    hasChanged: boolean;
}

export interface PartialPurchaseVendorAccount {
    vendorId: number;
    name: string | null;
    email: string;
}

/** Note - doing PosFieldArray so it can be property generated to React TypeScript */
export interface PosFieldArrayOfCostDetail {
    value: CostDetail[] | null;
    hasChanged: boolean;
}

/** Note - doing PosFieldArray so it can be property generated to React TypeScript */
export interface PosFieldArrayOfPurchasePayment {
    value: PurchasePayment[] | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableQualityControlState {
    value: QualityControlState | null;
    hasChanged: boolean;
}

export interface TicketGroupInput {
    ticketGroupId: number;
    purchaseOrderId: number | null;
    /** Because the TicketGroup is used for input, this property will be used to pass back
when selecting an Event and related info to create the TicketGroup for a PurchaseOrder */
    event: Event | null;
    performer: Performer | null;
    venue: Venue | null;
    /** Has user document artifacts to download */
    canGetDocArts: boolean | null;
    viagogoEventId: number | null;
    eventMappingId: string | null;
    viagogoVirtualId: string;
    posEventId: string | null;
    unitCost: PosFieldOfNullableDecimal | null;
    inHandDate: PosFieldOfNullableDateTime | null;
    expectedValue: PosFieldOfNullableDecimal | null;
    isFaceValueCost: PosFieldOfNullableBoolean | null;
    faceValueCost: PosFieldOfNullableDecimal | null;
    deliveryType: PosFieldOfNullableDeliveryType | null;
    totalCost: PosFieldOfNullableDecimal | null;
    taxPaid: PosFieldOfNullableDecimal | null;
    deliveryCost: PosFieldOfNullableDecimal | null;
    currencyCode: PosFieldOfString | null;
    section: PosFieldOfString | null;
    sectionId: PosFieldOfNullableInteger | null;
    rowId: PosFieldOfNullableInteger | null;
    row: PosFieldOfString | null;
    tickets: PosFieldArrayOfTicket | null;
    numberOfTickets: PosFieldOfNullableInteger | null;
    ticketTypeRules: TicketTypeOverride | null;
    /** Note - TicketGroup doesn't have InternalNotes as a field, but they are passed in from API to be set onto Listing */
    internalNotes: PosFieldOfString | null;
    listingNotes: PosFieldArrayOfListingNote | null;
    seatIncementType: number | null;
    allocateSeats: boolean | null;
    webPrice: number | null;
    autoBroadcastCreatedListing: boolean | null;
}

export interface PosFieldOfNullableDeliveryType {
    value: DeliveryType | null;
    hasChanged: boolean;
}

/** Note - doing PosFieldArray so it can be property generated to React TypeScript */
export interface PosFieldArrayOfTicket {
    value: Ticket[] | null;
    hasChanged: boolean;
}

/** Note - doing PosFieldArray so it can be property generated to React TypeScript */
export interface PosFieldArrayOfListingNote {
    value: ListingNote[] | null;
    hasChanged: boolean;
}

export interface PosFieldOfPurchaseOrderDealInput {
    value: PurchaseOrderDealInput | null;
    hasChanged: boolean;
}

export interface PurchaseOrderDealInput {
    dealId: string | null;
    dealType: DealType;
    dealDetails: PurchaseOrderDealDetailsInput;
}

export interface PurchaseOrderDealDetailsInput {
    guaranteedAmountPaid: number | null;
    dealStartDate: string | null;
    dealEndDate: string | null;
    configSplitType: PosFieldOfNullableDealSplitType;
    dealConfigId: string | null;
    dealFallbackConfig: PurchaseOrderDealConfig | null;
    dealConfigs: PosFieldArrayOfPurchaseOrderDealConfig | null;
}

export interface PosFieldOfNullableDealSplitType {
    value: DealSplitType | null;
    hasChanged: boolean;
}

/** Note - doing PosFieldArray so it can be property generated to React TypeScript */
export interface PosFieldArrayOfPurchaseOrderDealConfig {
    value: PurchaseOrderDealConfig[] | null;
    hasChanged: boolean;
}

export interface PosUiActionResultWithDataOfIEnumerableOfNullableLong extends PosUiActionResult {
    data: (number | null)[] | null;
}

export interface ValueTupleOfISetOfLongAndPosFieldOfNullableQualityControlState {
    item1: number[];
    item2: PosFieldOfNullableQualityControlState;
}

export interface ValueTupleOfLongAndDecimal {
    item1: number;
    item2: number;
}

export interface CurrencyConversionOverride {
    currencyConversionOverrideId: number;
    fromCurrencyCode: string;
    toCurrencyCode: string;
    purchasePaymentMethodId: number | null;
    /** Ignored if `PaymentMethodNameKnownRegexId` is not null. */
    purchasePaymentMethodName: string | null;
    paymentMethodNameKnownRegexId: PaymentMethodNameKnownRegex | null;
    conversionRate: number;
    conversionRateDate: string;
}

export enum PaymentMethodNameKnownRegex {
    All = "All",
    AllAmex = "AllAmex",
    AllVisa = "AllVisa",
    AllMastercard = "AllMastercard",
}

export interface CurrencyConversionOverrideRequest {
    currencyConversionOverrideId: number | null;
    conversionRateDate: string;
    fromCurrencyCode: string;
    toCurrencyCode: string;
    purchasePaymentMethodId: number | null;
    paymentMethodNameKnownRegexId: PaymentMethodNameKnownRegex | null;
    conversionRate: number;
}

export interface DeliveryOverride {
    delivType: DeliveryType | null;
    tktTypeRules: TicketTypeOverride | null;
    inHandAt: string | null;
}

export interface ValueTupleOfNullableIntegerAndNullableIntegerAndNullableGuidAndBoolean {
    item1: number | null;
    item2: number | null;
    item3: string | null;
    item4: boolean;
}

export interface PurchaseEventOverride {
    delivType: DeliveryType;
    vendorId: number | null;
}

export interface PurchaseOrderExportRequest {
    query: PurchaseOrderQuery;
    exportColumns: string[] | null;
}

/** Response model for purchase order aggregations */
export interface PurchaseOrderAggregationResponse {
    /** Aggregated summary in target currency */
    summary: PurchaseOrderAggregationSummary;
    /** Optional breakdown by original currency */
    byOriginalCurrency: PurchaseOrderCurrencyBreakdown[] | null;
    /** Metadata about the aggregation computation */
    metadata: AggregationResponseMetadata;
}

/** Aggregation summary for purchase order entities Based on calculations in PurchaseOrderSummaryFactory */
export interface PurchaseOrderAggregationSummary {
    /** Total number of tickets across all purchase orders */
    totalTickets: number;
    /** Total number of ticket groups */
    totalTicketGroups: number;
    /** Total cost of all purchase orders */
    totalCost: UiMoney | null;
    /** Aggregated unit cost (total cost / total tickets) */
    aggregatedUnitCost: UiMoney | null;
    /** Total payment amount across all purchase orders */
    totalPayment: UiMoney | null;
    /** Total converted payment amount (in various currencies converted to target) */
    totalConvertedPayment: UiMoney | null;
    /** Average payment conversion rate (totalConvertedPmt / totalPmt) */
    averagePaymentConversionRate: number | null;
    /** Outstanding balance (TotalCost - TotalConvertedPayment or TotalPayment) */
    outstandingBalance: UiMoney | null;
    /** Currency of the aggregated amounts */
    currency: string;
    /** Number of purchase orders included in aggregation */
    purchaseOrderCount: number;
}

/** Currency breakdown for purchase order response */
export interface PurchaseOrderCurrencyBreakdown {
    /** Currency code */
    currency: string;
    /** Number of documents in this currency */
    documentCount: number;
    /** Aggregated values in original currency */
    summary: PurchaseOrderAggregationSummary;
}

/** Generic request model for multi-currency aggregations */
export interface MultiCurrencyAggregationRequestOfPurchaseOrderSearchRequestV2AndPurchaseOrderFilterQueryV2 {
    /** The OpenSearch request containing filter criteria and options */
    request: PurchaseOrderSearchRequestV2;
    /** Target currency for final aggregation results */
    targetCurrency: string;
    /** Whether to include currency-by-currency breakdown in response */
    includeCurrencyBreakdown: boolean;
}

export interface OpenSearchRequestOfPurchaseOrderFilterQueryV2 {
    filter: PurchaseOrderFilterQueryV2;
    options: SearchOptions | null;
    allowedFields: string[] | null;
    appliedSecurityFilters: string[] | null;
    dataIsolationContext: { [key: string]: any; } | null;
}

export interface PurchaseOrderSearchRequestV2 extends OpenSearchRequestOfPurchaseOrderFilterQueryV2 {
}

export interface PurchaseOrderFilterQueryV2 {
    eventIds: FieldFilter | null;
    eventDates: FieldFilter | null;
    eventTimeFrameFilters: FieldFilter | null;
    clientTimezoneOffsetMins: number | null;
    eventStatuses: FieldFilter | null;
    topLevelCategories: FieldFilter | null;
    parentCategories: FieldFilter | null;
    eventOrMappingIds: FieldFilter | null;
    oldPosEventIds: FieldFilter | null;
    performerIds: FieldFilter | null;
    venueIds: FieldFilter | null;
    countryCodes: FieldFilter | null;
    stateProvinceIds: FieldFilter | null;
    cityIds: FieldFilter | null;
    purchaseOrderIds: FieldFilter | null;
    ticketGroupIds: FieldFilter | null;
    purchaseVendorIds: FieldFilter | null;
    purchaseVendorAccountIds: FieldFilter | null;
    purchaseVendorOrderIds: FieldFilter | null;
    purchaseBuyerIds: FieldFilter | null;
    purchaseInsertByIds: FieldFilter | null;
    purchaseDates: FieldFilter | null;
    purchaseCommissionUserIds: FieldFilter | null;
    orBuyerUserId: FieldFilter | null;
    orBuyerUserIds: FieldFilter | null;
    paymentDates: FieldFilter | null;
    paymentStatuses: FieldFilter | null;
    paymentMethodTypes: FieldFilter | null;
    paymentMethodUsedIds: FieldFilter | null;
    paymentCurrencyCodes: FieldFilter | null;
    deliveryTypes: FieldFilter | null;
    purchaseOrderStates: FieldFilter | null;
    isConsignment: FieldFilter | null;
    totalCost: FieldFilter | null;
    unitCosts: FieldFilter | null;
    currencyCodes: FieldFilter | null;
    internalNotes: FieldFilter | null;
    tagPairs: TagPairFilter | null;
    eventTagPairs: TagPairFilter | null;
    and: PurchaseOrderFilterQueryV2[] | null;
    or: PurchaseOrderFilterQueryV2[] | null;
    not: boolean;
}

/** Result of a secure purchase orders search with mapped PurchaseOrder DTOs Mirrors SecureSalesSearchMappedResult but for purchase orders */
export interface SecurePurchaseOrdersSearchMappedResult {
    /** The mapped PurchaseOrder DTOs ready for UI consumption */
    purchaseOrders: PurchaseOrderTicketGroup[];
    /** Total number of matching documents */
    total: number;
    /** Time taken for the search in milliseconds */
    took: number;
    /** Maximum score of the results (for relevance ranking) */
    maxScore: number | null;
    /** Whether the search timed out */
    timedOut: boolean;
    /** Applied security filters for debugging */
    appliedSecurityFilters: string[] | null;
    /** Number of fields that were allowed for the user */
    allowedFieldCount: number;
    /** Parsed aggregation results */
    aggregations: { [key: string]: AggregationResult; } | null;
    /** PIT ID for next page requests, null if not using PIT (Point-In-Time) pagination */
    pitId: string | null;
    /** Search after values for next page cursor (null if no more pages) */
    searchAfter: any[] | null;
    /** Whether there are more pages available */
    hasNextPage: boolean;
    /** Ordered list of purchase order IDs in the globally-sorted order returned by OpenSearch.
Used by the frontend to restore correct global sort order in flattened search views. */
    sortedItemIds: number[] | null;
}

export interface ReachProSupportConversation {
    conversationId: number;
    workItemId: number | null;
    eventId: number | null;
    stubHubListingId: number | null;
    stubHubSaleId: number | null;
    section: string | null;
    row: string | null;
    seatFrom: string | null;
    seatTo: string | null;
    topic: string | null;
    lastMessageSnippet: string | null;
    lastMessageTimestamp: string | null;
    lastReadTimestamp: string | null;
    createDate: string;
    hasUnreadMessages: boolean;
}

export interface ReachProSupportMessage {
    workItemNoteId: number | null;
    messageContent: string;
    senderName: string;
    timestamp: string;
    isSent: boolean;
}

export interface ReachProSupportCreateConversationRequest {
    topic: string;
    /** Viagogo Event ID (not POS Event ID) */
    eventId: number;
    /** Viagogo Listing ID (not POS Listing ID)
Only include if listing is on StubHub marketplace */
    listingId: number | null;
    /** Viagogo Sale ID (marketplace sale ID, i.e., idOnMkp)
Only include if sale is on StubHub marketplace */
    saleId: number | null;
    /** Section name for the tickets */
    section: string | null;
    /** Row name for the tickets */
    row: string | null;
    /** Starting seat number */
    seatFrom: string | null;
    /** Ending seat number */
    seatTo: string | null;
}

export interface ReachProSupportSendMessageRequest {
    conversationId: number;
    messageContent: string;
}

export interface ReachProSupportCatalogEventInfo {
    viagogoVirtualId: string;
    eventName: string | null;
    eventStartDate: string | null;
    eventGenre: string | null;
    venueName: string | null;
    venueCity: string | null;
    venueState: string | null;
    venueCountry: string | null;
    performerName: string | null;
}

export interface ReportConfigOfListingQueryAndReportWidgetTypesInventory {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    groupBy: ReportGroupBy;
    widgets: ReportWidgetTypesInventory[] | null;
    metrics: string[];
    filter: ListingQuery | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    numberOfItemsPerPage: number | null;
    sortBy: string | null;
    isSortDescending: boolean | null;
    arAgingTimeBuckets: DateTimeRangeWithRelative[] | null;
    reportId: number | null;
    /** If specified, open this report instead when the user clicks on a report link. */
    reportIdRedirect: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    allowReaderEditMetrics: boolean;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    hasFilterOverride: boolean | null;
}

export enum ReportGroupBy {
    Performer = "Performer",
    Event = "Event",
    Venue = "Venue",
    EventGenre = "EventGenre",
    EventCountry = "EventCountry",
    EventCity = "EventCity",
    SeatingSection = "SeatingSection",
    SeatingRow = "SeatingRow",
    SaleMarketplace = "SaleMarketplace",
    SaleMonth = "SaleMonth",
    SaleWeek = "SaleWeek",
    SaleDay = "SaleDay",
    SaleId = "SaleId",
    ListingId = "ListingId",
    PurchaseId = "PurchaseId",
    PurchasedBy = "PurchasedBy",
    PricedBy = "PricedBy",
    FulfilledBy = "FulfilledBy",
    Vendor = "Vendor",
    SaleIdTicketIdCommissionUser = "SaleIdTicketIdCommissionUser",
    ArAgingMarketplace = "ArAgingMarketplace",
}

/** Available widgets to show in inventory reports */
export enum ReportWidgetTypesInventory {
    TicketsListedAndSold = "TicketsListedAndSold",
    SalesAndMargin = "SalesAndMargin",
    AverageTicketPrice = "AverageTicketPrice",
}

export interface ReportConfigOverrideOfListingQuery {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    metrics: string[] | null;
    filter: ListingQuery | null;
}

export interface ReportConfigOfSaleQueryAndReportWidgetTypesNone {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    groupBy: ReportGroupBy;
    widgets: ReportWidgetTypesNone[] | null;
    metrics: string[];
    filter: SaleQuery | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    numberOfItemsPerPage: number | null;
    sortBy: string | null;
    isSortDescending: boolean | null;
    arAgingTimeBuckets: DateTimeRangeWithRelative[] | null;
    reportId: number | null;
    /** If specified, open this report instead when the user clicks on a report link. */
    reportIdRedirect: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    allowReaderEditMetrics: boolean;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    hasFilterOverride: boolean | null;
}

/** Widgets to show in reports. There are currently no available widgets, so this `None` serves as a placeholder and new widgets can be added in the future */
export enum ReportWidgetTypesNone {
    None = "None",
}

export interface ReportConfigOverrideOfSaleQuery {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    metrics: string[] | null;
    filter: SaleQuery | null;
}

export interface ListingReportMetricsResponse {
    metrics: ListingReportMetrics[];
    summary: ListingReportMetrics;
    totalCount: number;
    hasTimeout: boolean;
    hasUnknownError: boolean;
}

export interface ReportMetricsBase {
    /** Peformer id */
    perfId: number | null;
    venueId: number | null;
    /** This is viagogoEventId.toString() ?? viagogoEventMappingId.toString() */
    eventId: string | null;
    genre: TopLevelCategory | null;
    country: Country | null;
    city: string | null;
    section: string | null;
    row: string | null;
    /** Seating seat from */
    seatFr: string | null;
    /** Seating seat to */
    seatTo: string | null;
    /** Aggregated value of tags
Currently only support numerical value types (TagsValueType.Int, TagsValueType.Decimal) */
    tags: ReportTag[];
    /** Value of event tags
Currently only support numerical value types (TagsValueType.Int, TagsValueType.Decimal) */
    eventTags: ReportTag[];
    posEventIds: string[];
}

export interface ListingReportMetrics extends ReportMetricsBase {
    listId: number | null;
    tktQty: number;
    availQty: number;
    soldQty: number;
    currency: string;
    /** Total cost of all tickets */
    ttlCst: UiMoney;
    /** Total list price of all tickets */
    ttlListPrc: UiMoney;
    /** Total all-in price of all tickets */
    ttlWebPrc: UiMoney;
    soldCst: UiMoney;
    soldProcs: UiMoney;
    unsoldCst: UiMoney;
    pandL: UiMoney;
    /** Margin (SoldProceeds - SoldCost) / SoldProceeds */
    marg: number | null;
    delivType: DeliveryType | null;
    inHandDate: string | null;
    poInfos: PurchaseInfosReport;
    zone: string | null;
    pricerId: string | null;
    sales: SaleInfoReport[];
    holds: SaleInfoReport[];
    privNotes: string | null;
}

export interface PurchaseInfosReportBase {
    createdBys: string[];
    /** Purchase order ids */
    poIds: number[];
    /** Ticket group ids */
    tktGrIds: number[];
    buyers: PurchaseBuyerInfo[];
    vendors: PurchaseVendorInfo[];
    vendorAccs: PurchaseVendorAccountInfo[];
}

export interface PurchaseInfosReport extends PurchaseInfosReportBase {
    poDates: string[];
    pmtStatuses: PurchasePaymentStatus[];
    pmtMethods: PurchasePaymentMethodType[];
    privNotes: string[];
    vendOrdIds: string[];
    cancDates: string[];
}

export interface PurchaseBuyerInfo {
    buyerUserId: string;
    averageBuyerCommissionPercent: number | null;
}

export interface PurchaseVendorInfo {
    vendorId: number;
    vendorName: string;
}

export interface PurchaseVendorAccountInfo {
    vendorAccountId: string;
    vendorId: number;
    vendorAccountName: string;
    encryptedEmailAddress: string;
}

export interface SaleInfoReport {
    saleId: number;
    pmtState: PointOfSalePaymentState | null;
    mkpPmtState: MarketplacePaymentState | null;
    chargs: UiMoney | null;
    creds: UiMoney | null;
    fulfillerId: string | null;
    ttlNetProcs: UiMoney;
    qtySold: number;
    soldCst: UiMoney | null;
    status: PointOfSaleSaleStatus;
}

export interface ReportTag {
    key: string;
    value: string;
    valueType: TagsValueType | null;
}

export interface ListingReportMetricsRequest {
    query: ListingQuery;
    groupBy: ReportGroupBy;
    globalReportTypeId: number | null;
    isUsingFilterOverride: boolean | null;
    listingReportMetricsRequested: ListingReportMetricColumn[];
}

/** Enum to determine the metric to calculate/get report for */
export enum ListingReportMetricColumn {
    Zone = "Zone",
}

export interface SaleReportMetricsResponse {
    metrics: SaleReportMetrics[];
    summary: SaleReportMetrics;
    totalCount: number;
    hasTimeout: boolean;
    hasUnknownError: boolean;
}

export interface SaleReportMetrics extends ReportMetricsBase {
    saleDate: string | null;
    mkp: Marketplace | null;
    saleId: number | null;
    ticketId: number | null;
    tktGrId: number | null;
    mkpSaleId: string | null;
    /** Ar Aging Time Bucket
            
If group by is set to ArAging*, then this will be set
Only TtlOutsBal (TotalOutstandingBalance) among the metrics will be set */
    timeBkt: DateTimeRangeWithRelative | null;
    mkpPmtTerm: MarketplacePaymentTerm | null;
    qtySold: number;
    currency: string;
    netProcs: UiMoney;
    /** Total outstanding balance */
    ttlOutsBal: UiMoney;
    soldCst: UiMoney;
    /** Commision share */
    commssionShr: UiMoney | null;
    commission: BuyerCommission | null;
    pandL: UiMoney;
    /** Margin (TotalNetProceeds - SoldCost) / TotalNetProceeds */
    marg: number | null;
    chargs: UiMoney;
    creds: UiMoney;
    saleStatus: PointOfSaleSaleStatus | null;
    ticketType: TicketType | null;
    inHandDate: string | null;
    pmtState: PointOfSalePaymentState | null;
    mkpPmtState: MarketplacePaymentState | null;
    /** Payment received */
    pmtRcv: boolean | null;
    pmtRefId: string | null;
    lastPmtOn: string | null;
    cancelDate: string | null;
    allocState: PointOfSaleAllocationState | null;
    fulfillerId: string | null;
    fulfillDate: string | null;
    pricerId: string | null;
    poInfos: PurchaseInfosReport;
    privNotes: string | null;
}

export interface BuyerCommission {
    buyerUserId: string;
    commissionPercentage: number | null;
}

export enum PointOfSaleAllocationState {
    Pending = "Pending",
    Allocated = "Allocated",
    TicketsUnavailable = "TicketsUnavailable",
    AlternativeTicketsOffered = "AlternativeTicketsOffered",
    BlockingAllocation = "BlockingAllocation",
    AutoSourced = "AutoSourced",
}

export interface SaleReportMetricsRequest {
    query: SaleQuery;
    groupBy: ReportGroupBy;
    globalReportTypeId: number | null;
    isUsingFilterOverride: boolean | null;
    arAgingTimeBuckets: DateTimeRangeWithRelative[] | null;
}

export interface ReportSnapshotInfo {
    name: string;
    createdDate: string;
    documentId: string;
    downloadUri: string;
}

export interface SaleReportMetricsDownloadRequest extends SaleReportMetricsRequest {
    metrics: string[] | null;
    fileType: ReportFileType;
}

export enum ReportFileType {
    CSV = "CSV",
    XLSX = "XLSX",
    PDF = "PDF",
}

export interface ListingReportMetricsDownloadRequest extends ListingReportMetricsRequest {
    metrics: string[] | null;
    fileType: ReportFileType;
}

export interface ReportV2ConfigOfInventoryReportV2RequestAndReportWidgetTypesInventory {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesInventory[] | null;
    request: InventoryReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    /** Used to keep track of the original report from which this report was converted (v1) */
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2ListingQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2ListingQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
    metadata: ReportRequestMetadata | null;
    useRealtimeQuery: boolean | null;
}

export interface InventoryReportV2Request extends ReportBaseRequestOfUIReportV2ListingQuery {
}

export interface ReportColumn {
    /** Identifier of column, used for displaying in the UI and rendering the table, defined in the ListingReportTableGroupingColumnId / ListingReportTableValueColumnId enum */
    columnName: string;
    /** Expressions of columnId, format is ready for ReportingService to parse and transform into raw sql expressions */
    columnValue: string;
}

export interface ReportEntityWithTicketsQuery {
    performerIds: number[] | null;
    venueIds: number[] | null;
    countryCodes: string[] | null;
    stateProvinceIds: number[] | null;
    cityIds: number[] | null;
    purchaseOrderId: number | null;
    purchaseVendorId: number | null;
    vendorAccessControlProviderId: number | null;
    purchaseVendorAccountIds: string[] | null;
    purchaseVendorOrderId: string | null;
    purchaseBuyerId: string | null;
    purchaseOrderCreatedBy: string | null;
    purchaseCommissionUserId: string | null;
    purchaseDates: DateTimeRangeWithRelative | null;
    inHandDates: DateTimeRangeWithRelative | null;
    eventTimeFrameFilter: EventTimeFrameFilter | null;
    sections: string[] | null;
    rows: string[] | null;
    sectionContains: string | null;
    sectionEquals: string | null;
    sectionNotContains: string | null;
    rowContains: string | null;
    rowEquals: string | null;
    rowNotContains: string | null;
    isSeatSaver: boolean | null;
    eventDates: DateTimeRangeWithRelative | null;
    noSaleDates: DateTimeRangeWithRelative | null;
    tagName: string | null;
    tagValue: string | null;
    eventTagName: string | null;
    eventTagValue: string | null;
    lastSaleDates: DateTimeRangeWithRelative | null;
    eventNotReviewedSinceDate: DateTimeRangeWithRelative | null;
    eventUnpricedStatus: number | null;
    numberOfTicketsHeld: NumericRange | null;
    topLevelCategories: TopLevelCategory[] | null;
    parentCategories: number[] | null;
    internalNotes: string | null;
    internalNotesContains: string | null;
    internalNotesEquals: string | null;
    internalNotesNotContains: string | null;
    timezoneOffsetMins: number | null;
    currencyCode: string | null;
    currencyCodes: string[] | null;
    eventStatuses: ApiEventStatus[] | null;
    eventHasUnsoldTickets: boolean | null;
    purchaseCancellationDates: DateTimeRangeWithRelative | null;
    isParking: boolean | null;
    listingIdContains: string | null;
    saleIdContains: string | null;
    marketplaceSaleIdContains: string | null;
    purchaseOrderIdContains: string | null;
    vendorOrderIdContains: string | null;
}

export interface ReportV2ListingQuery extends ReportEntityWithTicketsQuery {
    isPredelivered: boolean | null;
    isNoFulfill: boolean | null;
    lastPriceUpdateDates: DateTimeRangeWithRelative | null;
    isPricedByMarketplace: boolean | null;
    isAutoPricingEnabled: boolean | null;
    isListed: boolean | null;
    isMapped: boolean | null;
    isDuplicate: boolean | null;
    isSeatingUnmapped: boolean | null;
    isAdminHold: boolean | null;
    pricerSellerUserId: string | null;
    purchaseCancelledOnly: boolean | null;
    hasUnsoldTickets: boolean | null;
    autoPricingResultTypes: AutoPricingResultType[] | null;
    isPricedAboveZero: boolean | null;
    hasBroadcastError: boolean | null;
    isPendingProof: boolean | null;
    deliveryType: DeliveryType | null;
    ticketType: TicketType | null;
    purchaseInsertBy: string | null;
}

export interface UIReportV2ListingQuery extends ReportV2ListingQuery {
    /** This is only used to filter on the frontend application. */
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportRequestMetadata {
    reportConfigId: number | null;
}

export interface ReportV2ConfigOfSalesReportV2RequestAndReportWidgetTypesNone {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: SalesReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    /** Used to keep track of the original report from which this report was converted (v1) */
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2SaleQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2SaleQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
    metadata: ReportRequestMetadata | null;
    useRealtimeQuery: boolean | null;
}

export interface SalesReportV2Request extends ReportBaseRequestOfUIReportV2SaleQuery {
}

export interface ReportV2SaleQuery extends ReportEntityWithTicketsQuery {
    isNoFulfill: boolean | null;
    saleDates: DateTimeRangeWithRelative | null;
    saleStatuses: PointOfSaleSaleStatus[] | null;
    soldOnMarketplace: Marketplace | null;
    cancellationDates: DateTimeRangeWithRelative | null;
    fulfillerSellerUserId: string | null;
    fulfillmentDates: DateTimeRangeWithRelative | null;
    paymentDates: DateTimeRangeWithRelative | null;
    marketplacePaymentState: MarketplacePaymentState | null;
    paymentReferenceId: string | null;
    listingInsertBy: string | null;
    dayOfWeek: number | null;
    quantityWasted: NumericRange | null;
    insertBy: string | null;
    listingNoteIds: number[] | null;
    originatedFromListingIdContains: string | null;
    seatContains: string | null;
    listingTagName: string | null;
    listingTagValue: string | null;
    purchaseOrderTagName: string | null;
    purchaseOrderTagValue: string | null;
    originatedFromListingTagName: string | null;
    originatedFromListingTagValue: string | null;
    ticketType: TicketType | null;
    pricerSellerUserId: string | null;
}

export interface UIReportV2SaleQuery extends ReportV2SaleQuery {
    /** This is only used to filter on the frontend application. */
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfPurchaseReportV2RequestAndReportWidgetTypesNone {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: PurchaseReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    /** Used to keep track of the original report from which this report was converted (v1) */
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2PurchaseQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2PurchaseQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
    metadata: ReportRequestMetadata | null;
    useRealtimeQuery: boolean | null;
}

export interface PurchaseReportV2Request extends ReportBaseRequestOfUIReportV2PurchaseQuery {
}

export interface ReportV2PurchaseQuery extends ReportEntityWithTicketsQuery {
    paymentMethod: PurchasePaymentMethodType | null;
    paymentStatus: PurchasePaymentStatus | null;
    purchaseOrderState: PurchaseOrderState | null;
}

export interface UIReportV2PurchaseQuery extends ReportV2PurchaseQuery {
    /** This is only used to filter on the frontend application. */
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfSaleLineItemReportV2RequestAndReportWidgetTypesNone {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: SaleLineItemReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    /** Used to keep track of the original report from which this report was converted (v1) */
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2SaleLineItemQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2SaleLineItemQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
    metadata: ReportRequestMetadata | null;
    useRealtimeQuery: boolean | null;
}

export interface SaleLineItemReportV2Request extends ReportBaseRequestOfUIReportV2SaleLineItemQuery {
}

export interface ReportV2SaleLineItemQuery extends ReportEntityWithTicketsQuery {
    isNoFulfill: boolean | null;
    saleDates: DateTimeRangeWithRelative | null;
    saleStatuses: PointOfSaleSaleStatus[] | null;
    soldOnMarketplace: Marketplace | null;
    cancellationDates: DateTimeRangeWithRelative | null;
    fulfillerSellerUserId: string | null;
    fulfillmentDates: DateTimeRangeWithRelative | null;
    paymentDates: DateTimeRangeWithRelative | null;
    marketplacePaymentState: MarketplacePaymentState | null;
}

export interface UIReportV2SaleLineItemQuery extends ReportV2SaleLineItemQuery {
    /** This is only used to filter on the frontend application. */
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfPurchaseOrderLineItemReportV2RequestAndReportWidgetTypesNone {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: PurchaseOrderLineItemReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    /** Used to keep track of the original report from which this report was converted (v1) */
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2PurchaseOrderLineItemQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2PurchaseOrderLineItemQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
    metadata: ReportRequestMetadata | null;
    useRealtimeQuery: boolean | null;
}

export interface PurchaseOrderLineItemReportV2Request extends ReportBaseRequestOfUIReportV2PurchaseOrderLineItemQuery {
}

export interface ReportV2PurchaseOrderLineItemQuery extends ReportEntityWithTicketsQuery {
    purchaseOrderCostTypeId: number | null;
    purchaseOrderState: PurchaseOrderState | null;
    purchasePaymentStatus: PurchasePaymentStatus | null;
}

export interface UIReportV2PurchaseOrderLineItemQuery extends ReportV2PurchaseOrderLineItemQuery {
    /** This is only used to filter on the frontend application. */
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfSoldTicketReportV2RequestAndReportWidgetTypesNone {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: SoldTicketReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    /** Used to keep track of the original report from which this report was converted (v1) */
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2SoldTicketQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2SoldTicketQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
    metadata: ReportRequestMetadata | null;
    useRealtimeQuery: boolean | null;
}

export interface SoldTicketReportV2Request extends ReportBaseRequestOfUIReportV2SoldTicketQuery {
}

export interface ReportV2SoldTicketQuery extends ReportEntityWithTicketsQuery {
    isNoFulfill: boolean | null;
    saleDates: DateTimeRangeWithRelative | null;
    saleStatuses: PointOfSaleSaleStatus[] | null;
    soldOnMarketplace: Marketplace | null;
    cancellationDates: DateTimeRangeWithRelative | null;
    fulfillerSellerUserId: string | null;
    fulfillmentDates: DateTimeRangeWithRelative | null;
    paymentDates: DateTimeRangeWithRelative | null;
    marketplacePaymentState: MarketplacePaymentState | null;
    dayOfWeek: number | null;
}

export interface UIReportV2SoldTicketQuery extends ReportV2SoldTicketQuery {
    /** This is only used to filter on the frontend application. */
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfCommissionReportV2RequestAndReportWidgetTypesNone {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: CommissionReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    /** Used to keep track of the original report from which this report was converted (v1) */
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportCommissionQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportCommissionQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
    metadata: ReportRequestMetadata | null;
    useRealtimeQuery: boolean | null;
}

export interface CommissionReportV2Request extends ReportBaseRequestOfUIReportCommissionQuery {
}

export interface ReportCommissionQuery {
    eventDates: DateTimeRangeWithRelative | null;
    eventTimeFrameFilter: EventTimeFrameFilter | null;
    saleDates: DateTimeRangeWithRelative | null;
    saleStatuses: PointOfSaleSaleStatus[] | null;
    soldOnMarketplace: Marketplace | null;
    paymentDates: DateTimeRangeWithRelative | null;
    fulfillmentDates: DateTimeRangeWithRelative | null;
    purchaseCommissionUserId: string | null;
    isCommissionEligible: boolean | null;
    commissionEligibilityDates: DateTimeRangeWithRelative | null;
    timezoneOffsetMins: number | null;
}

export interface UIReportCommissionQuery extends ReportCommissionQuery {
    /** This is only used to filter on the frontend application. */
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfCostOfGoodsSoldReportV2RequestAndReportWidgetTypesNone {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: CostOfGoodsSoldReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    /** Used to keep track of the original report from which this report was converted (v1) */
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2CostOfGoodsSoldQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2CostOfGoodsSoldQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
    metadata: ReportRequestMetadata | null;
    useRealtimeQuery: boolean | null;
}

export interface CostOfGoodsSoldReportV2Request extends ReportBaseRequestOfUIReportV2CostOfGoodsSoldQuery {
}

export interface ReportV2CostOfGoodsSoldQuery extends ReportEntityWithTicketsQuery {
    adjustmentsSinceDate: DateTimeRangeWithRelative | null;
    adjustmentType: string | null;
    isActive: boolean | null;
}

export interface UIReportV2CostOfGoodsSoldQuery extends ReportV2CostOfGoodsSoldQuery {
    /** This is only used to filter on the frontend application. */
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfSaleTotalCostAdjustmentReportV2RequestAndReportWidgetTypesNone {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: SaleTotalCostAdjustmentReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    /** Used to keep track of the original report from which this report was converted (v1) */
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2SaleTotalCostAdjustmentsQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2SaleTotalCostAdjustmentsQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
    metadata: ReportRequestMetadata | null;
    useRealtimeQuery: boolean | null;
}

export interface SaleTotalCostAdjustmentReportV2Request extends ReportBaseRequestOfUIReportV2SaleTotalCostAdjustmentsQuery {
}

export interface ReportV2SaleTotalCostAdjustmentsQuery extends ReportEntityWithTicketsQuery {
    adjustmentsSinceDate: DateTimeRangeWithRelative | null;
    adjustmentType: string | null;
}

export interface UIReportV2SaleTotalCostAdjustmentsQuery extends ReportV2SaleTotalCostAdjustmentsQuery {
    /** This is only used to filter on the frontend application. */
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfTicketGroupReportV2RequestAndReportWidgetTypesNone {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: TicketGroupReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    /** Used to keep track of the original report from which this report was converted (v1) */
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2TicketGroupQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2TicketGroupQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
    metadata: ReportRequestMetadata | null;
    useRealtimeQuery: boolean | null;
}

export interface TicketGroupReportV2Request extends ReportBaseRequestOfUIReportV2TicketGroupQuery {
}

export interface ReportV2TicketGroupQuery extends ReportEntityWithTicketsQuery {
    paymentMethod: PurchasePaymentMethodType | null;
    paymentStatus: PurchasePaymentStatus | null;
    purchaseOrderState: PurchaseOrderState | null;
    isMapped: boolean | null;
    isConsignment: boolean | null;
    deliveryType: DeliveryType | null;
    ticketStatuses: string[] | null;
}

export interface UIReportV2TicketGroupQuery extends ReportV2TicketGroupQuery {
    /** This is only used to filter on the frontend application. */
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOverride {
    schemaVersion: string;
    request: ReportOverrideRequest;
}

export interface ReportOverrideRequest {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
}

export interface ReportMetricsV2 {
    rows: { [key: string]: any; }[];
    valueTypes: { [key: string]: ReportValueType; };
}

export enum ReportValueType {
    None = "None",
    Guid = "Guid",
    Integer = "Integer",
    Money = "Money",
    DateTime = "DateTime",
    String = "String",
    User = "User",
    Decimal = "Decimal",
    Boolean = "Boolean",
    DateTimeList = "DateTimeList",
    IntegerList = "IntegerList",
    GuidList = "GuidList",
    UserList = "UserList",
    StringList = "StringList",
    BooleanList = "BooleanList",
}

export interface ReportMetricsSummaryV2 {
    row: { [key: string]: any; };
    valueTypes: { [key: string]: ReportValueType; };
}

export interface FileExportResult {
    fileName: string | null;
    fileUri: string | null;
    errorMessage: string | null;
    isSuccess: boolean;
}

export interface FileExportProgress {
    /** Percentage completed (0-100) */
    percentage: number;
}

export interface EntitiesWithSummaryOfSale {
    items: Sale[];
    summary: Sale | null;
}

/** Model for SearchV2 result */
export interface EntitySearchResultOfIDictionaryOfStringAndEntitiesWithSummaryOfSaleWithCatalogData {
    /** Actual entities returned from the search */
    entities: { [key: string]: EntitiesWithSummaryOfSaleWithCatalogData; };
    /** PIT ID for next page requests, null if not using PIT (Point-In-Time) pagination */
    pitId: string | null;
    /** Total number of matching documents that may have not been returned yet due to pagination */
    totalItemsCount: number | null;
    /** Maximum number of documents reachable via offset pagination (from + size).
Corresponds to the OpenSearch index.max_result_window setting (default 10,000).
The frontend should use this to cap pagination: maxPages = maxResultWindow / pageSize. */
    maxResultWindow: number | null;
    searchAfter: any[] | null;
    /** Ordered list of event group IDs (ViagogoVirtualIds) in the order returned by OpenSearch.
Solves a JavaScript serialization problem: Object.entries() reorders integer-like keys
numerically per ECMAScript spec, which would override the OpenSearch sort order.
Use this to iterate Entities in the correct group order.
Note: this is coarser than SortedItemIds — it gives the order of event groups, not
individual items within or across groups. */
    sortedGroupIds: string[] | null;
    /** Ordered list of individual item IDs (SaleId / ListingId) in the globally-sorted order
returned by OpenSearch. This is finer-grained than SortedGroupIds: because the response
groups items by event, a single event group may contain mixed-rank items (e.g., one event
with both Transfer and Paper tickets). Flattening event-by-event would put those mixed items
out of global sort order. Use SortedItemIds to re-sort the flat list and restore the correct
global order for flattened/search views. */
    sortedItemIds: number[] | null;
}

export interface EntitiesWithSummaryOfSaleWithCatalogData {
    items: SaleWithCatalogData[];
    summary: SaleWithCatalogData | null;
}

/** Extends the Sale model to include catalog data about the event, venue, and performer to power Opensearch-based search experience which doesn't depend on a separate catalog service call. */
export interface SaleWithCatalogData extends Sale {
    entityCatalogData: EntityCatalogData | null;
}

/** Extended version of SaleQuery with support for operations for each filter that is supported in search v2 with OpenSearch */
export interface SaleQueryV2 extends SaleQuery {
    soldOnMarketplaces: Marketplace[] | null;
    marketplacePaymentStates: MarketplacePaymentState[] | null;
    ticketTypes: TicketType[] | null;
    fulfillerSellerUserIds: string[] | null;
    listingInsertBys: string[] | null;
    operations: SaleQueryOperations | null;
    searchOptions: UISearchOptions | null;
}

export interface SaleQueryOperations extends EntityWithTicketsQueryOperations {
    soldOnMarketplaceOp: FilterOperationType | null;
    saleStatusesOp: FilterOperationType | null;
    fulfillmentStatesOp: FilterOperationType | null;
    paymentStateOp: FilterOperationType | null;
    marketplacePaymentStateOp: FilterOperationType | null;
    paymentReceivedOp: FilterOperationType | null;
    paymentReferenceIdOp: FilterOperationType | null;
    paymentDatesOp: FilterOperationType | null;
    fulfillmentDatesOp: FilterOperationType | null;
    cancellationDatesOp: FilterOperationType | null;
    saleDatesOp: FilterOperationType | null;
    ticketTypeOp: FilterOperationType | null;
    fulfillerSellerUserIdOp: FilterOperationType | null;
    listingInsertByOp: FilterOperationType | null;
    isNoFulfillOp: FilterOperationType | null;
    unitCostHighOp: FilterOperationType | null;
    unitCostLowOp: FilterOperationType | null;
}

export interface ValueTupleOfIEnumerableOfSaleAndUInt64 {
    item1: Sale[];
    item2: number;
}

export interface SaleDetails extends Sale {
    tickets: Ticket[];
    ticketGroupInfos: SaleTicketGroupInfo[];
    poInfos: UiPurchaseInfo[];
    isMarketplacePaymentLocked: boolean | null;
    /** Transfer Source */
    transSrc: TicketTransferInfo[] | null;
    /** Transfer Destination */
    transDest: TicketTransferInfo | null;
    transferUrls: string[] | null;
    transferProofDocs: UserDocumentLinks[] | null;
    transferProofId: string | null;
    /** AvailabileArtifactTypes */
    availArtTypes: ArtifactType[];
    lineItems: SaleLineItem[];
    mkpLines: MarketplaceSaleLineItem[];
    mkpLinesTotal: UiMoney;
    mkpSeating: Seating | null;
    mkpSaleTtlNetProcs: UiMoney | null;
    /** commissions got override at sale level */
    commissionOverride: Commission[] | null;
    /** the original commissions percentage set on the purchase order, which the allocated tickets are linked to */
    purchaseOrderCommissions: PurchaseOrderCommissions[] | null;
    mkpPmtTerm: MarketplacePaymentTerm | null;
}

export interface PurchaseOrderInfo {
    purchaseOrderId: number;
    purchaseOrderDate: string | null;
    ticketGroupId: number;
    buyerCommissionPercent: number | null;
    ticketCount: number;
    buyerUserId: string | null;
    vendor: PurchaseVendorInfo | null;
    vendorAccount: PurchaseVendorAccountInfo | null;
    createdBy: string | null;
    internalNotes: string | null;
}

export interface SaleTicketGroupInfo extends PurchaseOrderInfo {
    seating: Seating;
    vendorOrderId: string | null;
}

export interface TicketTransferInfo {
    name: string;
    email: string;
    app: string | null;
    appId: number;
    phoneNumber: string | null;
}

export interface MarketplaceSaleLineItem {
    /** MarketplacePaymentId */
    posPmtId: number;
    /** MarketplacePaymentLineId */
    id: number;
    /** ExternalPaymentId */
    extPmtId: string;
    /** ExternalPaymentLineId */
    extLineId: string;
    extSaleId: string;
    saleId: number | null;
    state: MarketplacePaymentState;
    date: string | null;
    recvDate: string | null;
    /** IsCredit */
    isCred: boolean;
    /** Amount */
    amt: UiMoney;
    type: MarketplacePaymentLineType;
    isLocked: boolean | null;
}

export interface PurchaseOrderCommissions {
    purchaseOrderId: number;
    orderId: string;
    commissions: Commission[];
}

export interface TicketTransferRequest {
    saleId: number;
    transferType: TransferTicketType;
    acceptanceUrls: string[] | null;
    uploadProofDocuments: UserDocument[] | null;
    transferProofId: string | null;
    barcodes: TicketBarcode[] | null;
}

export enum TransferTicketType {
    None = "None",
    ImageProof = "ImageProof",
    URL = "URL",
    IdProof = "IdProof",
    ApiTransferTicketmaster = "ApiTransferTicketmaster",
    ApiTransfer1Ticket = "ApiTransfer1Ticket",
}

export interface SaleAvailableSeatings {
    hasMoreAllocations: boolean;
    possibleSeatings: SeatingForAlloc[];
}

export interface SeatingForAlloc extends Seating {
    tktsForAlloc: TicketInfoForAllocation[];
    recAlloc: boolean | null;
    nonConsecSeats: boolean | null;
}

export interface TicketInfoForAllocation {
    id: number;
    row: string | null;
    seat: string;
    listingId: number | null;
    listingOrd: number | null;
    ticketOrd: number;
    purchasedBy: string | null;
    vendorId: number | null;
    vendorName: string | null;
    vendorAccId: string | null;
    vendorAccEmail: string | null;
    vendorAccName: string | null;
    isListingOnAdminHold: boolean | null;
}

export interface ValueTupleOfLongAndNullableBoolean {
    item1: number;
    item2: boolean | null;
}

/** A marketplace sale that originated from (and is managed by) the POS (Marketplace = Offline/Direct) Unlike other marketplace sales which are synced from that Marketplace (e.g. StubHub, Ticketmaster, VividSeat, etc.) */
export interface PosManagedMarketplaceSaleInput {
    listingId: number;
    saleId: number | null;
    marketplaceSaleId: PosFieldOfString | null;
    posEventId: string;
    viagogoEventId: number | null;
    eventMappingId: string | null;
    venueId: number | null;
    saleDate: PosFieldOfNullableDateTime | null;
    currencyCode: PosFieldOfString | null;
    totalNetProceeds: PosFieldOfNullableDecimal | null;
    inHandDate: PosFieldOfNullableDateTime | null;
    quantitySold: PosFieldOfNullableInteger | null;
    section: PosFieldOfString | null;
    row: PosFieldOfString | null;
    seatFrom: PosFieldOfString | null;
    seatTo: PosFieldOfString | null;
    ticketType: PosFieldOfNullableTicketType | null;
    buyerName: PosFieldOfString | null;
    buyerEmail: PosFieldOfString | null;
    buyerPhone: PosFieldOfString | null;
    listingNotes: PosFieldArrayOfListingNote | null;
    saleStatus: PosFieldOfNullablePointOfSaleSaleStatus | null;
    paymentState: PosFieldOfNullablePointOfSalePaymentState | null;
    fulfillerSellerUserId: PosFieldOfNullableGuid | null;
    internalNotes: PosFieldOfString | null;
}

export interface PosFieldOfNullablePointOfSaleSaleStatus {
    value: PointOfSaleSaleStatus | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullablePointOfSalePaymentState {
    value: PointOfSalePaymentState | null;
    hasChanged: boolean;
}

export interface MarketplaceSaleInput {
    listingId: number;
    saleId: number | null;
    marketplace: Marketplace;
    marketplaceSaleId: PosFieldOfString | null;
    posEventId: string;
    viagogoEventId: number | null;
    eventMappingId: string | null;
    venueId: number | null;
    saleDate: PosFieldOfNullableDateTime | null;
    currencyCode: PosFieldOfString | null;
    totalNetProceeds: PosFieldOfNullableDecimal | null;
    inHandDate: PosFieldOfNullableDateTime | null;
    quantitySold: PosFieldOfNullableInteger | null;
    section: PosFieldOfString | null;
    row: PosFieldOfString | null;
    seatFrom: PosFieldOfString | null;
    seatTo: PosFieldOfString | null;
    ticketType: PosFieldOfNullableTicketType | null;
    buyerName: PosFieldOfString | null;
    buyerEmail: PosFieldOfString | null;
    buyerPhone: PosFieldOfString | null;
    listingNotes: PosFieldArrayOfListingNote | null;
    saleStatus: PosFieldOfNullablePointOfSaleSaleStatus | null;
    paymentState: PosFieldOfNullablePointOfSalePaymentState | null;
    fulfillerSellerUserId: PosFieldOfNullableGuid | null;
    internalNotes: PosFieldOfString | null;
}

export interface BuyerInfo {
    email: string;
    name: string;
    phone: string;
}

export interface WasteListingTicketsInput {
    listingId: number;
}

export interface UnwasteSaleInput {
    saleId: number;
}

export interface AggregatedSaleMetric {
    dateTime: string;
    marketplaceId: number;
    totalQuantity: number;
    totalRevenue: number;
    totalPnL: number;
    totalNetProceeds: number;
    totalFees: number;
    maxSaleTimestamp: string;
}

export enum AggregateMetricsTimePeriod {
    UnspecifiedAggregatedSaleMetricsTimePeriod = "UnspecifiedAggregatedSaleMetricsTimePeriod",
    Today = "Today",
    LastWeek = "LastWeek",
    LastMonth = "LastMonth",
    LastThreeMonths = "LastThreeMonths",
    LastSixMonths = "LastSixMonths",
    Ytd = "Ytd",
    LastYear = "LastYear",
    LastFiveYears = "LastFiveYears",
    All = "All",
}

/** Response model for sale aggregations */
export interface SaleAggregationResponse {
    /** Aggregated summary in target currency */
    summary: SaleAggregationSummary;
    /** Optional breakdown by original currency */
    byOriginalCurrency: SaleCurrencyBreakdown[] | null;
    /** Metadata about the aggregation computation */
    metadata: AggregationResponseMetadata;
}

/** Aggregation summary for sale entities Based on calculations in SaleSummaryFactory */
export interface SaleAggregationSummary {
    /** Total number of tickets across all sales */
    totalTickets: number;
    /** Total quantity wasted across all sales */
    totalQuantityWasted: number;
    /** Total net proceeds across all sales */
    totalNetProceeds: UiMoney | null;
    /** Total cost of sold tickets */
    totalSoldTicketCost: UiMoney | null;
    /** Total profit and loss (net proceeds - sold ticket cost) */
    totalProfitAndLoss: UiMoney | null;
    /** Average margin percentage ((net proceeds - sold ticket cost) / net proceeds) */
    averageMargin: number | null;
    /** Total charges across all sales */
    totalCharges: UiMoney | null;
    /** Total credits across all sales */
    totalCredits: UiMoney | null;
    /** Total payment amount across all sales */
    totalPayment: UiMoney | null;
    /** Total converted payment amount (in various currencies converted to target) */
    totalConvertedPayment: UiMoney | null;
    /** Total payment amount received across all sales */
    totalPaymentAmountReceived: UiMoney | null;
    /** Currency of the aggregated amounts */
    currency: string;
    /** Number of sales included in aggregation */
    saleCount: number;
}

/** Currency breakdown for sale response */
export interface SaleCurrencyBreakdown {
    /** Currency code */
    currency: string;
    /** Number of documents in this currency */
    documentCount: number;
    /** Aggregated values in original currency */
    summary: SaleAggregationSummary;
}

/** Generic request model for multi-currency aggregations */
export interface MultiCurrencyAggregationRequestOfSaleSearchRequestV2AndSaleFilterQueryV2 {
    /** The OpenSearch request containing filter criteria and options */
    request: SaleSearchRequestV2;
    /** Target currency for final aggregation results */
    targetCurrency: string;
    /** Whether to include currency-by-currency breakdown in response */
    includeCurrencyBreakdown: boolean;
}

export interface OpenSearchRequestOfSaleFilterQueryV2 {
    filter: SaleFilterQueryV2;
    options: SearchOptions | null;
    allowedFields: string[] | null;
    appliedSecurityFilters: string[] | null;
    dataIsolationContext: { [key: string]: any; } | null;
}

export interface SaleSearchRequestV2 extends OpenSearchRequestOfSaleFilterQueryV2 {
}

export interface SaleFilterQueryV2 {
    eventIds: FieldFilter | null;
    eventDates: FieldFilter | null;
    eventTimeFrameFilters: FieldFilter | null;
    clientTimezoneOffsetMins: number | null;
    eventStatuses: FieldFilter | null;
    topLevelCategories: FieldFilter | null;
    parentCategories: FieldFilter | null;
    lastSaleDates: FieldFilter | null;
    numberOfAvailableTickets: FieldFilter | null;
    eventHasUnsoldTickets: FieldFilter | null;
    eventOrMappingIds: FieldFilter | null;
    oldPosEventIds: FieldFilter | null;
    performerIds: FieldFilter | null;
    venueIds: FieldFilter | null;
    countryCodes: FieldFilter | null;
    stateProvinceIds: FieldFilter | null;
    cityIds: FieldFilter | null;
    fulfillmentStates: FieldFilter | null;
    inHandDates: FieldFilter | null;
    ticketTypes: FieldFilter | null;
    fulfilledBySellerIds: FieldFilter | null;
    isPlaceholder: FieldFilter | null;
    fulfillmentDates: FieldFilter | null;
    isNoFulfill: FieldFilter | null;
    cancellationDates: FieldFilter | null;
    soldOnMarketplace: FieldFilter | null;
    saleDates: FieldFilter | null;
    listingInsertBy: FieldFilter | null;
    paymentStates: FieldFilter | null;
    marketplacePaymentStates: FieldFilter | null;
    paymentReferenceIds: FieldFilter | null;
    paymentDates: FieldFilter | null;
    isPaymentReceived: FieldFilter | null;
    currencyCodes: FieldFilter | null;
    sections: FieldFilter | null;
    rows: FieldFilter | null;
    internalNotes: FieldFilter | null;
    tagPairs: TagPairFilter | null;
    eventTagPairs: TagPairFilter | null;
    listingTagPairs: TagPairFilter | null;
    purchaseOrderTagPairs: TagPairFilter | null;
    purchaseOrdersFilter: PurchaseOrderNestedFilter | null;
    isSeatSaver: FieldFilter | null;
    saleStatuses: FieldFilter | null;
    marketplaceFulfillmentState: FieldFilter | null;
    marketplaceContractState: FieldFilter | null;
    saleIds: FieldFilter | null;
    listingIds: FieldFilter | null;
    prices: FieldFilter | null;
    unitCosts: FieldFilter | null;
    quantitySold: FieldFilter | null;
    quantityWasted: FieldFilter | null;
    and: SaleFilterQueryV2[] | null;
    or: SaleFilterQueryV2[] | null;
    orConditions: SaleFilterQueryV2[] | null;
    not: boolean | null;
    orFulfillerSellerUserId: string | null;
    orFulfillerSellerUserIds: string[] | null;
    orPricerSellerUserId: string | null;
    orPricerSellerUserIds: string[] | null;
    orPurchaseBuyerId: string | null;
    orPurchaseBuyerIds: string[] | null;
}

/** Result of a secure sales search with mapped Sale DTOs */
export interface SecureSalesSearchMappedResult {
    /** The mapped Sale DTOs ready for UI consumption */
    sales: SaleWithCatalogData[];
    /** Total number of matching documents */
    total: number;
    /** Time taken for the search in milliseconds */
    took: number;
    /** Maximum score of the results (for relevance ranking) */
    maxScore: number | null;
    /** Whether the search timed out */
    timedOut: boolean;
    /** Applied security filters for debugging */
    appliedSecurityFilters: string[] | null;
    /** Number of fields that were allowed for the user */
    allowedFieldCount: number;
    /** Parsed aggregation results */
    aggregations: { [key: string]: AggregationResult; } | null;
    /** PIT ID for next page requests, null if not using PIT (Point-In-Time) pagination */
    pitId: string | null;
    /** Search after values for next page cursor (null if no more pages) */
    searchAfter: any[] | null;
    /** Whether there are more pages available */
    hasNextPage: boolean;
}

export interface SearchResult {
    name: string | null;
    id: string | null;
    ownerUserId: string | null;
    count: number | null;
    entityIds: number[] | null;
    /** Note we call this fetch (instead of refresh) because this refers to the EntityIds that is obtained by running the query
Not the data for each of the entity which is obtained via another method */
    lastFetchDate: string | null;
}

export interface PurchaseSearchResult extends SearchResult {
    query: PurchaseOrderQuery | null;
    queryV2: PurchaseOrderQueryV2 | null;
}

export interface SaleSearchResult extends SearchResult {
    query: SaleQuery | null;
    queryV2: SaleQueryV2 | null;
}

export interface InventorySearchResult extends SearchResult {
    query: ListingQuery | null;
    queryV2: ListingQueryV2 | null;
}

export interface SellerUserAccountInfo {
    userId: string;
    consigneeSellerAccountId: string | null;
    displayName: string;
    email: string;
    isDeactivated: boolean;
    isTeam: boolean;
    roles: number[];
    userGroupIds: number[];
}

export interface SellerRoleInfo {
    id: number;
    consigneeSellerAccountId: string | null;
    prefinedRole: Role | null;
    name: string;
    details: string | null;
    isDeleted: boolean;
    permissions: Permission[];
}

export enum Role {
    Owner = "Owner",
    Buyer = "Buyer",
    FinanceAPI = "FinanceAPI",
    Fulfillment = "Fulfillment",
    Pricer = "Pricer",
    Processor = "Processor",
    AutoPO = "AutoPO",
    AutoFulfill = "AutoFulfill",
    AutoPricer = "AutoPricer",
    Reporter = "Reporter",
    Finance = "Finance",
}

export interface SellerPermissionInfo {
    name: string;
    permission: Permission;
    area: PermissionAccessArea;
    details: string;
}

export enum PermissionAccessArea {
    General = "General",
    Inventory = "Inventory",
    Sales = "Sales",
    Purchases = "Purchases",
    Events = "Events",
    Account = "Account",
    Reporting = "Reporting",
    Messages = "Messages",
    Accounting = "Accounting",
    AdPlatform = "AdPlatform",
}

export interface SellerUserInput {
    sellerUserId: string;
    consigneeSellerAccountId: string | null;
    displayName: string;
    roles: number[];
    userGroupIds: number[];
}

export interface SellerUser {
    sellerUserId: string;
    stubHubLoginId: string;
    sellerDisplayName: string;
    sellerUserName: string;
    email: string;
    deleteDate: string | null;
}

export interface SellerUserRolesInput {
    sellerUserId: string;
    consigneeSellerAccountId: string | null;
    roles: number[];
}

export interface SellerUserAccountInput {
    sellerUserId: string;
    consigneeSellerAccountId: string | null;
}

export interface SyncCenterSettings {
    defaultSplitType: SplitType | null;
    defaultSplitTypeForSeatSaver: SplitType | null;
    ticketTypeRules: TicketTypeRule[] | null;
    inHandDatePaddingInDays: number | null;
    defaultHideSeatNumbers: boolean | null;
    priceFloor: number | null;
    defaultMaxQuantityDisplay: number | null;
    marketplaceSettings: MarketplaceAccountSettingInput[] | null;
    adminHoldIndefinitelyForCancelledSales: boolean | null;
    inHandDaysBeforeEvent: number | null;
    isAutoPoQualityControlled: boolean | null;
    isAutoAddCancelledProceedsEnabled: boolean | null;
    isAutoLinkSaleLineItemEnabled: boolean | null;
    enableListingSplitOnDiscontinuousOrdinal: boolean | null;
    defaultManualMaxDisplayQuantity: number | null;
    showUnbroadcastListingsInComps: boolean | null;
    excludeParkingEventsFromEventSearch: boolean | null;
    includeOverPaymentForUnitCost: boolean | null;
}

export interface TicketTypeRule {
    deliveryType: DeliveryType;
    ticketTypePriorityOrders: TicketTypePriorityOrder[];
}

export interface TicketTypePriorityOrder {
    ticketType: TicketType;
    priorityOrder: number | null;
    /** Whether this ticket type shouldn't be used */
    blocked: boolean | null;
}

export interface MarketplaceAccountSettingInput {
    marketplace: Marketplace;
    isEnabled: boolean;
    markup: number | null;
    sellerFee: number | null;
    /** This field is currently only used for read and does not need to be sent in the update request. */
    userName: string | null;
    /** This field is currently only used for read and does not need to be sent in the update request. */
    tokenVersion: number | null;
    paymentTerm: MarketplacePaymentTerm;
    broadcastHoldDurationInDays: number | null;
    maxHoldDurationInHours: number | null;
}

export interface AccountAutoPricingSettingsInputs extends AutoPricingInputs {
    defaultCompListingQuantityFilters: CompListingQuantityFiltersCollection | null;
    compRowOffsetMode: CompRowOffsetMode | null;
    autoPricingPauseType: AutoPricingPauseType | null;
    compFailureActionType: AutoPricingCompFailureActionType | null;
}

export interface CompListingQuantityFiltersCollection {
    exactMatchQuantityFilters: CompListingQuantityFilters[] | null;
    greaterThanOrEqualToQuantityFilter: CompListingQuantityFilters | null;
}

export interface CompListingQuantityFilters {
    posListingQuantity: number;
    compQuantityFilters: CompListingQuantity;
}

export enum AutoPricingPauseType {
    PriceDecreases = "PriceDecreases",
    AllPriceUpdates = "AllPriceUpdates",
}

export enum AutoPricingCompFailureActionType {
    DontChangePrice = "DontChangePrice",
    SetPriceToCeiling = "SetPriceToCeiling",
}

export interface AutoCurrencyConversionSettings {
    enabled: boolean;
    defaultCurrencyCode: string | null;
    ignoredCurrencyCodes: string[] | null;
}

export interface TimezoneInfo {
    value: string;
    timezoneOffsetMins: number;
}

export interface SellerRoleInput {
    id: number;
    consigneeSellerAccountId: string | null;
    name: string | null;
    details: string | null;
    permissions: Permission[] | null;
    userIds: string[] | null;
}

export interface TradeDeskPasswordResetInput {
    username: string;
    oldPassword: string | null;
    newPassword: string;
    code: string;
}

export interface RevealMarketExternalPosSyncConfig {
    overrideRevealSyncDateRelativeStartSecs: number | null;
    overrideRevealSyncDateRelativeEndSecs: number | null;
    overrideRevealSyncDateStart: string | null;
    overrideRevealSyncDateEnd: string | null;
    overrideRevealSyncDateRoundingMode: RelativeTimeRoundingMode | null;

    [key: string]: any;
}

export interface RevealSyncConfigOverrideInput {
    syncDateOverride: DateTimeRangeWithRelative;
}

export interface ConfirmationDialogSettingsResponse {
    settings: { [key in keyof typeof ConfirmationDialogType]?: ConfirmationDialogSettingItem; };
    metadata: ConfirmationDialogMetadata[];
}

export enum ConfirmationDialogType {
    FloorCeilingViolation = "FloorCeilingViolation",
    SuspiciousPriceChange = "SuspiciousPriceChange",
    AutoPricingDisable = "AutoPricingDisable",
    AbsolutePriceDrop = "AbsolutePriceDrop",
    RelativePriceDrop = "RelativePriceDrop",
    RelativeFloorPriceDrop = "RelativeFloorPriceDrop",
    PriceStaggerFloorPriceDrop = "PriceStaggerFloorPriceDrop",
}

export interface ConfirmationDialogSettingItem {
    isActive: boolean;
    absoluteThreshold: number | null;
    relativeThreshold: number | null;
}

export interface ConfirmationDialogMetadata {
    dialogType: ConfirmationDialogType;
    thresholdType: ConfirmationDialogThresholdType;
}

export enum ConfirmationDialogThresholdType {
    None = "None",
    Absolute = "Absolute",
    Relative = "Relative",
    Both = "Both",
}

export interface ConfirmationDialogSettingRequest {
    settings: ConfirmationDialogSettingRequestItem[];
}

export interface ConfirmationDialogSettingRequestItem {
    confirmationDialogType: ConfirmationDialogType;
    isActive: boolean;
    absoluteThreshold: number | null;
    relativeThreshold: number | null;
}

export interface PurchaseOrderSettings {
    isAutoGeneratedVendorOrderIdEnabled: boolean | null;
    vendorOrderIdPrefix: string | null;
    excludeParkingEventsFromEventSearch: boolean | null;
}

export interface ListingGroupSettings {
    defaultExcludeFullySoldInGroup: boolean | null;
    defaultCollapseListingGroups: boolean | null;
}

export interface SellerAccountFulfillmentRuleDto {
    sellerAccountFulfillmentRuleId: number;
    fulfillerSellerUserId: string;
    fulfillmentRuleTargetType: FulfillmentRuleTargetType;
    viagogoEventId: number | null;
    eventMappingId: string | null;
    purchaseOrderVendorId: number | null;
    purchaseOrderId: number | null;
    viagogoVenueId: number | null;
}

export enum FulfillmentRuleTargetType {
    Event = "Event",
    Vendor = "Vendor",
    Venue = "Venue",
    PurchaseOrder = "PurchaseOrder",
}

export interface SellerAccountFulfillmentRulesInput {
    sellerAccountFulfillmentRulesId: number | null;
    fulfillerSellerUserId: string;
    fulfillmentRuleTargetTypeId: number;
    viagogoEventId: number | null;
    eventMappingId: string | null;
    purchaseOrderVendorId: number | null;
    purchaseOrderId: number | null;
    viagogoVenueId: number | null;
}

export interface SellerAccountFulfillmentRule {
    sellerAccountFulfillmentRuleId: number;
    fulfillerSellerUserId: string;
    fulfillmentRuleTargetType: FulfillmentRuleTargetType;
    viagogoEventId: number | null;
    eventMappingId: string | null;
    eventName: string | null;
    purchaseOrderVendorId: number | null;
    purchaseOrderId: number | null;
    viagogoVenueId: number | null;
    venueName: string | null;
}

export interface SellerSupportCaseNote {
    sellerSupportCaseNoteId: number;
    createByUserId: string | null;
    impersonatedUserId: string | null;
    createDate: string;
    workItemNoteId: number | null;
    noteContent: string | null;
    readDate: string | null;
    attachments: AttachmentResource[] | null;
}

export interface AttachmentResource {
    id: string;
    name: string;
    content_type: string;
    content: string | null;
}

export interface SellerSupportCase {
    createByUserId: string;
    impersonatedUserId: string | null;
    marketplace: Marketplace;
    sellerSupportCaseId: number;
    entityId: number | null;
    entityType: ActionOutboxEntityType | null;
    marketplaceEntityId: string | null;
    workItemId: number | null;
    readDate: string | null;
    createDate: string;
    lastNoteDate: string;
    unreadNoteCount: number;
}

export interface SellerSupportCaseQuery {
    isMostRecent: boolean | null;
    sellerSupportCaseIds: number[] | null;
}

export interface SellerSupportCaseRequest {
    marketplace: Marketplace;
    entityId: number | null;
    entityType: ActionOutboxEntityType | null;
    marketplaceEntityId: string | null;
    noteContent: string | null;
    attachments: string[] | null;
}

export interface FileDownloadInfo {
    contentType: string;
    contentDisposition: string;
    length: number;
    name: string;
    fileName: string;
    content: string | null;
}

export interface SellerSupportCaseAttachmentRequest {
    id: string;
    name: string;
    contentType: string;
}

export interface SellerUserSetting {
    userSetting: UserSetting;
    /** JSON string of setting */
    userSettingValue: string;
}

export enum UserSetting {
    QuickFiltersStateInventory = "QuickFiltersStateInventory",
    QuickFiltersCustomInventory = "QuickFiltersCustomInventory",
    QuickFiltersStateSales = "QuickFiltersStateSales",
    QuickFiltersCustomSales = "QuickFiltersCustomSales",
    QuickFiltersStatePurchases = "QuickFiltersStatePurchases",
    QuickFiltersCustomPurchases = "QuickFiltersCustomPurchases",
    SalesViewSelected = "SalesViewSelected",
    SuspiciousPriceChange = "SuspiciousPriceChange",
    InternationalCompliance = "InternationalCompliance",
    InventoryPageViewMode = "InventoryPageViewMode",
    InventoryColumnOrder = "InventoryColumnOrder",
    InventoryColumnNumberPrecision = "InventoryColumnNumberPrecision",
    InventoryColumnWidths = "InventoryColumnWidths",
    InventoryCustomColumns = "InventoryCustomColumns",
    InventoryColumnEditability = "InventoryColumnEditability",
    SaleColumnOrder = "SaleColumnOrder",
    SaleCustomColumns = "SaleCustomColumns",
    SaleColumnEditability = "SaleColumnEditability",
    SaleColumnNumberPrecision = "SaleColumnNumberPrecision",
    ReportConfigInventory = "ReportConfigInventory",
    ReportConfigSale = "ReportConfigSale",
    EventsColumnOrder = "EventsColumnOrder",
    EventsCustomColumns = "EventsCustomColumns",
    EventsColumnEditability = "EventsColumnEditability",
    EventsColumnNumberPrecision = "EventsColumnNumberPrecision",
    SiteTheme = "SiteTheme",
    ReportingColumnLimit = "ReportingColumnLimit",
    PriceFloorCeilingMode = "PriceFloorCeilingMode",
    ReleaseNoteIdsRead = "ReleaseNoteIdsRead",
    EventsColumnsEnabled = "EventsColumnsEnabled",
    InventoryColumnsEnabled = "InventoryColumnsEnabled",
    SaleColumnsEnabled = "SaleColumnsEnabled",
    SiteZoom = "SiteZoom",
    InventoryDefaultTab = "InventoryDefaultTab",
    PurchaseColumnOrder = "PurchaseColumnOrder",
    PurchaseCustomColumns = "PurchaseCustomColumns",
    PurchaseColumnEditability = "PurchaseColumnEditability",
    PurchaseColumnNumberPrecision = "PurchaseColumnNumberPrecision",
    PurchaseColumnsEnabled = "PurchaseColumnsEnabled",
    InventoryFlattenedColumnOrder = "InventoryFlattenedColumnOrder",
    InventoryFlattenedColumnsEnabled = "InventoryFlattenedColumnsEnabled",
    InventoryFlattenedColumnEditability = "InventoryFlattenedColumnEditability",
    InventoryFlattenedColumnNumberPrecision = "InventoryFlattenedColumnNumberPrecision",
    SaleFlattenedColumnOrder = "SaleFlattenedColumnOrder",
    SaleFlattenedColumnsEnabled = "SaleFlattenedColumnsEnabled",
    SaleFlattenedColumnEditability = "SaleFlattenedColumnEditability",
    SaleFlattenedColumnNumberPrecision = "SaleFlattenedColumnNumberPrecision",
    SaleColumnWidths = "SaleColumnWidths",
    PurchaseColumnWidths = "PurchaseColumnWidths",
    InventoryV2DefaultTab = "InventoryV2DefaultTab",
    SalePageViewMode = "SalePageViewMode",
    PurchasePageViewMode = "PurchasePageViewMode",
    InventoryReportColumnWidths = "InventoryReportColumnWidths",
    SaleReportColumnWidths = "SaleReportColumnWidths",
    EventsColumnWidths = "EventsColumnWidths",
    PurchaseEventColumnOrder = "PurchaseEventColumnOrder",
    PurchaseEventColumnsEnabled = "PurchaseEventColumnsEnabled",
    PurchaseEventColumnEditability = "PurchaseEventColumnEditability",
    PurchaseEventColumnNumberPrecision = "PurchaseEventColumnNumberPrecision",
    PurchaseEventColumnWidths = "PurchaseEventColumnWidths",
    SidePanelWidths = "SidePanelWidths",
    SalesDefaultTab = "SalesDefaultTab",
    PurchasesDefaultTab = "PurchasesDefaultTab",
    SalesSideTableColumnOrder = "SalesSideTableColumnOrder",
    SalesSideTableColumnsEnabled = "SalesSideTableColumnsEnabled",
    SalesSideTableColumnEditability = "SalesSideTableColumnEditability",
    SalesSideTableColumnNumberPrecision = "SalesSideTableColumnNumberPrecision",
    PurchaseSideTableColumnOrder = "PurchaseSideTableColumnOrder",
    PurchaseSideTableColumnsEnabled = "PurchaseSideTableColumnsEnabled",
    PurchaseSideTableColumnEditability = "PurchaseSideTableColumnEditability",
    PurchaseSideTableColumnNumberPrecision = "PurchaseSideTableColumnNumberPrecision",
    InventorySideTableColumnOrder = "InventorySideTableColumnOrder",
    InventorySideTableColumnsEnabled = "InventorySideTableColumnsEnabled",
    InventorySideTableColumnEditability = "InventorySideTableColumnEditability",
    InventorySideTableColumnNumberPrecision = "InventorySideTableColumnNumberPrecision",
    MarketplacePaymentsTableColumnOrder = "MarketplacePaymentsTableColumnOrder",
    MarketplacePaymentsCustomColumns = "MarketplacePaymentsCustomColumns",
    MarketplacePaymentsTableColumnsEnabled = "MarketplacePaymentsTableColumnsEnabled",
    MarketplacePaymentsColumnNumberPrecision = "MarketplacePaymentsColumnNumberPrecision",
    MarketplacePaymentsColumnEditability = "MarketplacePaymentsColumnEditability",
    MarketplacePaymentsColumnsWidth = "MarketplacePaymentsColumnsWidth",
    QuickFloorPromptDismissal = "QuickFloorPromptDismissal",
    QuickFiltersCustomMarketplacePayments = "QuickFiltersCustomMarketplacePayments",
    QuickFiltersStateMarketplacePayments = "QuickFiltersStateMarketplacePayments",
    QuickFiltersStateOnSaleEvent = "QuickFiltersStateOnSaleEvent",
    QuickFiltersCustomOnSaleEvent = "QuickFiltersCustomOnSaleEvent",
    OnSaleEventColumnsOrder = "OnSaleEventColumnsOrder",
    OnSaleEventColumnsWidths = "OnSaleEventColumnsWidths",
    OnSaleEventColumnNumberPrecision = "OnSaleEventColumnNumberPrecision",
    OnSaleEventCustomColumns = "OnSaleEventCustomColumns",
    OnSaleEventColumnEditability = "OnSaleEventColumnEditability",
    OnSaleEventColumnsEnabled = "OnSaleEventColumnsEnabled",
    FirstTimeFeaturesViewed = "FirstTimeFeaturesViewed",
    InventoryMenuTabFavorite = "InventoryMenuTabFavorite",
    SaleMenuTabFavorite = "SaleMenuTabFavorite",
    PurchaseMenuTabFavorite = "PurchaseMenuTabFavorite",
    RecentSalesTableColumnsWidths = "RecentSalesTableColumnsWidths",
    RecentSalesTableColumnsOrder = "RecentSalesTableColumnsOrder",
    RecentSalesTableColumnsEnabled = "RecentSalesTableColumnsEnabled",
    RecentSalesTableColumnNumberPrecision = "RecentSalesTableColumnNumberPrecision",
    RecentSalesTableColumnEditability = "RecentSalesTableColumnEditability",
    ReportCustomColumnInventory = "ReportCustomColumnInventory",
    ReportCustomColumnSales = "ReportCustomColumnSales",
    ReportCustomColumnSaleLineItem = "ReportCustomColumnSaleLineItem",
    ReportCustomColumnSoldTicket = "ReportCustomColumnSoldTicket",
    ReportCustomColumnPurchase = "ReportCustomColumnPurchase",
    ReportCustomColumnCommission = "ReportCustomColumnCommission",
    ReportV2InventoryColumnWidths = "ReportV2InventoryColumnWidths",
    ReportV2SaleColumnWidths = "ReportV2SaleColumnWidths",
    ReportV2CommissionColumnWidths = "ReportV2CommissionColumnWidths",
    ReportV2PurchaseColumnWidths = "ReportV2PurchaseColumnWidths",
    ReportV2SaleLineItemColumnWidths = "ReportV2SaleLineItemColumnWidths",
    ReportV2SoldTicketColumnWidths = "ReportV2SoldTicketColumnWidths",
    ReportV2PurchaseOrderLineItemColumnWidths = "ReportV2PurchaseOrderLineItemColumnWidths",
    ReportV2ColumnNumberPrecision = "ReportV2ColumnNumberPrecision",
    ReportCustomColumnCostOfGoodsSold = "ReportCustomColumnCostOfGoodsSold",
    ReportCostOfGoodsSoldColumnWidths = "ReportCostOfGoodsSoldColumnWidths",
    ReportCustomColumnSaleCostAdjustments = "ReportCustomColumnSaleCostAdjustments",
    ReportSaleCostAdjustmentsColumnWidths = "ReportSaleCostAdjustmentsColumnWidths",
    EnableSelectionByDefault = "EnableSelectionByDefault",
    GroupInventoryEventView = "GroupInventoryEventView",
    FavoriteVendorIds = "FavoriteVendorIds",
    EnableNotifications = "EnableNotifications",
    ReportCustomColumnTicketGroup = "ReportCustomColumnTicketGroup",
    ReportTicketGroupColumnWidths = "ReportTicketGroupColumnWidths",
    InventoryPortfolioColumnSort = "InventoryPortfolioColumnSort",
    InventoryEventColumnSort = "InventoryEventColumnSort",
    PurchasePortfolioColumnSort = "PurchasePortfolioColumnSort",
    PurchaseEventColumnSort = "PurchaseEventColumnSort",
    SalePortfolioColumnSort = "SalePortfolioColumnSort",
    SaleEventColumnSort = "SaleEventColumnSort",
    InventorySearchColumnSort = "InventorySearchColumnSort",
    PurchaseSearchColumnSort = "PurchaseSearchColumnSort",
    SaleSearchColumnSort = "SaleSearchColumnSort",
    HasCreatedAdCampaign = "HasCreatedAdCampaign",
}

export interface CustomQuickFilterOfListingQuery {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    id: string;
    name: string;
    data: ListingQuery;
}

export interface CustomQuickFilterOfOnSaleEventQuery {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    id: string;
    name: string;
    data: OnSaleEventQuery;
}

export interface CustomQuickFilterOfSaleQuery {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    id: string;
    name: string;
    data: SaleQuery;
}

export interface CustomQuickFilterOfPurchaseOrderQuery {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    id: string;
    name: string;
    data: PurchaseOrderQuery;
}

export interface CustomQuickFilterOfMarketplacePaymentQuery {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    id: string;
    name: string;
    data: MarketplacePaymentQuery;
}

export interface ReleaseNote {
    id: number;
    title: string;
    releaseNoteType: ReleaseNoteType;
    descriptionHtml: string | null;
    /** Date when user gets access to this release note. For "NewFeature" type,
this is `FeatureInsertDate` from ReleaseNoteDto, date when user is granted access.
Otherwise (e.g. BugFix), it is the date the release note itself is created */
    releaseNoteGetAccessDate: string;
}

export enum ReleaseNoteType {
    NewFeature = "NewFeature",
    BugFix = "BugFix",
}

export interface TutorialItem {
    tutorialItemId: number;
    title: string;
    titleContentId: number | null;
    parentTutorialItemId: number | null;
    tutorialItemType: TutorialItemType;
}

export enum TutorialItemType {
    Folder = "Folder",
    Document = "Document",
}

export interface TutorialItemContent {
    tutorialItemId: number;
    tutorialItemContentId: number | null;
    contentHtml: string;
}

export interface SellerEventConfirmationDialogSuppression {
    eventVirtualId: string;
    confirmationDialogType: ConfirmationDialogType;
    startDate: string;
    endDate: string;
}

export interface PosActionResult {
    succeeded: boolean;
    errorStatusCode: number | null;
    errorMessage: string | null;
}

export interface InsertSellerEventConfirmationDialogSuppressionRequest {
    viagogoVirtualId: string;
    confirmationDialogType: ConfirmationDialogType;
    durationHours: number;
}

export interface TeamInfo {
    teamSellerUserId: string;
    teamName: string;
    isDeactivated: boolean;
    sellerUserIds: string[];
}

export interface TeamMemberDto {
    sellerUserId: string;
    displayName: string;
    email: string;
    teamName: string;
}

export interface TeamInput {
    teamName: string;
    memberSellerUserIds: string[] | null;
}

export interface TeamUpdateInput {
    teamSellerUserId: string;
    teamName: string;
    memberSellerUserIds: string[] | null;
}

export interface TeamAccountInput {
    teamSellerUserId: string;
}

export interface DeliveryTypeTicketTypeMapping {
    deliveryType: DeliveryType;
    ticketTypes: { [key in keyof typeof TicketType]?: number[]; };
}

export interface TicketGroupMergeInput {
    intentions: TicketGroupIntention[];
    purchaseOrderId: number;
    ticketGroups: TicketGroupInput[];
    updateSalesOfListings: boolean | null;
    deallocateSales: boolean | null;
    updatePredeliveryETicketArtifacts: boolean | null;
}

export interface TicketGroupIntention {
    ticketGroupId: number;
    reason: TicketGroupEditReason;
    additionalInfo: string;
}

export enum TicketGroupEditReason {
    AmendTickets = "Amend Tickets",
    CancelTickets = "Cancel Tickets",
    AddTickets = "Add Tickets",
    ExchangeTickets = "Exchange Tickets",
    EditEvent = "Edit Event",
}

export interface UserGroup {
    userGroupId: number;
    userGroupName: string;
    userGroupDescription: string | null;
    sellerUserIds: string[];
    consigneeSellerAccountId: string | null;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}



